import axios from "axios";
import moment from "moment";
import jwt from "jsonwebtoken";
import { createBrowserHistory } from "history";
import getParameterByName from "../../Functions/functions";
const roleName = getParameterByName("roleName");
const history = createBrowserHistory();
const token = localStorage.getItem("user_token");
const user = jwt.decode(token);

const getAllUsers = (setUsers, setLoading) => {
  setLoading(true);

  var axios = require("axios");

  var config = {
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/api/Authenticate/getUsers`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
    },
  };

  axios(config)
    .then(function (response) {
      setUsers(response.data);
      setLoading(false);
    })
    .catch(function (error) {});
};

const getUsersByRole = async (
  user,
  setUserData,
  setLoading,
  setFilterLoginUser,
  filterloginUser,
  loginid
) => {
  let ApiUrl;
  if (user === "Reviewer") {
    ApiUrl = `${process.env.REACT_APP_API_URL}/api/Role/GetUserListJobtitle_v2/JobTitle/${user}`;
  } else {
    ApiUrl = `${process.env.REACT_APP_API_URL}/api/Role/GetUserList_v2/${user}`;
  }
  await axios({
    method: "post", //you can set what request you want to be
    // url: `${process.env.REACT_APP_API_URL}/api/Role/GetUserList_v2/${user}`,
    url: ApiUrl,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    // data: formState,
  })
    .then(async (res) => {
      const newItems = [];
      for (let index = 0; index < res.data.length; index++) {
        const item = res.data[index];
        if (!item?.userName.includes("undefined")) {
          newItems.push(item);
        }
      }
      setUserData(newItems);
      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);

      // setErrorMessage("Invalid username or password");
    });
};


const getUsersByIRIPRole = async (
  user,
  setUserData,
  setLoading,
  setFilterLoginUser,
  filterloginUser,
  loginid
) => {
  let ApiUrl;
  if (user === "Reviewer") {
    ApiUrl = `${process.env.REACT_APP_API_URL}/api/Role/GetUserListJobtitle_v2/JobTitle/${user}`;
  } else {
    ApiUrl = `${process.env.REACT_APP_API_URL}/api/Role/GetUserList_v3/${user}`;
  }
  await axios({
    method: "post", //you can set what request you want to be
    // url: `${process.env.REACT_APP_API_URL}/api/Role/GetUserList_v2/${user}`,
    url: ApiUrl,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    // data: formState,
  })
    .then(async (res) => {
      const newItems = [];
      for (let index = 0; index < res.data.length; index++) {
        const item = res.data[index];
        if (!item?.userName.includes("undefined")) {
          newItems.push(item);
        }
      }
      setUserData(newItems);
      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);

      // setErrorMessage("Invalid username or password");
    });
};


const getAllUsersByRole = async (
  user,
  setUserData,
  setLoading,
  setFilterLoginUser,
  filterloginUser,
  loginid
) => {
  await axios({
    method: "post", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Role/GetUserList_v1/${user}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    // data: formState,
  })
    .then(async (res) => {
      setUserData(res.data);
      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);

      // setErrorMessage("Invalid username or password");
    });
};
const getAllNotifications = (setNotification, setLoading) => {
  // setLoading(true);

  var axios = require("axios");

  var config = {
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/api/Notifications/GetNotifications`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
    },
  };

  axios(config)
    .then(function (response) {
      setNotification(response.data);
      // setLoading(false);
    })
    .catch(function (error) {});
};

const getVendorDetail = async (user, setUserData, setLoading) => {
  setLoading(true);
  //
  await axios({
    method: "get", //you can set what request you want to be
    url: `${
      process.env.REACT_APP_API_URL
    }/api/InvoiceDetails/getVendorDetails/${user ? user : null}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      setUserData(res.data);
      setLoading(false);
    })
    .catch((err) => {
    //   const data =


    //   [
    //     {
    //         Bank_Key: "1APR-HBL001",
    //         Vendor_Code: "0001005482",
    //         Vendor_Name: "Ecolean Pakistan (Pvt) Ltd",
    //         CO_POST_BLOCK: "",
    //         ALL_COMPANY_CODE: "",
    //         Payment_Terms: "V004"
    //     }
    // ]

    // setUserData(data);
      setLoading(false);

      // setErrorMessage("Invalid username or password");
    });
};
const getVendorDetailForVendorBlock = async (
  user,
  setUserData,
  setLoading,
  setvendorblock,
  alertMessage,
  setErrAlertMessage
) => {
  setLoading(true);
  //
  await axios({
    method: "get", //you can set what request you want to be
    url: `${
      process.env.REACT_APP_API_URL
    }/api/InvoiceDetails/getVendorDetails/${user ? user : null}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      setUserData(res.data);
      setLoading(false);
      if (!alertMessage && res.data[0]?.CO_POST_BLOCK === "X") {
        setvendorblock(true);
        setErrAlertMessage("This Gl Account has been Blocked");
      }
    })
    .catch((err) => {
      setLoading(false);

      // setErrorMessage("Invalid username or password");
    });
};
const getVendorDetailForTable = async (user, setUserData, setLoading) => {
  setLoading(true);
  //
  await axios({
    method: "get", //you can set what request you want to be
    url: `${
      process.env.REACT_APP_API_URL
    }/api/InvoiceDetails/getVendorDetails/${user ? user : null}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      if (typeof setUserData === "function") {
        const updatedChoices = res.data?.map((vendor) => ({
          data: vendor,
          value: `${vendor.Vendor_Code}`,
          label: `${vendor.Vendor_Code} - ${vendor.Vendor_Name}`,
        }));
        setUserData(updatedChoices);
      } else {
        const finded = res.data?.find((x) => x.Vendor_Code === user);
        setUserData.VendorData = finded;
      }
      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);

      // setErrorMessage("Invalid username or password");
    });
};
const getHorizonID_Data = async (setHorizonLoading, setHorizonIDList) => {
  setHorizonLoading(true);
  await axios({
    method: "get", //you can set what request you want to be
    url: `${
      process.env.REACT_APP_API_URL
    }/api/Invoices/GetEmployeeList_v1/${null}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      setHorizonIDList(res.data);
      setHorizonLoading(false);
    })
    .catch((err) => {
      setHorizonLoading(false);

      // setErrorMessage("Invalid username or password");
    });
};

const getCostCenterData = async (
  costCenter,
  setLoading,
  setCostCenterList,
  setCostLoading
) => {
  setLoading(true);
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetCostCenters_v1/${
      costCenter ? costCenter : "-1"
    }`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      setCostCenterList(res.data);
      setCostLoading(res.data);
      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);

      // setErrorMessage("Invalid username or password");
    });
};
const getCostCenterData_v2 = async (
  costCenter,
  setLoading,
  setCostCenterList
) => {
  setLoading(true);
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetCostCenters_v1/${
      costCenter ? costCenter : "-1"
    }`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      const updatedChoices = res.data?.map((account) => ({
        data: account,
        value: `${account.CostCenterCode}`,
        label: `${account.CostCenterCode} - ${account.Name}`,
      }));
      if (typeof setCostCenterList === "function") {
        setCostCenterList(updatedChoices);
      } else {
        const finded = res.data?.find((x) => x.CostCenterCode === costCenter);
        setCostCenterList.costCenterData = finded;
      }
      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);
      // setErrorMessage("Invalid username or password");
    });
};
const getCostCenterDataForExcel = async (
  costCenter,
  setLoading,
  setCostCenterList,
  setCostLoading
) => {
  const CostCenterData = localStorage.getItem("getCostCenterCode");
  if (!CostCenterData) {
    setLoading(true);

    await axios({
      method: "get", //you can set what request you want to be
      url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetCostCenters_v1/${
        costCenter ? costCenter : "-1"
      }`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        setCostCenterList(res.data);
        setCostLoading(res.data);
        localStorage.setItem("getCostCenterCode", JSON.stringify(res.data));
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);

        // setErrorMessage("Invalid username or password");
      });
  } else {
    const data = JSON.parse(CostCenterData);
    setCostCenterList(data);
    setCostLoading(data);
  }
};
const getEmployeeByCostCenter = async (
  // setCostCenterEmployeeLoading,
  // costCenterCode,
  // tempArray,
  // formState,
  // index
  costCenter,
  setCostCenterEmployeeLoading,
  setCostCenterList
) => {
  let costCenterEmployeeList = [];
  setCostCenterEmployeeLoading(true);
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetEmployeeByCostCenter_v1/${costCenter}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      // const finded = res.data?.find((x) => x.costCenter === costCenter);
      // const finded = res.data?.find((x) => x.costCenter === costCenter);
      setCostCenterList.costCenterData = res.data;
      // tempArray[index] = {
      //   ...formState.invoice_Accounts_list[index],
      //   c: res.data.employeeCode ? res.data.employeeCode : "Not Found",
      //   costCenterOwnerName: res.data.employeeName
      //     ? res.data.employeeName
      //     : "Not Found",
      // };

      setCostCenterEmployeeLoading(false);
    })
    .catch((err) => {
      setCostCenterEmployeeLoading(false);

      // setErrorMessage("Invalid username or password");
    });
};
const getEmployeeByCostCenter_IP = async (
  setCostCenterEmployeeLoading,
  costCenterCode,
  tempArray,
  formState,
  index
  // setCCowner
) => {
  let costCenterEmployeeList = [];
  setCostCenterEmployeeLoading(true);

  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetEmployeeByCostCenter_v1/${costCenterCode}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      tempArray[index] = {
        ...formState.invoice_Accounts[index],
        costCenterOwner: res.data.employeeCode
          ? res.data.employeeCode
          : "Not Found",
        costCenterOwnerName: res.data.employeeName
          ? res.data.employeeNamesetCCowner
          : "Not Found",
      };
      tempArray = {
        ...formState.invoice_Accounts[index],
        costCenterOwner: res.data.employeeCode
          ? res.data.employeeCode
          : "Not Found",
        costCenterOwnerName: res.data.employeeName
          ? res.data.employeeName
          : "Not Found",
      };
      // setCCowner(res.data.employeeCode ? `${res.data.employeeCode}` + `-` + `${res.data.employeeName }` : "Not Found")
      setCostCenterEmployeeLoading(false);
    })
    .catch((err) => {
      setCostCenterEmployeeLoading(false);

      // setErrorMessage("Invalid username or password");
    });
};

const uploadFile_v1 = async (
  e,
  setFormState,
  setInvoiceloader,
  name,
  setAttchmentFile_UI,
  invoice_attachmentRef,
  setAttachmentURLList,
  setAttachmentURL,
  attachmentURLList,
  invoice_attachment,
  setDocError,
  setAttachError,
  setAlertMessage,
  invoicePayload,
  selectedRole,
  dragfile,
  setDragFile,
  setSuccessMessage
) => {
  const data = {
    Invoice_Id:
      invoicePayload?.Invoice_id && selectedRole.roleName
        ? invoicePayload?.Invoice_id
        : 0,
    RoleName: selectedRole.roleName,
    isAdditional: false,
  };
  setInvoiceloader(true);
  setDocError("");

  setAttachError("");
  const file = dragfile ? e.dataTransfer.files[0] : e.target.files[0];

  // const MAX_FILE_SIZE = 204800; // 1MB equal 1024 kilo bytes so 200MB equal to  204,800 kilo bytes
  // const fileSizeKiloBytes = file.size / 1024;

  // if (fileSizeKiloBytes > MAX_FILE_SIZE) {
  // setAttachError("File size should be less then or equal to 20MBs")
  //   setAttachError("File size should be less then or equal to 200MBs");
  //   invoice_attachmentRef.current.value = null;
  // }

  if (!file?.name.match(/\.(jpg|jpeg|png|pdf|JPG|JPEG|PNG|PDF)$/)) {
    setAlertMessage(true);
    setDocError("Please upload only png, .jpg, .jpeg, .pdf Format");
    invoice_attachmentRef.current.value = null;
  } else if (file?.name.match(/[`!#%^&*+\=\[\]{};':"\\|,<>\/?~]/)) {
    setAlertMessage(true);
    setAttachError("File name should not have any special characters");
    invoice_attachmentRef.current.value = null;
  } else {
    setAttchmentFile_UI((attachmentFiles) => [...attachmentFiles, file]);
    let formData = new FormData();
    formData.append("", file);
    await axios({
      method: "post", //you can set what request you want to be
      url: `${process.env.REACT_APP_API_URL}/api/UploadFile/UploadFiles_v1`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "multipart/form-data",
      },
      data: formData,
      params: data,
    })
      .then(async (res) => {
        if (res.status === 200) {
          setDragFile(false);
          const obj = {
            path: res.data.path,
            sr: res.data.sr,
            id: res.data.sr,
            role_Name: selectedRole.roleName,
          };
          invoice_attachmentRef.current.value = null;
          let filtered = attachmentURLList || [];

          if (invoice_attachment) {
            // remove prev invoice_attachment.
            if (invoice_attachment) {
              filtered = attachmentURLList.filter(function (item) {
                return ![invoice_attachment?.path].includes(item.path);
              });
            }
          } else {
            filtered.push(obj);
          }

          setAttachmentURLList(filtered);
          setAttachmentURL(obj);

          setFormState((formState) => ({
            ...formState,
            [name]: obj,
            // attachment_Sr: !invoicePayload?.Invoice_id ? [res.data?.sr] : [0],

             attachment_Sr: !invoicePayload?.Invoice_id
                ? [...formState.attachment_Sr, res.data?.sr]
                : [0],
          }));
          // setAttachInvoiceLoading(false);
          // setInvoiceDeleteID(res.data?.sr);
          setInvoiceloader(false);
          // setImgPreview(true);
          setSuccessMessage(
            "Invoice Attachment has been Uploaded Successfully"
          );
        }
      })
      .catch((err) => {
        setInvoiceloader(false);
      });
  }
  setInvoiceloader(false);
};

const uploadFile = async (
  e,
  setLoamState,
  setInvoiceloader,
  name,
  setAttachmentURL,
  setAttchmentFile_UI,
  invoice_attachmentRef
) => {
  setInvoiceloader(true);
  const file = e.target.files[0];
  setAttchmentFile_UI((attachmentFiles) => [...attachmentFiles, file]);
  let formData = new FormData();
  formData.append("", file);
  await axios({
    method: "post", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/UploadFile/UploadFiles`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "multipart/form-data",
    },
    data: formData,
  })
    .then(async (res) => {
      setLoamState((formState) => ({
        ...formState,
        [name]: res.data,
      }));
      setAttachmentURL(res.data);
      invoice_attachmentRef.current.value = null;
      // setAttachInvoiceLoading(false);
      setInvoiceloader(false);
      // setImgPreview(true);
    })
    .catch((err) => {
      setInvoiceloader(false);
    });
};

const uploadAdditioalDocumentFile = async (
  e,
  setFormState,
  // setAttachInvoiceLoading,
  setAttchmentLoader,
  name,
  additionalAttachmentRef,
  setDocError,
  setAttachError,
  setAlertMessage,
  invoicePayload,
  selectedRole,
  dragfile,
  setDragFile,
  setSuccessMessage,

  // attachmentdeleteId,
  // setAttachmentdeleteID,

  // setDocsrc,setDocPreview
  setAttachmentURLList,   // <-- ADD THIS
  setAttachmentURL        // <-- ADD THIS
) => {
  const data = {
    Invoice_Id:
      invoicePayload?.Invoice_id && (selectedRole.roleName || selectedRole.role)
        ? invoicePayload?.Invoice_id :invoicePayload?.Invoice_Id? invoicePayload?.Invoice_Id
        : 0,
    RoleName: invoicePayload?.Invoice_Id?"IP":selectedRole.roleName || selectedRole.role,
    isAdditional: true,
  };
  setAttchmentLoader(true);
  setAttachError("");
  setDocError("");
  // setAttachInvoiceLoading(true);
  // const  file = dragfile ? e.dataTransfer.files[0] : e.target.files[0];let files = [];
  let files = [];
  // Case 1: `e` is directly a File object (e.g., generated Blob)
  if (e instanceof File) {
    files = [e]; // Wrap the single file in an array
  }
  // Case 2: `e` is a file input event or drag event
  else if (e.target && e.target.files) {
    files = Array.from(e.target.files); // Convert FileList to Array
  }
  // Case 3: Drag and Drop files
  else if (dragfile && e.dataTransfer && e.dataTransfer.files) {
    files = Array.from(e.dataTransfer.files); // Handle drag files
  }
  // setDocsrc(URL.createObjectURL(file));
  // const MAX_FILE_SIZE = 20480; // 20MB
  // const fileSizeKiloBytes = file.size / 1024;

  // if (fileSizeKiloBytes > MAX_FILE_SIZE) {
  //   setAttchmentLoader(true);

  //

  //   setTimeout(() => {
  //     setDocError("File size should be less then or equal to 20MBs");
  //     additionalAttachmentRef.current.value = null;
  //   }, 2000);
  // } else if (!file.name.match(/\.(jpg|jpeg|png|pdf|JPG|JPEG|PNG|PDF)$/)) {
  //   setDocError("Please upload only png, .jpg, .jpeg, .pdf Format");
  //   additionalAttachmentRef.current.value = null;
  // }

  for (let i = 0; i < files.length; i++) {
    if (
      files[i].name.match(/[`!#%^&*+\=\[\]{};':"\\|,<>\/?~]/) &&
      !files[i].name.match(
        /\.(eml|msg|pst|mbox|emlx|dbx|mbx|nws|p7m|mht|mhtml|rar|zip)$/i
      )
    ) {
      setAlertMessage(true);
      setDocError(
        `File name ${files[i].name}  should not have any special characters`
      );
      additionalAttachmentRef.current.value = null;
    } else {
      let formData = new FormData();
      formData.append("", files[i]);

      await axios({
        method: "post", //you can set what request you want to be
        url: `${process.env.REACT_APP_API_URL}/api/UploadFile/UploadFiles_v1`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          "Content-Type": "multipart/form-data",
        },
        data: formData,
        params: data,
      })
        .then(async (res) => {
          if (res.status === 200) {
            setDragFile(false);
            additionalAttachmentRef.current.value = null;
            const obj = {
              path: res.data.path,
              sr: res.data.sr,
              id: res.data.sr,
              role_Name: selectedRole.roleName,
            };
            setFormState((formState) => {
      const updatedList = [...formState[name], obj];
      // Update the attachment list
      if (setAttachmentURLList) setAttachmentURLList(updatedList);
      // Only set preview if NO invoice attachment exists
      if (setAttachmentURL && (!formState.invoice_attachment || !formState.invoice_attachment.path)) {
        setAttachmentURL(obj);
      }
      return {
              ...formState,
              [name]: updatedList,
              attachment_Sr: !invoicePayload?.Invoice_id
                ? [...formState.attachment_Sr, res.data?.sr]
                : [0],
     };
    });

            // setAttachmentdeleteID([...attachmentdeleteId, res.data?.sr])

            // const s = res.data.split("\\");
            // const ss = s[s.length - 1];
            // additionalAttachmentRef.current.value = null;
            setAttchmentLoader(false);
            setSuccessMessage(
              "Additional Attachment has been Uploaded Successfully"
            );
          }

          // setDocPreview(true)

          // setAttachInvoiceLoading(false);
})
        .catch((err) => {
          // setAttachInvoiceLoading(false);
          setAttchmentLoader(false);

          // setErrorMessage("Invalid username or password");
        });
    }
  }
  setAttchmentLoader(false);
};

const getVendorByPO = async (po_value, name, setFormState) => {
  // setFormState((formState) => ({
  //   ...formState,
  //   [name]: "",
  //   vendor_Name: "",
  // }));
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/sap-endpoint/get-vendor/${po_value}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      if (res.data?.VENDOR) {
        setFormState((formState) => ({
          ...formState,
          [name]: res.data?.VENDOR,
          po_Date : res.data?.PO_DATE ,
          plant_Code : res.data?.PLANT_CODE,
          vendor_Name: res.data?.VENDOR
            ? `${res.data?.VENDOR} - ${res.data?.VENDOR_NAME}`
            : "",
        }));
      }
      // else if (res.VENDOR) {
      //   setFormState((formState) => ({
      //     ...formState,

      //     [name]: res.VENDOR,
      //     vendor_Name: res.VENDOR
      //       ? `${res.VENDOR || ""} - ${res.VENDOR_NAME || ""}`
      //       : "",
      //   }));
      // }
      else {
        setFormState((formState) => ({
          ...formState,
          po_Date : res.data?.PO_DATE ,
          plant_Code : res.data?.PLANT_CODE,
          [name]: res.data?.VENDOR,
          vendor_Name: "",
        }));
      }
    })
    .catch((err) => {
      // setErrorMessage("Invalid username or password");
    });
};
const getVendorForPaymentMethod = async (po_value, setFormState) => {
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/sap-endpoint/get-vendor/${po_value}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      setFormState((formState) => ({
        ...formState,
        po_Date : res.data?.PO_DATE ,
        plant_Code : res.data?.PLANT_CODE,
        invoice_Payment: {
          ...formState?.invoice_Payment,
          paymentTerms: res.data?.PAYT_TERMS || "",
        },
      }));
    })
    .catch((err) => {
      // setErrorMessage("Invalid username or password");
    });
};
const getVendorByPOForBlock = async (
  Invoice_Id,
  po_value,
  name,
  setFormState,
  setVendorCode,
  setLoading,
  setvendorblock,
  alertMessage,
  setErrAlertMessage,
  setPoCreated
) => {
  setFormState((formState) => ({
    ...formState,
    [name]: "",
    vendor_Name: "",
  }));
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/sap-endpoint/get-vendor/${po_value}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      if (res.data?.VENDOR) {
        setFormState((formState) => ({
          ...formState,
          po_Date : res.data?.PO_DATE ,
          plant_Code : res.data?.PLANT_CODE,
          [name]: res.data?.VENDOR,
          vendor_Name: res.data?.VENDOR
            ? `${res.data?.VENDOR} - ${res.data?.VENDOR_NAME}`
            : "",
        }));
        setPoCreated((poCreated) => ({
          ...poCreated,
          POCreatedForBuyer: res.data?.POCREATED_BY,
          PRCreatedForInitiator: res.data?.PRCREATED_BY,
        }));
        getVendorDetailForVendorBlock(
          res.data?.VENDOR,
          setVendorCode,
          setLoading,
          setvendorblock,
          alertMessage,
          setErrAlertMessage
        );
        if(Invoice_Id!==0){
        getBuyerPRInitiator(res.data?.POCREATED_BY, res.data?.PRCREATED_BY, setFormState, Invoice_Id);}
      } else {
        setFormState((formState) => ({
          ...formState,
          po_Date : res.data?.PO_DATE ,
          plant_Code : res.data?.PLANT_CODE,
          [name]: res.data?.VENDOR,
          vendor_Name: "",
        }));
      }
    })
    .catch((err) => {


    //   const data = {
    //     PO_NUMBER: "4900023132",
    //     POCREATED_BY: "JEHTSHAM",
    //     PURCHASE_REQ: "1000098179",
    //     PRCREATED_BY: "FFAZAAL",
    //     PAYT_TERMS: "V004",
    //     VENDOR: "0001005482",
    //     VENDOR_NAME: "Ecolean Pakistan (Pvt) Ltd",
    //     PO_DATE: "2024-08-24",
    //     PLANT_CODE: "1032"
    // }



    //   setFormState((formState) => ({
    //     ...formState,
    //     [name]: data?.VENDOR,
    //     po_Date : data?.PO_DATE ,
    //     plant_Code : data?.PLANT_CODE,
    //     vendor_Name: data?.VENDOR
    //       ? `${data?.VENDOR} - ${data?.VENDOR_NAME}`
    //       : "",
    //   }));
      // setErrorMessage("Invalid username or password");
    });
};
const getBuyerPRInitiator = async (
  buyer, PRInitiator, setFormState, InvoiceId
) => {
  await axios({
    method: "post", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/save-invoice?invoiceId=${InvoiceId}&buyer=${buyer}&prInitiator=${PRInitiator}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      setFormState((formState) => ({
        ...formState,
        buyer: res.data?.buyer,
        prInitiator: res.data?.prInitiator,
      }));
    })
    .catch((err) => {
    });
};

// get Po details
const getPODetails_v1 = async (po_value, setFormState) => {
  const data = {
    po_no: po_value,
  };
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/sap-endpoint/GetPOData_V1`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
  })
    .then(async (res) => {
      let newData = [];
      if (res?.data?.Message) {
      } else {
        var result = JSON.parse(res?.data);
        for (let index = 0; index < result.length; index++) {
          const item = result[index];
          const obj = {
            AssetNumber: item.AssetNumber,
            BALANCE_QTY: item.BALANCE_QTY,
            BALANCE_VAL: item.BALANCE_VAL,
            COND_COUNT: item.COND_COUNT,
            COND_ST_NO: item.COND_ST_NO,
            Currency: item.Currency,
            DIST_IND: item.DIST_IND,
            DN_NO: item.DN_NO,
            DOC_DATE: item.DOC_DATE,
            DOC_YEAR: item.DOC_YEAR,
            DelivUnit: item.DelivUnit,
            Dlvqty: item.Dlvqty,
            INVOICE_QTY: item.INVOICE_QTY,
            INVOICE_VAL: item.INVOICE_VAL,
            KSCHL: item.KSCHL,
            ORDER_QTY: item.ORDER_QTY,
            ORDER_UNIT: item.ORDER_UNIT,
            POItem: item.POItem,
            POItemText: item.POItemText,
            PONumber: item.PONumber,
            Plant: item.Plant,
            Poqty: item.Poqty,
            Quantity: item.Quantity,
            RefDoc: item.RefDoc,
            RefDocIT: item.RefDocIT,
            RefDocNo: item.RefDocNo,
            RefDocNoLong: item.RefDocNoLong,
            SEQ_NO: item.SEQ_NO,
            SHEET_ITEM: item.SHEET_ITEM,
            SHEET_NO: item.SHEET_NO,
            SO_ITEM: item.SO_ITEM,
            SO_NO: item.SO_NO,
            VText: item.VText,
            Val_Gr_Loc: item.Val_Gr_Loc,
            Val_Iv_Loc: item.Val_Iv_Loc,
            Val_Loccur: item.Val_Loccur,
            Vendor_Code: item.Vendor_Code,
            DOC_DATE: item.DOC_DATE,
            Vendor_Name: item.Vendor_Name,
          };
          newData.push(obj);
        }
        setFormState((formState) => ({
          ...formState,
          invoicePORef_List: result,
        }));
      }
    })
    .catch((err) => {});
};

const getPODetailsForBuyer = async (
  po_value,
  setPoTableLoading,
  setFormState,
  invoicePayload,
  formState,
  setCopyOfPoDetail
) => {
  const data = {
    po_no: po_value,
  };
  setPoTableLoading(true);
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/sap-endpoint/GetPOData_V1`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
  })
    .then(async (res) => {
      let newData = [];
      if (res?.data?.Message) {
      } else {
        let grn = formState?.grn_No?.split(",");
        let filtered = [];

        var result = JSON.parse(res?.data);

        for (let index = 0; index < result.length; index++) {
          const item = result[index];
          const obj = {
            AssetNumber: item.AssetNumber,
            BALANCE_QTY: item.BALANCE_QTY,
            BALANCE_VAL: item.BALANCE_VAL,
            COND_COUNT: item.COND_COUNT,
            COND_ST_NO: item.COND_ST_NO,
            Currency: item.Currency,
            DIST_IND: item.DIST_IND,
            DN_NO: item.DN_NO,
            DOC_DATE: item.DOC_DATE,
            DOC_YEAR: item.DOC_YEAR,
            DelivUnit: item.DelivUnit,
            Dlvqty: item.Dlvqty,
            INVOICE_QTY: item.INVOICE_QTY,
            INVOICE_VAL: item.INVOICE_VAL,
            INPUT_QTY: Number(item?.Quantity) - Number(item.INVOICE_QTY),
            INPUT_VAL: Number(item?.Val_Loccur) - Number(item.INVOICE_VAL),
            KSCHL: item.KSCHL,
            ORDER_QTY: item.ORDER_QTY,
            ORDER_UNIT: item.ORDER_UNIT,
            POItem: item.POItem,
            POItemText: item.POItemText,
            PONumber: item.PONumber,
            Plant: item.Plant,
            uniT_PRICE : item.UNIT_PRICE, 
            Poqty: item.Poqty,
            Quantity: item.Quantity,
            RefDoc: item.RefDoc,
            RefDocIT: item.RefDocIT,
            RefDocNo: item.RefDocNo,
            RefDocNoLong: item.RefDocNoLong,
            SEQ_NO: item.SEQ_NO,
            SHEET_ITEM: item.SHEET_ITEM,
            SHEET_NO: item.SHEET_NO,
            SO_ITEM: item.SO_ITEM,
            SO_NO: item.SO_NO,
            VText: item.VText,
            Val_Gr_Loc: item.Val_Gr_Loc,
            Val_Iv_Loc: item.Val_Iv_Loc,
            Val_Loccur: item.Val_Loccur,
            Vendor_Code: item.Vendor_Code,
            Vendor_Name: item.Vendor_Name,
            DOC_DATE: item.DOC_DATE,
            invoice_Id: Number(invoicePayload),
            selected: false,
          };
          newData.push(obj);
          grn.map((data) => {
            if (item?.RefDoc?.toLowerCase().includes(data?.toLowerCase())) {
              filtered.push(item);
            }
          });
        }

        // for (let j = 0; j < filtered?.length; j++) {
        //   const itm = filtered[j];

        //   for (let i = 0; i < formState?.invoicePORef_List?.length; i++) {
        //   const ele = formState?.invoicePORef_List[i];
        //
        //     if ( ele.poItem === itm.POItem && ele.poNumber === itm.PONumber && ele.refDoc === itm.RefDoc && ele.dN_NO === itm.DN_NO ) {
        //       itm.selected = true;
        //       newFiltered.push(itm);
        //     }
        //   }
        // }

        setFormState((formState) => ({
          ...formState,
          invoicePORef_List: filtered,
          // invoicePORef_List: newData,
          // invoicePORef_List: result,
        }));
        const stringified = JSON.stringify(filtered);
        const parsedResult = JSON.parse(stringified);

        setCopyOfPoDetail((formState) => ({
          ...formState,
          copyInvoicePORef_List: parsedResult,
        }));

        setPoTableLoading(false);
      }
    })
    .catch((err) => {
      setPoTableLoading(false);
    });
};
const getPODetails = async (
  po_value,
  setPoTableLoading,
  setFormState,
  invoicePayload,
  formState,
  setCopyOfPoDetail,
  setErrorMessage,
  setAlertMessageForPO,
  setErrAlertMessage
) => {

  const data = {
    po_no: po_value,
  };
  setPoTableLoading(true);
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/sap-endpoint/GetPOData_V1`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
  })
    .then(async (res) => {
      let newData = [];
      if (res?.data?.Message) {
        setErrorMessage(res.data.Message);
      } else {
        var result = JSON.parse(res?.data);

        for (let index = 0; index < result.length; index++) {
          const item = result[index];
          const obj = {
            AssetNumber: item.AssetNumber,
            BALANCE_QTY: item.BALANCE_QTY,
            BALANCE_VAL: item.BALANCE_VAL,
            COND_COUNT: item.COND_COUNT,
            COND_ST_NO: item.COND_ST_NO,
            Currency: item.Currency,
            DIST_IND: item.DIST_IND,
            DN_NO: item.DN_NO,
            DOC_DATE: item.DOC_DATE,
            DOC_YEAR: item.DOC_YEAR,
            DelivUnit: item.DelivUnit,
            Dlvqty: item.Dlvqty,
            INVOICE_QTY: item.INVOICE_QTY,
            INVOICE_VAL: item.INVOICE_VAL,
            INPUT_QTY: Number(item?.BALANCE_QTY),
            INPUT_VAL: Number(item?.BALANCE_VAL),
            // INPUT_QTY: Number(item?.Quantity) - Number(item.INVOICE_QTY),
            // INPUT_VAL: Number(item?.Val_Loccur) - Number(item.INVOICE_VAL),
            KSCHL: item.KSCHL,
            ORDER_QTY: item.ORDER_QTY,
            ORDER_UNIT: item.ORDER_UNIT,
            POItem: item.POItem,
            POItemText: item.POItemText,
            PONumber: item.PONumber,
            Plant: item.Plant,
            uniT_PRICE : item.UNIT_PRICE, 
            Poqty: item.Poqty,
            Quantity: item.Quantity,
            RefDoc: item.RefDoc,
            RefDocIT: item.RefDocIT,
            RefDocNo: item.RefDocNo,
            RefDocNoLong: item.RefDocNoLong,
            SEQ_NO: item.SEQ_NO,
            SHEET_ITEM: item.SHEET_ITEM,
            SHEET_NO: item.SHEET_NO,
            SO_ITEM: item.SO_ITEM,
            SO_NO: item.SO_NO,
            VText: item.VText,
            Val_Gr_Loc: item.Val_Gr_Loc,
            Val_Iv_Loc: item.Val_Iv_Loc,
            Val_Loccur: item.Val_Loccur,
            Vendor_Code: item.Vendor_Code,
            Vendor_Name: item.Vendor_Name,
            DOC_DATE: item.DOC_DATE,
            invoice_Id: Number(invoicePayload),
            selected: false,
          };
          newData.push(obj);
        }

        setFormState((formState) => ({
          ...formState,
          invoicePORef_List: newData,
          // invoicePORef_List: result,
        }));
        if (newData?.length === 0) {
          setAlertMessageForPO(true);
          setErrAlertMessage("All invoices are consumed");
        }
        const stringified = JSON.stringify(newData);
        const parsedResult = JSON.parse(stringified);
        

        setCopyOfPoDetail((formState) => ({
          ...formState,
          copyInvoicePORef_List: parsedResult,
        }));

        setPoTableLoading(false);
      }
    })
    .catch((err) => {
      let newData = [];
      // const data =  [
      //   {
      //     RefDocNo: "",
      //     RefDocIT: "0003",
      //     Val_Loccur: "4603996.5000",
      //     Currency: "PKR",
      //     DelivUnit: "EA",
      //     POItem: "00010",
      //     Plant: "1032",
      //     RefDoc: "5001342741",
      //     RefDocNoLong: "",
      //     AssetNumber: "",
      //     VText: "",
      //     Quantity: "529195.000",
      //     Val_Gr_Loc: null,
      //     Val_Iv_Loc: null,
      //     Poqty: null,
      //     Dlvqty: null,
      //     PONumber: "4900023132",
      //     POItemText: "Olpers 250ml e Ecolean Packmat",
      //     KSCHL: "",
      //     COND_ST_NO: "000",
      //     COND_COUNT: "00",
      //     Vendor_Code: "0001005482",
      //     Vendor_Name: "Ecolean Pakistan (Pvt) Ltd",
      //     BALANCE_QTY: "529195.000",
      //     BALANCE_VAL: "4603996.5000",
      //     INVOICE_QTY: "0.000",
      //     INVOICE_VAL: "0.0000",
      //     DOC_YEAR: "2024",
      //     DOC_DATE: "2024-08-23",
      //     SHEET_ITEM: "0000000000",
      //     SHEET_NO: "5001342741",
      //     DN_NO: "30186",
      //     SEQ_NO: "00",
      //     DIST_IND: "",
      //     ORDER_UNIT: "",
      //     ORDER_QTY: "0.000",
      //     SO_NO: null,
      //     SO_ITEM: null,
      //     UNIT_PRICE: "8.70"
      //   },
      //   {
      //     RefDocNo: "",
      //     RefDocIT: "0002",
      //     Val_Loccur: "2616655.5000",
      //     Currency: "PKR",
      //     DelivUnit: "EA",
      //     POItem: "00010",
      //     Plant: "1032",
      //     RefDoc: "5001342741",
      //     RefDocNoLong: "",
      //     AssetNumber: "",
      //     VText: "",
      //     Quantity: "300765.000",
      //     Val_Gr_Loc: null,
      //     Val_Iv_Loc: null,
      //     Poqty: null,
      //     Dlvqty: null,
      //     PONumber: "4900023132",
      //     POItemText: "Olpers 250ml e Ecolean Packmat",
      //     KSCHL: "",
      //     COND_ST_NO: "000",
      //     COND_COUNT: "00",
      //     Vendor_Code: "0001005482",
      //     Vendor_Name: "Ecolean Pakistan (Pvt) Ltd",
      //     BALANCE_QTY: "300765.000",
      //     BALANCE_VAL: "2616655.5000",
      //     INVOICE_QTY: "0.000",
      //     INVOICE_VAL: "0.0000",
      //     DOC_YEAR: "2024",
      //     DOC_DATE: "2024-08-23",
      //     SHEET_ITEM: "0000000000",
      //     SHEET_NO: "5001342741",
      //     DN_NO: "30186",
      //     SEQ_NO: "00",
      //     DIST_IND: "",
      //     ORDER_UNIT: "",
      //     ORDER_QTY: "0.000",
      //     SO_NO: null,
      //     SO_ITEM: null,
      //     UNIT_PRICE: "8.70"
      //   }
      // ];
      
      

      
      // for (let index = 0; index < data.length; index++) {
      //   const item = data[index];
      //   const obj = {
      //     AssetNumber: item.AssetNumber,
      //     BALANCE_QTY: item.BALANCE_QTY,
      //     BALANCE_VAL: item.BALANCE_VAL,
      //     COND_COUNT: item.COND_COUNT,
      //     COND_ST_NO: item.COND_ST_NO,
      //     Currency: item.Currency,
      //     DIST_IND: item.DIST_IND,
      //     DN_NO: item.DN_NO,
      //     DOC_DATE: item.DOC_DATE,
      //     DOC_YEAR: item.DOC_YEAR,
      //     DelivUnit: item.DelivUnit,
      //     Dlvqty: item.Dlvqty,
      //     INVOICE_QTY: item.INVOICE_QTY,
      //     INVOICE_VAL: item.INVOICE_VAL,
      //     INPUT_QTY: Number(item?.BALANCE_QTY),
      //     INPUT_VAL: Number(item?.BALANCE_VAL),
      //     // INPUT_QTY: Number(item?.Quantity) - Number(item.INVOICE_QTY),
      //     // INPUT_VAL: Number(item?.Val_Loccur) - Number(item.INVOICE_VAL),
      //     KSCHL: item.KSCHL,
      //     ORDER_QTY: item.ORDER_QTY,
      //     ORDER_UNIT: item.ORDER_UNIT,
      //     POItem: item.POItem,
      //     POItemText: item.POItemText,
      //     PONumber: item.PONumber,
      //     Plant: item.Plant,
      //     uniT_PRICE : item.UNIT_PRICE, 
      //     Poqty: item.Poqty,
      //     Quantity: item.Quantity,
      //     RefDoc: item.RefDoc,
      //     RefDocIT: item.RefDocIT,
      //     RefDocNo: item.RefDocNo,
      //     RefDocNoLong: item.RefDocNoLong,
      //     SEQ_NO: item.SEQ_NO,
      //     SHEET_ITEM: item.SHEET_ITEM,
      //     SHEET_NO: item.SHEET_NO,
      //     SO_ITEM: item.SO_ITEM,
      //     SO_NO: item.SO_NO,
      //     VText: item.VText,
      //     Val_Gr_Loc: item.Val_Gr_Loc,
      //     Val_Iv_Loc: item.Val_Iv_Loc,
      //     Val_Loccur: item.Val_Loccur,
      //     Vendor_Code: item.Vendor_Code,
      //     Vendor_Name: item.Vendor_Name,
      //     DOC_DATE: item.DOC_DATE,
      //     invoice_Id: Number(invoicePayload),
      //     selected: false,
      //   };
      //   newData.push(obj);
      // }

      // setFormState((formState) => ({
      //   ...formState,
      //   invoicePORef_List: newData,
      //   // invoicePORef_List: result,
      // }));

      setPoTableLoading(false);
    });
};
const getDNDetails = async (
  dn_value,
  setPoTableLoading,
  setFormState,
  invoicePayload,
  formState,
  setCopyOfPoDetail,
  setdnVendorDetail,
  setFormState_v1 // here used to set vendor
) => {
  const data = {
    dn_no: dn_value,
    po_no: "",
  };
  setPoTableLoading(true);
  await axios({
    method: "POST", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/sap-endpoint/GetDNData_v1`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  })
    .then(async (res) => {
      let newData = [];
      if (res?.data?.Message) {
      } else {
        var result = JSON.parse(res?.data);
        for (let index = 0; index < result.length; index++) {
          const item = result[index];
          const inpuT_QTY_1 = Number(item?.Quantity) - Number(item.INVOICE_QTY);
          const inpuT_VAL_1 =
            Number(item?.Val_Loccur) - Number(item.INVOICE_VAL);
            const obj = {
            AssetNumber: item.AssetNumber,
            BALANCE_QTY: item.BALANCE_QTY,
            BALANCE_VAL: item.BALANCE_VAL,
            COND_COUNT: item.COND_COUNT,
            COND_ST_NO: item.COND_ST_NO,
            Currency: item.Currency,
            DIST_IND: item.DIST_IND,
            DN_NO: item.DN_NO,
            DOC_DATE: item.DOC_DATE,
            DOC_YEAR: item.DOC_YEAR,
            DelivUnit: item.DelivUnit,
            Dlvqty: item.Dlvqty,
            INVOICE_QTY: item.INVOICE_QTY,
            INVOICE_VAL: item.INVOICE_VAL,
            INPUT_QTY: inpuT_QTY_1.toString(),
            INPUT_VAL: inpuT_VAL_1.toString(),
            KSCHL: item.KSCHL,
            ORDER_QTY: item.ORDER_QTY,
            ORDER_UNIT: item.ORDER_UNIT,
            POItem: item.POItem,
            POItemText: item.POItemText,
            PONumber: item.PONumber,
            Plant: item.Plant,
            uniT_PRICE : item.UNIT_PRICE, 
            Poqty: item.Poqty,
            Quantity: item.Quantity,
            RefDoc: item.RefDoc,
            RefDocIT: item.RefDocIT,
            RefDocNo: item.RefDocNo,
            RefDocNoLong: item.RefDocNoLong,
            SEQ_NO: item.SEQ_NO,
            SHEET_ITEM: item.SHEET_ITEM,
            SHEET_NO: item.SHEET_NO,
            SO_ITEM: item.SO_ITEM,
            SO_NO: item.SO_NO,
            VText: item.VText,
            Val_Gr_Loc: item.Val_Gr_Loc,
            Val_Iv_Loc: item.Val_Iv_Loc,
            Val_Loccur: item.Val_Loccur,
            Vendor_Code: item.Vendor_Code,
            Vendor_Name: item.Vendor_Name,
            DOC_DATE: item.DOC_DATE,
            invoice_Id: Number(invoicePayload),
            selected: false,
          };
          newData.push(obj);
        }

        // if get 1 record from api no need to show vendors on popup
        if (newData.length === 1) {
          setFormState((formState) => ({
            ...formState,
            invoicePORef_List: newData,
          }));
          setFormState_v1((formState) => ({
            ...formState,
            vendor_Code: newData[0].Vendor_Code,
            vendor_Name: newData[0].Vendor_Code + "-" + newData[0].Vendor_Name,
          }));
        }

        const stringified = JSON.stringify(newData);
        const parsedResult = JSON.parse(stringified);

        // setCopyOfPoDetail((formState) => ({
        //   ...formState,
        //   copyInvoicePORef_List: parsedResult,
        // }));
        // if get more then 1 records then show vendor in popup.
        setdnVendorDetail((formState) => ({
          ...formState,
          dnVendorDetail_List: parsedResult,
        }));

        setPoTableLoading(false);
      }
    })
    .catch((err) => {
      setPoTableLoading(false);
    });
};
// for logistic invoices.
const getDN_ITN_Details = async (
  data,
  setPoTableLoading,
  setTemp_ActualPoDetail,
  invoicePayload,
  setCopyOfPoDetail,
  setFormState
) => {
  setPoTableLoading(true);
  await axios({
    method: "POST", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/sap-endpoint/GetDNData_v1`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  })
    .then(async (res) => {
      let newData = [];
      if (res?.data?.Message) {
      } else {
        var result = JSON.parse(res?.data);
        for (let index = 0; index < result.length; index++) {
          const item = result[index];
          const inpuT_QTY_1 = Number(item?.Quantity) - Number(item.INVOICE_QTY);
          const inpuT_VAL_1 =
            Number(item?.Val_Loccur) - Number(item.INVOICE_VAL);
          const obj = {
            AssetNumber: item.AssetNumber,
            BALANCE_QTY: item.BALANCE_QTY,
            BALANCE_VAL: item.BALANCE_VAL,
            COND_COUNT: item.COND_COUNT,
            COND_ST_NO: item.COND_ST_NO,
            Currency: item.Currency,
            DIST_IND: item.DIST_IND,
            DN_NO: item.DN_NO,
            DOC_DATE: item.DOC_DATE,
            DOC_YEAR: item.DOC_YEAR,
            DelivUnit: item.DelivUnit,
            Dlvqty: item.Dlvqty,
            INVOICE_QTY: item.INVOICE_QTY,
            INVOICE_VAL: item.INVOICE_VAL,
            INPUT_QTY: inpuT_QTY_1.toString(),
            INPUT_VAL: inpuT_VAL_1.toString(),
            KSCHL: item.KSCHL,
            ORDER_QTY: item.ORDER_QTY,
            ORDER_UNIT: item.ORDER_UNIT,
            POItem: item.POItem,
            POItemText: item.POItemText,
            PONumber: item.PONumber,
            Plant: item.Plant,
            uniT_PRICE : item.UNIT_PRICE, 
            Poqty: item.Poqty,
            Quantity: item.Quantity,
            RefDoc: item.RefDoc,
            RefDocIT: item.RefDocIT,
            RefDocNo: item.RefDocNo,
            RefDocNoLong: item.RefDocNoLong,
            SEQ_NO: item.SEQ_NO,
            SHEET_ITEM: item.SHEET_ITEM,
            SHEET_NO: item.SHEET_NO,
            SO_ITEM: item.SO_ITEM,
            SO_NO: item.SO_NO,
            VText: item.VText,
            Val_Gr_Loc: item.Val_Gr_Loc,
            Val_Iv_Loc: item.Val_Iv_Loc,
            Val_Loccur: item.Val_Loccur,
            Vendor_Code: item.Vendor_Code,
            Vendor_Name: item.Vendor_Name,
            invoice_Id: Number(invoicePayload),
            selected: false,
          };
          newData.push(obj);
        }
        setTemp_ActualPoDetail((pre) => ({
          ...pre,
          invoicePORef_List: newData,
        }));
        if (newData?.length > 0) {
          setFormState((pre) => ({
            ...pre,
            vendor_Code: newData[0]?.Vendor_Code,
            vendor_Name: `${newData[0]?.Vendor_Code} - ${newData[0]?.Vendor_Name}`,
          }));
        }
        const stringified = JSON.stringify(newData);
        const parsedResult = JSON.parse(stringified);

        setCopyOfPoDetail((pre) => ({
          ...pre,
          copyInvoicePORef_List: parsedResult,
        }));
        setPoTableLoading(false);
      }
    })
    .catch((err) => {
      setPoTableLoading(false);
    });
};

const createNewInvoice = async (
  formState,
  setFormState,
  poBasedState,
  setErrorMessage,
  setSuccessMessage,
  setAttachInvoiceLoading,
  setOpenProceedBtn,
  navigate,
  rolesNavigate,
  setPost
) => {
  setAttachInvoiceLoading(true);
  const stringified = JSON.stringify(formState);
  console.log(stringified, "stringified");

  const data = JSON.parse(stringified);
  console.log(data, "data");
  const Role = rolesNavigate?.filter((item) => {
    return item.roleName.toLowerCase() === "ir";
  });


if(data?.invoice_Type === "DES" ||data?.invoice_Type === "Rent"  ){
  const updatedAccountsList = data.invoice_Accounts_list.map(account => {
    return {
      ...account,
      glAccount: account.glAccount?.split(" - ")[0]?.trim() || account.GLAccount?.split(" - ")[0]?.trim()  , 
      costCenter : account?.costCenter?.split(" - ")[0]?.trim() || account?.CostCenter?.split(" - ")[0]?.trim(), 
    };
  });

  data.invoice_Accounts_list = updatedAccountsList;
}

if (data?.vP_InvoiceId == null) {
    data.vP_InvoiceId = 0;
  }

data.invoice_Amount = formState.invoice_Amount 
    ? formState.invoice_Amount
     : "0";
  data.pO_Based = poBasedState === "PO" ? true : false;
  data.invoice_No = formState?.invoice_No?.replace(/^\s+|\s+$/gm, "");
  const additionalDocIds = [];
  for (let i = 0; i < formState?.additionalDocIds.length; i++) {
    const item = formState?.additionalDocIds[i];
    additionalDocIds.push(item?.path);
  }
  data.additionalDocIds = additionalDocIds;
  data.invoice_attachment = formState?.invoice_attachment?.path;

  if (poBasedState !== "PO" || data?.isHR) {
    data.vendor_Code = formState.vendor_Code.Vendor_Code;
  }

  if (formState.isPCDV) {
    data.invoice_Accounts_list = formState.Expense_Accounts_list;
    // data.invoice_Date = "2023-11-15T19:00:00.000Z";
  }
  if (data?.isHR) {
    const Invoice_Clearingvendor_list = formState.vendor_Details.map((item) => {
      return {
        vendorCode: item?.vendor_Code.Vendor_Code,
        amount: item?.amount.toString(),
      };
    });
    data.Invoice_Clearingvendor_list = Invoice_Clearingvendor_list;

    const invoice_Accounts = formState.invoice_Accounts_list.map((item) => {
      return {
        ...item,
        profitCenter: item?.profitCenter?.toString(),
        costCenter: item?.costCenter?.split("-")[0].trim(),
        glAccount: item?.glAccount?.split("-")[0].trim(),
        horizonId: item?.horizonId?.split("-")[0].trim(),
        vendorCode: item?.vendor_Code?.split("-")[0].trim(),
      };
    });
    data.invoice_Accounts_list = invoice_Accounts;
    data.pO_Based = false;
  }
  if ((data.vendor_Code === "" || data.vendor_Code === null || data.vendor_Code === undefined) && !data.isHR) {
    setOpenProceedBtn(false);
    setAttachInvoiceLoading(false);
    setErrorMessage("Invalid Vendor code");
  } else {
    await axios({
      method: `${
        formState.invoice_Id === 0 || formState.invoice_Id === ""
          ? "Post"
          : "Put"
      }`, //you can set what request you want to be
      url: `${process.env.REACT_APP_API_URL}/api/Invoices/${
        formState.invoice_Id === 0 || formState.invoice_Id === ""
          ? "PostNewInvoice_v1" //  for all initiator
          : "UpdateInvoice_v1" // for update all initiator invoice

        //
      }`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
      data: data,
    })
      .then(async (res) => {
        if (res.status === 200) {
          // clearState(setFormState);
          setPost(false);
          setAttachInvoiceLoading(false);
          setOpenProceedBtn(false);
          setErrorMessage("");
          if (formState?.isDraft) {
            // setSuccessMessage(
            //   `Your Invoice ${formState.invoice_No} is Saved as Draft Successfully`
            // );
               navigate("/home", {
            state: {
              msg: formState?.isDraft
                ? `Your Invoice ${formState.invoice_No} is Saved as Draft Successfully`
                : `Invoice ${formState.invoice_No} has been Submitted Successfully`,
            },
          });
          } else {
            // setSuccessMessage(
            //   `Invoice ${formState.invoice_No} has been Submitted Successfully`
            // );
    navigate("/home", {
            state: {
              msg: formState?.isDraft
                ? `Your Invoice ${formState.invoice_No} is Saved as Draft Successfully`
                : `Invoice ${formState.invoice_No} has been Submitted Successfully`,
            },
          });          }

          // navigate("/home", {
          //   state: {
          //     msg: formState?.isDraft
          //       ? `Your Invoice ${formState.invoice_No} is Saved as Draft Successfully`
          //       : `Invoice ${formState.invoice_No} has been Submitted Successfully`,
          //   },
          // });
        }
      })
      .catch((err) => {
        setOpenProceedBtn(false);
        if (err?.response?.data) {
          setErrorMessage(err?.response?.data?.title || err?.response?.data);
        } else {
          setErrorMessage(err?.message);
        }
        setAttachInvoiceLoading(false);
      });
    }
};
const submit_APSInvoice = async (
  formState,
  setErrorMessage,
  setSuccessMessage,
  setAttachInvoiceLoading,
  setOpenProceedBtn,
  setInvoiceCompleted,
  navigate,
  setPost
) => {
  setAttachInvoiceLoading(true);
  const dataStringyfy = JSON.stringify(formState);
  const dataParse = JSON.parse(dataStringyfy);
  const obj = [];
  const invoiceNo = formState?.invoice_No || formState?.invoiceNo || "";
  const invoiceId = formState?.invoice_Id || formState?.invoiceId || 0;

  dataParse.rtbLineItems_List =
    formState?.rtbLineItems_List?.map((item) => ({
      LineId: item.ID,
      RTBCode: item.RtbNo,
      Category: item.Category,
      VendorCode: item.VendorCode,
      InvoiceNo: invoiceNo,
      InvoiceId: invoiceId,
      I2PStatus: null,
      I2PInvoiceUrl: null,
      isFinalled: item.isFinalled,
    })) || [];
  for (let index = 0; index < formState?.additional_Docs.length; index++) {
    const element = formState?.additional_Docs[index];
    obj.push(element.path);
  }
  dataParse.additional_Docs = obj;
  dataParse.invoice_attachment = formState?.invoice_attachment?.path || "";
  dataParse.payment_Method = `${"|" + formState.payment_Method}`;
  dataParse.house_Bank = `${"|" + formState.house_Bank}`;
  dataParse.refrence_DocNo = `${"|" + formState.refrence_DocNo}`;
  dataParse.invoice_Desc = `${"|" + formState.invoice_Desc}`;

  await axios({
    method: "Put", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/PutApSinvoice_v1`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    data: dataParse,
  })
    .then(async (res) => {
      setErrorMessage("");
      setPost(false);
      setOpenProceedBtn(false);
      // setSuccessMessage(
      //   `Invoice ${
      //     formState?.invoice_No ? "" : ""
      //   } has been Submitted Successfully`
      // );
      setTimeout(() => {
        setAttachInvoiceLoading(false);
        setSuccessMessage(
          `Invoice ${
            formState?.invoice_No ? "" : ""
          } has been Submitted Successfully`
        );
        // navigate("/home", {
        //   state: {
        //     msg: `Invoice ${
        //       formState?.invoice_No ? "" : ""
        //     } has been Submitted Successfully`,
        //   },
        // });
      }, 3000);
    })
    .catch((err) => {
      if (err?.response?.data) {
        setErrorMessage(
          err?.response?.data?.title ||
            err?.response?.data?.Message ||
            err?.response?.data ||
            err?.response?.data?.Status
        );
      } else {
        setErrorMessage(err?.message);
      }
      setAttachInvoiceLoading(false);
      if(err?.response?.data?.Message?.includes('is not blocked for payment')){
      setInvoiceCompleted(true)}
      setOpenProceedBtn(false);
    });
};
const updateInvoiceByTaxTeam = async (
  formState,
  setFormState,
  setErrorMessage,
  setSuccessMessage,
  setAttachInvoiceLoading,
  setOpenProceedBtn,
  navigate,
  setPost
) => {
  setAttachInvoiceLoading(true);
  const dataStringyfy = JSON.stringify(formState);
  const dataParse = JSON.parse(dataStringyfy);

  const additionalDocIds = [];
  for (let i = 0; i < formState?.additionalDocIds?.length; i++) {
    const item = formState?.additionalDocIds[i];
    additionalDocIds.push(item?.path);
  }
  dataParse.additionalDocIds = additionalDocIds;

  dataParse.salesTaxAmount = formState?.salesTaxAmount?.toString();
  const a = {
    Invoice_Id: "25629", //ddd
    taxCodeDes: "FI - WHT on Transp. 3% - Karachi", //dd
    taxCode_1: "FI", //dd
    taxId: "46038", //dd
    taxTypeDes: "Z1 - WHT Deducted at Source (Company)", //dd
    taxType_v1: "Z1", //dd
  };
  dataParse.taxCard_List = formState?.taxCard_List?.filter(
    (x) => x.category && x?.taxCode
  );

  const taxCard_List = [];
  for (let i = 0; i < dataParse.taxCard_List.length; i++) {
    const item = dataParse.taxCard_List[i];
    item.taxType = item["taxType"]?.split("-")[0]?.trim();
    item.taxCode = item["taxCode"]?.split("-")[0]?.trim();
    item.amount = item["amount"]?.toString();
    item.invoice_Id = Number(formState?.invoice_Id);
    taxCard_List.push(item);
  }
  dataParse.taxCard_List = taxCard_List;
  await axios({
    method: "put", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/PutTaxTeamInvoice`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    data: dataParse,
  })
    .then(async (res) => {
      if (res.status === 200) {
        // setSuccessMessage(
        //   `Invoice ${formState.invoice_No} has been Updated Successfully`
        // );
        // clearState(setFormState);
        // setTimeout(() => {
        setOpenProceedBtn(false);
        setPost(false);
        setAttachInvoiceLoading(false);
        setSuccessMessage(
          `Invoice ${formState.invoice_No}  has been Updated Successfully`
        );
        // navigate("/home", {
        //   state: {
        //     msg: `Invoice ${formState.invoice_No}  has been Updated Successfully`,
        //   },
        // });
        // }, 3000);
      }
    })
    .catch((err) => {
      if (err?.message) {
        setErrorMessage(err?.message);
      } else {
        setErrorMessage(err?.response?.data?.title);
      }
      setAttachInvoiceLoading(false);
    });
};

const updateIR = async (
  formState,
  newFormState,
  setSuccessMessage,
  setErrorMessage,
  setLoading,
  close,
  navigate , 
  setCommentsList,
  setCommentsLoading,
  invoicePayload ,
  setcount
) => {
  setLoading(true);

  const data={
  Invoice_Id:formState.Invoice_Id,
  IRUser:formState.IRUser!=="" ? formState.IRUser : formState.taxTeam,
  state:formState.state,
  IsIRuser:formState.IRUser!=="" ?true:false,
  comment : formState?.comment || newFormState?.comments
  }
  await axios({
    method: "put", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/UpdateIR`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
  })
    .then(async (res) => {
      // setSuccessMessage(
      //   `Invoice ${formState.invoice_No} has been Updated by IR Successfully`
      // );
      setLoading(false);
      close();
      setSuccessMessage(`${formState.IRUser!==""?"IR User has been changed Successfully":"Invoice has been Submitted Successfully"}`);
      getCommentsByInvoiceId(
        setCommentsList,
        setCommentsLoading,
        invoicePayload ,
        setcount
      )
       navigate("/home", {
        state: {
          msg: `IR User has been changed Successfully`,
        },
      });
      
      // setTimeout(() => {
      // navigate("/home", {
      //   state: {
      //     msg: `Invoice ${formState.invoice_No} has been Updated by IR Successfully`,
      //   },
      // });
      // }, 3000);
    })
    .catch((err) => {
      if (err?.response?.data) {
        setErrorMessage(err?.response?.data?.title || err?.response?.data);
      } else {
        setErrorMessage(err?.message);
      }
      setLoading(false);
    });
};

const updateLoamReviewer = async (
  Invoice_Id,
  formState,
  setSuccessMessage,
  setErrorMessage,
  setLoading,
  close,
  navigate,
  setAllowToProceed
) => {
  setLoading(true);
  const transformData=[]
  if (!Array.isArray(formState.loamReviewer)) {
    transformData.push(formState.loamReviewer);
  }
  const data={
  Invoice_Id:formState.invoice_Id ,
  Invoice_No:formState.invoice_No,
  }
  await axios({
    method: "put",
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/AddLoamReviewer?Invoice_Id=${formState.invoice_Id==0?Invoice_Id:formState.invoice_Id}&Invoice_No=${formState.invoice_No}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    data:Array.isArray(formState.loamReviewer)?formState.loamReviewer:transformData
  })
    .then(async (res) => {
      setLoading(false);
      formState.invoice_Id && close();
      setSuccessMessage(`${"Invoice has been Submitted Successfully"}`);
      setAllowToProceed(false);
         navigate("/home", {
          state: {
            msg: `Invoice reviewer has been changed Successfully`,
          },
        });
    })
    .catch((err) => {
      if (err?.response?.data) {
        setErrorMessage(err?.response?.data?.title || err?.response?.data);
      } else {
        setErrorMessage(err?.message);
      }
      setLoading(false);
    });
};
const createNewInvoiceByEFDV = async (
  formState,
  setFormState,
  setErrorMessage,
  setSuccessMessage,
  setAttachInvoiceLoading,
  setOpenProceedBtn,
  navigate,
  setPost
) => {
  setAttachInvoiceLoading(true);
  const stringified = JSON.stringify(formState);
  const data = JSON.parse(stringified);
  // data.invoice_Id = parseInt(formState.invoice_Id);
  // data.pO_Based = poBasedState === "PO" ? true : false;
  const additionalDocIds = [];
  for (let i = 0; i < formState?.additionalDocIds?.length; i++) {
    const item = formState?.additionalDocIds[i];
    additionalDocIds.push(item?.path);
  }
  data.additionalDocIds = additionalDocIds;
  data.vendor_Code = formState.vendor_Code.Vendor_Code;
  data.invoice_attachment = formState?.invoice_attachment?.path;
  if (formState.isPCDV) {
    data.invoice_Amount = formState.invoice_Amount.toString();
    data.invoice_Accounts_list = formState.Expense_Accounts_list.map((item) => {
      return {
        ...item,

        glAccount: item?.glAccount?.split("-")[0]?.trim(),
        costCenter: item?.costCenter?.split("-")[0]?.trim(),
        profitCenter: item?.profitCenter
          ? item?.profitCenter.toString().padStart(10, "0")
          : "",
        // amount: item?.amount.toString(),
        amount: (item?.amount=="" ||item?.amount=="NaN") ? 0 : Number(item?.amount)?.toFixed(2),
      };
    });

    // data.loamReviewer = "501066e6-041e-4c85-bff9-caf855f09b9b";
    data.pO_Based = false;
  }

  await axios({
    method: `${
      formState.invoice_Id === 0 || formState.invoice_Id === "" ? "Post" : "Put"
    }`, //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/${
      formState.invoice_Id === 0 || formState.invoice_Id === ""
        ? "PostNewInvoice_v1"
        : "UpdateInvoice_v1"
    }`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  })
    .then(async (res) => {
      if (res.status === 200) {
        // clearState(setFormState);
        setPost(false);
        setAttachInvoiceLoading(false);
        setOpenProceedBtn(false);
        setSuccessMessage(
          `Invoice ${res.data} has been Submitted Successfully`
        );
        navigate("/home", {
          state: {
            msg: `Invoice ${res.data} has been Submitted Successfully`,
          },
        });
      }
    })
    .catch((err) => {
      if (err?.response?.data) {
        setErrorMessage(err?.response?.data?.title || err?.response?.data);
      } else {
        setErrorMessage(err?.message);
        setAttachInvoiceLoading(false);
      }
      setOpenProceedBtn(false);
      setAttachInvoiceLoading(false);
    });
};

const createInvoiceByIR = async (
  formState,
  temp_ActualPoDetail,
  setFormState,
  poBasedState,
  setErrorMessage,
  setSuccessMessage,
  setAttachInvoiceLoading,
  setOpenProceedBtn,
  navigate,
  rolesNavigate,
  searchWithPo,
  BuyerStatus,
  PRInitiatorStatus,
  setPost
) => {
  setAttachInvoiceLoading(true);

  let transformData = [];
  const stringified = JSON.stringify(formState);
  const data = JSON.parse(stringified);
  // ✅ transform RTB list before API call
data.rtbLineItems_List =
  formState?.rtbLineItems_List?.map((item) => ({
    LineId: item.ID,
    RTBCode: item.RtbNo,
    Category: item.Category,
    VendorCode: item.VendorCode,
    InvoiceNo: formState.invoice_No,
    InvoiceId: formState.invoice_Id,
    I2PStatus: null,
    I2PInvoiceUrl: null,
    isFinalled: item.isFinalled,
  })) || [];
  data.pO_Based = poBasedState === "PO" ? true : false;
  data.invoice_No = formState?.invoice_No?.replace(/^\s+|\s+$/gm, "");
  data.invoice_Id = formState?.invoice_Id?.toString();
  const additionalDocIds = [];
  for (let i = 0; i < formState?.additionalDocIds?.length; i++) {
    const item = formState?.additionalDocIds[i];
    additionalDocIds.push(item?.path);
  }
  data.additionalDocIds = additionalDocIds;

  // data.additionalDocIds = formState?.additionalDocIds || []; // for draft invoice because while posting draft invoice additional documents send in the form of string instead of list
  data.searchWith = searchWithPo ? "PO" : "DN";
  data.urgent = formState?.urgent === null ? false : formState.urgent; // for Quick pay invoice data of this invoice comes from data database which is null for urgent
  data.skipTaxStep =
    formState?.skipTaxStep === null ? false : formState.skipTaxStep;
  data.invoice_attachment = formState?.invoice_attachment?.path;
  if (poBasedState !== "PO") {
    data.vendor_Code = formState.vendor_Code.Vendor_Code;
    data.taxTeam = formState?.skipTaxStep ? "" : formState.taxTeam; // for quick pay invoice
  }
  for (let i = 0; i < temp_ActualPoDetail?.invoicePORef_List?.length; i++) {
    const item = temp_ActualPoDetail?.invoicePORef_List[i];
    if (item.selected == true) {
      const obj = {
        assetNumber: item?.AssetNumber || "",
        balancE_QTY: item?.BALANCE_QTY || "",
        balancE_VAL: item?.BALANCE_VAL || "",
        conD_COUNT: item?.COND_COUNT || "",
        conD_ST_NO: item?.COND_ST_NO || "",
        currency: item?.Currency || "",
        disT_IND: item?.DIST_IND || "",
        dN_NO: item?.DN_NO || "",
        created_on: item?.DOC_DATE || "",
        doc_Date: item?.DOC_DATE || "",
        doC_YEAR: item?.DOC_YEAR || "",
        delivUnit: item?.DelivUnit || "",
        // inpuT_QTY: item?.Dlvqty || "",
        inpuT_QTY: item?.INPUT_QTY?.toString() || "0",
        inpuT_VAL: item?.INPUT_VAL?.toString() || "0",
        invoicE_QTY: item?.INVOICE_QTY.toString() || "0",
        invoicE_VAL: item?.INVOICE_VAL.toString() || "0",
        kschl: item?.KSCHL || "",
        ordeR_QTY: item?.ORDER_QTY || "",
        ordeR_UNIT: item?.ORDER_UNIT || "",
        poItem: item?.POItem || "",
        poItemText: item?.POItemText || "",
        poNumber: item?.PONumber || "",
        plant: item?.Plant || "",
        uniT_PRICE : item?.uniT_PRICE || "", 
        // inpuT_VAL: item?.Poqty || "",
        quantity: item?.Quantity.toString() || "",
        refDoc: item?.RefDoc || "",
        reF_DOC_IT: item?.RefDocIT || "",
        reF_DOC_NO: item?.RefDocNo || "",
        reF_DOC_NO_LONG: item?.RefDocNoLong || "",
        seQ_NO: item?.SEQ_NO || "",
        sheeT_ITEM: item?.SHEET_ITEM || "",
        po_Ref_Id: 1,
        sO_ITEM: item?.SO_ITEM || "",
        sO_NO: item?.SO_NO || "",
        vText: item?.VText || "",
        invoice_Id: item?.invoice_Id || 0,
        created_by: item?.Val_Iv_Loc || "",
        val_Loccur: item?.Val_Loccur.toString() || "",
        // Vendor_Code: item?.Vendor_Code || "",
        // Vendor_Name: item?.Vendor_Name//n
      };
      transformData.push(obj);
    }
  }

  data.invoicePORef_List = transformData;
  if (formState.isPCDV) {
    data.invoice_Accounts_list = formState.Expense_Accounts_list;
    // data.invoice_Date = "2023-11-15T19:00:00.000Z";
  }

   if(formState?.invoice_Type === "Final Settlement - Distributor"){
    data.distributor_Code = formState?.distributor_Code
    const invoice_Accounts = formState?.invoice_Accounts_list.map((item) => {
      return {
        ...item,
        vendorCode: item?.vendor_Code?.split("-")[0].trim(),
      };
    });
    data.invoice_Accounts_list = invoice_Accounts;
  }

  await axios({
    method: "put", //you can set what request you want to be
    // url: `${process.env.REACT_APP_API_URL}/api/Invoices/${formState.poBasedState} === "PO" ? PutIRInvoice : PutIRInvoice_v2`,
    url:
      // data.pO_Based === true &&
      // formState?.invoice_Id !== "0" &&
      // formState?.invoice_Id !== ""
      //   ? `${process.env.REACT_APP_API_URL}/api/Invoices/PutIRInvoice` // create invoice by ir.
      //   : `${process.env.REACT_APP_API_URL}/api/Invoices/PutIRInvoice_v2`, // can be used only this (saleem said)(create and update by ir).
      `${process.env.REACT_APP_API_URL}/api/Invoices/PutIRInvoice_v2`, // can be used only this (saleem said)(create and update by ir).
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  })
    .then(async (res) => {
      if (res.status === 200) {
        setSuccessMessage(res?.data)
        setErrorMessage("");
        setPost(false);
        // clearState(setFormState);
        setAttachInvoiceLoading(false);
        if (poBasedState === "Non-PO" && formState.loamReviewer=="") {
          NOnPObasedNavigation(
            rolesNavigate,
            formState,
            poBasedState,
            BuyerStatus,
            PRInitiatorStatus,
            res,
            data,
            navigate,
            setSuccessMessage
          );
        } else if(poBasedState === "PO" && formState.loamReviewer=="") {
          PObasedNavigation(
            rolesNavigate,
            formState,
            poBasedState,
            BuyerStatus,
            PRInitiatorStatus,
            res,
            data,
            navigate,
            setSuccessMessage
          );
        }else{

        }
      }
      setOpenProceedBtn(false);
      // setTimeout(() => {
      //   // navigate("/home");

      //  Id: invoicePayload?.Invoice_id,
      //  RoleId: role?.roleId,
      // }, 4000);
      // setSuccessMessage(
      //   `Invoice ${formState.invoice_No} has been Submitted Successfully`
      // );
    })
    .catch((err) => {
      if (err?.response?.data) {
        setErrorMessage(err?.response?.data?.title || err?.response?.data);
      } else {
        setErrorMessage(err?.message);
      }
      setAttachInvoiceLoading(false);
    });
  setOpenProceedBtn(false);
};
const NOnPObasedNavigation = (
  rolesNavigate,
  formState,
  poBasedState,
  BuyerStatus,
  PRInitiatorStatus,
  res,
  data,
  navigate,
  setSuccessMessage
) => {
  const Role = rolesNavigate?.filter((item) => {
    return item.roleName?.toLowerCase() === "tax team";
  });
  const IPRole = rolesNavigate?.filter((item) => {
    return item.roleName?.toLowerCase() === "ip";
  });
  const DepRole = rolesNavigate?.filter((item) => {
    return item.roleName?.toLowerCase() === "department coordinator";
  });
  const logisticRole = rolesNavigate?.filter((item) => {
    return item.roleName?.toLowerCase() === "logistic";
  });

  let specificRoute = null;
  let message = `Invoice ${formState.invoice_No} has been Submitted Successfully`;

  if (
    !formState.skipTaxStep &&
    data?.taxTeam &&
    Role.length !== 0 &&
    user?.LoginId === data?.taxTeam
  ) {
    specificRoute = `/taxCheck?invoiceId=${res.data}&roleId=${Role[0].roleId}&roleName=${Role[0].roleName}&vendorCode=${data.vendor_Code}&status=SendToTaxTeam&edit=true`;
  } else if (
    formState.skipTaxStep &&
    formState?.dept_coordinator &&
    DepRole.length !== 0 &&
    user?.LoginId === formState?.dept_coordinator
  ) {
    specificRoute = `/departmentCoordinator?invoiceId=${res.data}&roleName=${DepRole[0].roleName}&roleId=${DepRole[0].roleId}&vendorCode=${data.vendor_Code}&status=SendToDeptCoordinator&edit=true`;
  } else if (
    formState.skipTaxStep &&
    formState?.ipUser &&
    IPRole.length !== 0 &&
    !formState?.dept_coordinator &&
    user?.LoginId === formState?.ipUser
  ) {
    specificRoute = `/processInvoice?invoiceId=${res.data}&roleName=${IPRole[0].roleName}&roleId=${IPRole[0].roleId}&vendorCode=${data.vendor_Code}&status=SendToIP&edit=true`;
  }

  // handleNavigation(res, navigate, specificRoute, "/home", message, setSuccessMessage);

  handleNavigation(
    res,
    navigate,
    specificRoute,
    "/home",
    message,
    setSuccessMessage
  );
};
const PObasedNavigation = (
  rolesNavigate,
  formState,
  poBasedState,
  BuyerStatus,
  PRInitiatorStatus,
  res,
  data,
  navigate,
  setSuccessMessage
) => {
  const Role = rolesNavigate?.filter((item) => {
    // return item.roleId === "02e4e743-9a83-46b3-933f-bac372c52e49";
    return item.roleName?.toLowerCase() === "tax team";
  });
  const IPRole = rolesNavigate?.filter((item) => {
    // return item.roleId === "013fa4f6-3525-434b-8293-c1a72ef1526f";
    return item.roleName?.toLowerCase() === "ip";
  });
  const logisticRole = rolesNavigate?.filter((item) => {
    // return item.roleId === "865415b5-e426-467c-8278-9cb4cb3d789a";
    return item.roleName?.toLowerCase() === "logistic";
  });

  if (
    !formState.skipTaxStep &&
    Role.length !== 0 &&
    poBasedState === "PO" &&
    BuyerStatus === false &&
    PRInitiatorStatus === false
  ) {
    if (
      formState.isLogistics &&
      logisticRole.length !== 0 &&
      user?.LoginId === formState?.logisticsTeam
    ) {
      navigate(
        `/logisticsInvoice?invoiceId=${res.data}&roleId=${logisticRole[0].roleId}&roleName=${logisticRole[0].roleName}&status=SendToLogistic&edit=true`,
        {
          state: {
            msg: `Invoice ${formState.invoice_No} has been Submitted Successfully`,
          },
        }
      );
    } else if (user?.LoginId === formState?.taxTeam) {
      navigate(
        `/taxCheck?invoiceId=${res.data}&roleId=${Role[0].roleId}&roleName=${Role[0].roleName}&vendorCode=${data.vendor_Code}&status=SendToTaxTeam&edit=true`,
        {
          state: {
            msg: `Invoice ${formState.invoice_No} has been Submitted Successfully`,
          },
        }
      );
    } else {
      setSuccessMessage(
        `Invoice ${formState.invoice_No} has been Submitted Successfully`
      );
      // navigate("/home", {
      //   state: {
      //     msg: `Invoice ${formState.invoice_No} has been Submitted Successfully`,
      //   },
      // });
    }
  } else if (
    IPRole.length !== 0 &&
    poBasedState === "PO" &&
    BuyerStatus === false &&
    PRInitiatorStatus === false
  ) {
    if (
      formState.isLogistics &&
      logisticRole.length !== 0 &&
      user?.LoginId === formState?.logisticsTeam
    ) {
      navigate(
        `/logisticsInvoice?invoiceId=${res.data}&roleId=${logisticRole[0].roleId}&roleName=${logisticRole[0].roleName}&status=SendToLogistic&edit=true`,
        {
          state: {
            msg: `Invoice ${formState.invoice_No} has been Submitted Successfully`,
          },
        }
      );
    } else if (
      formState.skipTaxStep &&
      poBasedState === "PO" &&
      BuyerStatus === false &&
      PRInitiatorStatus === false &&
      user?.LoginId === formState?.ipUser
    ) {
      navigate(
        `/processInvoice?invoiceId=${res.data}&roleName=${IPRole[0].roleName}&roleId=${IPRole[0].roleId}&vendorCode=${data.vendor_Code}&status=SendToIP&edit=true`,
        {
          state: {
            msg: `Invoice ${formState.invoice_No} has been Submitted Successfully`,
          },
        }
      );
    } else {
      setSuccessMessage(
        `Invoice ${formState.invoice_No} has been Submitted Successfully`
      );
      // navigate("/home", {
      //   state: {
      //     msg: `Invoice ${formState.invoice_No} has been Submitted Successfully`,
      //   },
      // });
    }
  }else {
    // setSuccessMessage(
    //   `Invoice ${formState.invoice_No} has been Submitted Successfully`
    // );
    navigate("/home", {
      state: {
        msg: `Invoice ${formState.invoice_No} has been Submitted Successfully`,
      },
    });
  }
};

const handleNavigation = (
  res,
  navigate,
  specificRoute,
  homeRoute,
  message,
  setSuccessMessage
) => {
  if (specificRoute) {
    navigate(specificRoute, {
      state: {
        msg: message,
      },
    });
  // } else {
  //   setSuccessMessage(message);
  }
  else {
    setSuccessMessage(message)
    navigate(homeRoute, {
      state: {
        msg: message,
      },
    });
  }
};
const LoamPutInvoice = async (
  formState,
  setFormState,
  setErrorMessage,
  setSuccessMessage,
  setAttachInvoiceLoading,
  navigate,
  setConfirmationModal,
  setPost
) => {
  const additionalDocIds = [];
  for (let i = 0; i < formState?.additionalDocIds?.length; i++) {
    const item = formState?.additionalDocIds[i];
    additionalDocIds.push(item?.path);
  }
  const data = {
    invoice_id: formState?.invoice_id,
    additionalDocs: additionalDocIds,
    comments: formState?.comments,
    invoice_Accounts: [],
    // rtbId : formState?.rtbId,
    // rtbLineItems_List: formState?.rtbLineItems_List,
          rtbLineItems_List :
  formState?.rtbLineItems_List?.map((item) => ({
    LineId: item.ID,
    RTBCode: item.RtbNo,
    Category: item.Category,
    VendorCode: item.VendorCode,
    InvoiceNo: formState.invoice_No,
    InvoiceId: formState.invoice_Id,
    I2PStatus: null,
    I2PInvoiceUrl: null,
    isFinalled: item.isFinalled,
  })) || [],
    // invoice_Accounts: formState?.invoice_Accounts_list.map((item) => {
    //   return {
    //     ...item,
    //     glAccount: item?.glAccount?.split("-")[0],
    //     costCenter: item?.costCenter?.split("-")[0],
    //     profitCenter: item?.profitCenter
    //       ? item?.profitCenter?.toString()?.padStart(10, "0")
    //       : "",
    //     amount: item?.amount.toString(),
    //   };
    // }),
    isReject: formState?.isReject,
    createdBy: "",
    aditional_Comments: formState?.aditional_Comments,
    reviewer: formState?.loamReviewer.length > 0 ? formState?.loamReviewer : [],
    reviewer2: [],
  };

  await axios({
    method: "put", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/PutLoamApproval`,
    //  url:( data.pO_Based === true) ? `${process.env.REACT_APP_API_URL}/api/Invoices/PutIRInvoice ` : `${process.env.REACT_APP_API_URL}/api/Invoices/PutIRInvoice_v2 ` ,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  })
    .then(async (res) => {
      if (res.status === 200) {
        setErrorMessage("");
        setPost(false);

        setConfirmationModal(false);
        // clearState(setFormState);
        setAttachInvoiceLoading(false);
      }
      if (formState?.isReject) {
        setSuccessMessage(
          `Invoice ${formState?.invoice_No} has been Rejected Successfully`
        );
      } else {
        setSuccessMessage(
          `Invoice ${formState?.invoice_No} Approved Successfully`
        );
      }

      // setTimeout(() => {
      // navigate("/home", {
      //   state: {
      //     msg: `${
      //       formState?.isReject
      //         ? `Invoice ${formState?.invoice_No} Rejected Successfully`
      //         : `Invoice ${formState?.invoice_No} Submitted Successfully`
      //     }`,
      //   },
      // });
      // }, 3000);
    })
    .catch((err) => {
      if (err?.response?.data) {
        setErrorMessage(err?.response?.data?.title || err?.response?.data);
      } else {
        setErrorMessage(err?.message);
      }
      setAttachInvoiceLoading(false);
    });
};
const putDeptCoordinatorAndReviewerInvoice = async (
  formState,
  setFormState,
  setErrorMessage,
  setSuccessMessage,
  setAttachInvoiceLoading,
  navigate,
  setConfirmationModal,
  reviwerFlag,
  setPost,
  isParallel
) => {
  let data = {};
  const additionalDocIds = [];
  for (let i = 0; i < formState?.additionalDocIds?.length; i++) {
    const item = formState?.additionalDocIds[i];
    additionalDocIds.push(item?.path);
  }
  const transformedReviewers = [];

  if (formState?.loamReviewer !== undefined && formState?.loamReviewer !== "") {
    for (const [index, reviewer] of formState?.loamReviewer?.entries()) {
      
      const payload = {
        id: reviewer,
        sortOrder: !isParallel ? index + 1 : null,
      };
      transformedReviewers.push(payload);
    }
  }

  let url = "";
  setAttachInvoiceLoading(true);
  if (reviwerFlag) {
    data = {
      invoice_Id: Number(formState.invoice_Id),
      invoice_No: formState.invoice_No,
      // rtbId : formState?.rtbId,
      comments: formState.comments,
      aditional_Comments: formState.aditional_Comments,
      loam_Approver: formState?.loam_approver || "",
      updated_By: formState?.updated_By || "",
      additionalDocIds: additionalDocIds,
      loamReviewer: transformedReviewers,
      invoice_Accounts_list: [],
      // rtbLineItems_List: formState?.rtbLineItems_List,
      rtbLineItems_List :
  formState?.rtbLineItems_List?.map((item) => ({
    LineId: item.ID,
    RTBCode: item.RtbNo,
    Category: item.Category,
    VendorCode: item.VendorCode,
    InvoiceNo: formState.invoice_No,
    InvoiceId: formState.invoice_Id,
    I2PStatus: null,
    I2PInvoiceUrl: null,
    isFinalled: item.isFinalled,
  })) || [],
      // invoice_Accounts_list: formState.invoice_Accounts_list.map((item) => {
      //   return {
      //     ...item,
      //     profitCenter: item?.profitCenter
      //       ? item?.profitCenter.toString().padStart(10, "0")
      //       : "",
      //     amount: item?.amount.toString(),
      //     glAccount: item?.glAccount.split("-")[0],
      //     costCenter: item?.costCenter.split("-")[0],
      //   };
      // }),
      isReject: formState.isReject,
      ipUser: formState.ipUser,
      isParallel:isParallel
    };
    url = "PutReviewerInvoice";
  } else {
    const invoice_Accounts_list = formState.invoice_Accounts_list.map(
      (item) => {
        const { GLAccount, ...newItem } = item;
        return {
          ...newItem,
          profitCenter: item?.profitCenter
            ? item?.profitCenter.toString().padStart(10, "0")
            : "",
          amount: item?.amount.toString(),
          glAccount: item?.glAccount?.split("-")[0]?.trim(),
          costCenter: item?.costCenter?.split("-")[0]?.trim(),
        };
      }
    );
    const invoice_Accounts_filtered = invoice_Accounts_list.filter(
      (item) => item?.glAccount && item?.amount
    );

    data = {
      invoice_Id: Number(formState.invoice_Id),
      invoice_No: formState.invoice_No,
      comments: formState.comments,
      // rtbId : formState?.rtbId,
      aditional_Comments: formState.aditional_Comments,
      loam_Approver: formState.loam_approver,
      updated_By: formState.updated_By,
      additionalDocIds: additionalDocIds,
      loamReviewer: transformedReviewers,
      isReject: formState.isReject,
      invoice_Accounts_list: invoice_Accounts_filtered,
      isParallel:isParallel,
      ipUser: formState.ipUser,

      Agreement_Details : formState?.Agreement_Details , 
      FCA_Details : formState?.FCA_Details , 
      provinceDuty : formState?.provinceDuty , 
      stamp_Duty_Calculations : formState?.stamp_Duty_Calculations,
      stampDuty : formState?.stampDuty ,
      // rtbLineItems_List :formState?.rtbLineItems_List ,
      rtbLineItems_List :
  formState?.rtbLineItems_List?.map((item) => ({
    LineId: item.ID,
    RTBCode: item.RtbNo,
    Category: item.Category,
    VendorCode: item.VendorCode,
    InvoiceNo: formState.invoice_No,
    InvoiceId: formState.invoice_Id,
    I2PStatus: null,
    I2PInvoiceUrl: null,
    isFinalled: item.isFinalled,
  })) || [],
      // invoice_Accounts_list: formState.invoice_Accounts_list.map((item) => {
      //   return {
      //     ...item,
      //     costCenter: item?.costCenter?.CostCenterCode,
      //     costCenterOwner: item?.costCenter?.Name,
      //     costCenterOwnerName: item?.costCenter?.Owner,
      //     profitCenter: item?.profitCenter.toString(),
      //     amount: item?.amount.toString(),
      //   };
      // }),
    };

    console.log(data, "data")
    url = "PutDeptCoordinatorInvoice";
  }

  await axios({
    method: "put", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/${url}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  })
    .then(async (res) => {
      if (res.status === 200) {
        setErrorMessage("");
        setConfirmationModal(false);
        setAttachInvoiceLoading(false);
        setPost(false);
      }
      // setTimeout(() => {
      if (formState?.isReject) {
        setSuccessMessage(
          `Invoice ${formState.invoice_No} has been Rejected Successfully`
        );
        // navigate("/home", {
        //   state: {
        //     msg: `Invoice ${formState.invoice_No} has been Rejected Successfully`,
        //   },
        // });
      } else {
        setSuccessMessage(
          `Invoice ${formState.invoice_No} has been Reviewed Successfully`
        );
        // navigate("/home", {
        //   state: {
        //     msg: `Invoice ${formState.invoice_No} has been Submitted Successfully`,
        //   },
        // });
      }

      // }, 3000);
    })
    .catch((err) => {
      setConfirmationModal(false);
      if (err?.response?.data) {
        setErrorMessage(err?.response?.data?.title || err?.response?.data);
      } else {
        setErrorMessage(err?.message);
      }
      setAttachInvoiceLoading(false);
    });
};

const updateIPInvoice = async (
  formState,
  setFormState,
  poBasedState,
  setErrorMessage,
  setSuccessMessage,
  setAttachInvoiceLoading,
  navigate,
  importPaymentDetail,
  setPost,
  multipleData
) => {
  setAttachInvoiceLoading(true);
  const dataStringyfy = JSON.stringify(formState);
  const dataParse = JSON.parse(dataStringyfy);
  let invoice_Accounts = [];
  if (poBasedState !== "PO") {
    dataParse.vendor_Code = formState.vendor_Code.Vendor_Code;
  }

dataParse.rtbLineItems_List =
  formState?.rtbLineItems_List?.map((item) => ({
    LineId: item.ID,
    RTBCode: item.RtbNo,
    Category: item.Category,
    VendorCode: item.VendorCode,
    InvoiceNo: formState.invoice_No,
    InvoiceId: formState.invoice_Id,
    I2PStatus: null,
    I2PInvoiceUrl: null,
    isFinalled: item.isFinalled,
  })) || [];
  const invoice_Accounts_filtered = formState.invoice_Accounts.filter(
    (item) => item?.glAccount && item?.amount && item?.accountType
  );
   invoice_Accounts = invoice_Accounts_filtered?.map((item) => {
    return {
      ...item,
      profitCenter: item?.profitCenter
        ? item?.profitCenter?.toString().padStart(10, "0")
        : "",
      // amount: item?.amount.toString(),
      amount: Number(item?.amount)?.toFixed(2),
      glAccount: item?.glAccount?.split("-")[0]?.trim(),
      horizonId: item?.horizonId?.split("-")[0]?.trim(),
      vendorCode: item?.vendorCode?.split("-")[0]?.trim(),
      costCenter: item?.costCenter?.split("-")[0]?.trim(),
    };
  });
  if(formState.invoice_Accounts_list.length>0||formState.invoice_Accounts.length>0){
    if(formState.invoice_Type=="Final Settlement - Distributor"){
        invoice_Accounts = formState.invoice_Accounts_list?.map((item) => {
        const { rowId, ...rest } = item; // remove rowId
    return {
      ...rest,
      profitCenter: item?.profitCenter
        ? item?.profitCenter?.toString().padStart(10, "0")
        : "",
      // amount: item?.amount.toString(),
      vendor_Code:item?.vendor_Code?.split("-")[0]?.trim(),
      amount: (item?.amount=="" ||item?.amount=="NaN") ? 0 : Number(item?.amount)?.toFixed(2),
      glAccount: formState.invoice_Type=="Final Settlement - Distributor"?null:item?.glAccount?.split("-")[0]?.trim(),
      horizonId: item?.horizonId?.split("-")[0]?.trim(),
      vendorCode: item?.vendorCode?.split("-")[0]?.trim(),
      costCenter: item?.costCenter?.split("-")[0]?.trim(),
    };
  });
    }else{
   invoice_Accounts = formState.invoice_Accounts?.map((item) => {
        const { rowId, ...rest } = item; // remove rowId
    return {
      ...rest,
      profitCenter: item?.profitCenter
        ? item?.profitCenter?.toString().padStart(10, "0")
        : "",
      // amount: item?.amount.toString(),
      vendor_Code:item?.vendor_Code?.split("-")[0]?.trim(),
      amount: (item?.amount=="" ||item?.amount=="NaN") ? 0 : Number(item?.amount)?.toFixed(2),
      glAccount: formState.invoice_Type=="Final Settlement - Distributor"?null:item?.glAccount?.split("-")[0]?.trim(),
      horizonId: item?.horizonId?.split("-")[0]?.trim(),
      vendorCode: item?.vendorCode?.split("-")[0]?.trim(),
      costCenter: item?.costCenter?.split("-")[0]?.trim(),
    };
  });}
  }
  const additionalDocIds = [];
  for (let i = 0; i < formState?.additionalDocIds?.length; i++) {
    const item = formState?.additionalDocIds[i];
    additionalDocIds.push(item?.path);
  }
  dataParse.additionalDocIds = additionalDocIds;
  dataParse.invoice_attachment = formState?.invoice_attachment?.path || "";
  dataParse.invoice_Accounts = invoice_Accounts;
  dataParse.invoice_Amount = formState?.invoice_Amount?.toString();
  dataParse.invoice_Id = parseInt(formState.invoice_Id);
  // dataParse.additionalDocIds = formState.additionalDocIds[0];
  dataParse.pO_Based = poBasedState === "PO" ? true : false;
  dataParse.salesTaxCode = formState?.salesTaxCode?.split("-")[0];
  dataParse.invoice_TaxDetails = formState?.taxCard_List?.filter(
    (x) => x.category && x?.taxCode
  );
  const taxCard_List = [];
  for (let i = 0; i < dataParse?.invoice_TaxDetails?.length; i++) {
    const item = dataParse.taxCard_List[i];
    item.taxType = item["taxType"]?.split("-")[0]?.trim();
    item.taxCode = item["taxCode"]?.split("-")[0]?.trim();
    item.amount = item["amount"]?.toString();
    item.invoice_Id = Number(formState?.invoice_Id);
    taxCard_List.push(item);
  }
  dataParse.invoice_TaxDetails = taxCard_List;
  if(formState.isHR){
    if(formState.invoiceCategory=='Final Settlement – Death case'){
    dataParse.firstClearText=`${formState.invoice_No}CL`
    }
    dataParse.vendor_Code= invoice_Accounts_filtered[0]?.vendorCode?.split(" - ")[0] || "";
    dataParse.vendor_Name= invoice_Accounts_filtered[0]?.vendorCode;//n
  }
  delete dataParse.taxCard_ListCheck;
  delete dataParse.invoice_Accounts_list;
  dataParse.salesTaxAmount = formState?.salesTaxAmount?.toString();
  const vendor_Details = [];
  for (let j = 0; j < formState?.vendor_Details.length; j++) {
    const element = formState?.vendor_Details[j];
    const obj = {
      vendor_Code: element?.vendor_Code?.Vendor_Code,
      vendor_Name: element?.vendor_Name,
      amount: element?.amount?.toString(),
    };
    vendor_Details.push(obj);
  }
  dataParse.vendor_Details = vendor_Details;
  // invoice_Payment
  let invoice_Payment_Details = importPaymentDetail.invoice_Payment_Details.map(
    (item) => {
      return {
        ...item,
        costCenter: item?.costCenter?.split("-")[0]?.trim() || "",
        profitCenter: item?.profitCenter
          ? item?.profitCenter?.toString()?.padStart(10, "0")
          : "",
        // amount: item?.amount.toString(),
        amount: Number(item?.amount)?.toFixed(2),
        account: item?.account?.split("-")[0]?.trim(),
        advanceDocNo : item?.advanceDocNo || "", 
        advanceAmount : (item?.advanceAmount=="" ||item?.advanceAmount=="NaN") ? 0 : item?.advanceAmount,
        taxAmount:item?.taxAmount=="" ? 0: item?.taxAmount,
        postingKey: (() => {
          const pkList = multipleData?.postingKey || [];
          const match = pkList.find(pk => pk?.ReferenceCode === item?.postingKey);
          // If the posting key has a mapped counterpart (ReferenceProp3), use it; otherwise keep original
          return match?.ReferenceProp3 || item?.postingKey;
        })(),
        ReferencePostingKey: (() => {
          const pkList = multipleData?.postingKey || [];
          const match = pkList.find(pk => pk?.ReferenceCode === item?.postingKey);
          return match?.ReferenceCode;
        })(),

      };
    }
  );
  let poBasedPaymentDetail = {};
  if (formState.pO_Based) {
    const str = JSON.stringify(formState.invoice_Payment);
    const parsed = JSON.parse(str);
    parsed.postingKey = "0";
    poBasedPaymentDetail = parsed;
  }
  invoice_Payment_Details = invoice_Payment_Details.filter(
    (x) => x.postingKey && x.account
  );
  dataParse.isImport
    ? (dataParse.invoice_Payment = invoice_Payment_Details)
    : (dataParse.invoice_Payment = formState.pO_Based
        ? [poBasedPaymentDetail]
        : invoice_Payment_Details);

  // if(poBasedState !== "PO"){
  //   dataParse.invoice_Payment = importPaymentDetail.invoice_Payment_Details
  // }

  if (formState.pO_Based) {
    dataParse.invoice_Payment = [];
    dataParse.invoice_Payment[0] = poBasedPaymentDetail;
    // dataParse.invoice_Payment[0] = dataParse.invoice_Payment;
    dataParse.invoice_Payment[0].invoice_Id = parseInt(formState.invoice_Id);
  }
  // formState.pO_No &&
  //   (dataParse.invoice_Payment[0].dueOn =
  //     formState?.invoice_Payment?.dueOn);
  dataParse.due_Date = new Date(formState.invoice_Date);
  dataParse.invoice_Date = new Date(formState.invoice_Date);
  let transformData = [];
  // taxCard_List
  for (let i = 0; i < dataParse?.invoicePORef_List.length; i++) {
    const item = dataParse?.invoicePORef_List[i];
    const obj = {
      assetNumber: item?.assetNumber || "",
      balancE_QTY: item?.balancE_QTY || "",
      balancE_VAL: item?.balancE_VAL || "",
      conD_COUNT: item?.conD_COUNT || "",
      conD_ST_NO: item?.conD_ST_NO || "",
      currency: item?.currency || "",
      disT_IND: item?.disT_IND || "",
      dN_NO: item?.dN_NO || "",
      created_on: item?.created_on || moment().format("YYYY-MM-DD"),
      doc_Date: item?.doc_Date || "",
      doC_YEAR: item?.doC_YEAR || "",
      delivUnit: item?.delivUnit || "",
      // inpuT_QTY: item?.inpuT_QTY || "",
      inpuT_QTY: item?.inpuT_QTY?.toString() || "0",
      inpuT_VAL: item?.inpuT_VAL?.toString() || "0",
      invoicE_QTY: item?.invoicE_QTY.toString() || "0",
      invoicE_VAL: item?.invoicE_VAL.toString() || "0",
      kschl: item?.kschl || "",
      ordeR_QTY: item?.ordeR_QTY || "",
      ordeR_UNIT: item?.ordeR_UNIT || "",
      poItem: item?.poItem || "",
      poItemText: item?.poItemText || "",
      poNumber: item?.poNumber || "",
      plant: item?.plant || "",
      uniT_PRICE : item.uniT_PRICE, 
      // inpuT_VAL: item?.inpuT_VAL || "",
      quantity: item?.quantity.toString() || "",
      refDoc: item?.refDoc || "",
      reF_DOC_IT: item?.rEF_DOC_IT || "",
      reF_DOC_NO: item?.reF_DOC_NO || "",
      reF_DOC_NO_LONG: item?.reF_DOC_NO_LONG || "",
      seQ_NO: item?.seQ_NO || "",
      sheeT_ITEM: item?.sheeT_ITEM || "",
      po_Ref_Id: 1,
      sO_ITEM: item?.sO_ITEM || "",
      sO_NO: item?.sO_NO || "",
      vText: item?.vText || "",
      invoice_Id: item?.invoice_Id || 0,
      created_by: item?.created_by || "",
      val_Loccur: item?.val_Loccur.toString() || "",
      // Vendor_Code: item?.Vendor_Code || "",
      // Vendor_Name: item?.Vendor_Name//n
    };
    if (
      formState.isImport &&
      (obj.inpuT_QTY !== "0" || obj.inpuT_VAL !== "0")
    ) {
      transformData.push(obj);
    } else if (!formState.isImport) {
      transformData.push(obj);
    }
  }
  dataParse.pO_Details = transformData;

  if (dataParse.vP_InvoiceId == null) {
    dataParse.vP_InvoiceId = 0;
  }
  if((dataParse?.vendor_Code?.Vendor_Code!=""||dataParse.vendor_Code!=="") && dataParse.pO_Based){
  dataParse.vendor_Code=dataParse.vendor_Code?.Vendor_Code||dataParse.vendor_Code
  }

  await axios({
    method: "post", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/IP/UpdateIPInvoice`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    data: dataParse,
  })
    .then(async (res) => {
      if (res.status === 200) {
        setPost(false);
        setErrorMessage("");

        // setSuccessMessage(
        //   `Invoice ${formState.invoice_No} has been Submitted Successfully`
        // );
        // setTimeout(() => {
        setAttachInvoiceLoading(false);
        clearState(setFormState);
        // setSuccessMessage(res?.data);
        navigate("/home", {
          state: {
            msg: res?.data,
          },
        });
        // navigate("/home", {
        //   state: {
        //     // msg: `Invoice ${formState.invoice_No} has been Submitted Successfully`,
        //     msg: `${res?.data} `,
        //   },
        // });
        // }, 3000);
      }
    })
    .catch((err) => {
      setAttachInvoiceLoading(false);
      if (err?.response?.data) {
        setErrorMessage(
          err?.response?.data?.title ||
            err?.response?.data?.Message ||
            err?.response?.data?.Messages ||
            err?.response?.data
        );
      } else {
        setErrorMessage(err?.message);
      }
    });
};

const updateLogisticsInvoice = async (
  data,
  formState,
  setErrorMessage,
  setSuccessMessage,
  setAttachInvoiceLoading,
  navigate,
  roles
) => {
  setAttachInvoiceLoading(true);
  await axios({
    method: "put", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/PutLogistics`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  })
    .then(async (res) => {
      if (res.status === 200) {
        setErrorMessage("");

        // setSuccessMessage(
        //   `Invoice ${formState.invoice_No} has been Send to IR Successfully`
        // );

        setAttachInvoiceLoading(false);
        navigate("/home", {
          state: {
            msg: `Invoice ${formState.invoice_No} has been Send to IR Successfully`,
          },
        });

        // setTimeout(() => {
        //   setAttachInvoiceLoading(false);
        // //  check if IR ROLE Id exist
        //   const IRRole = roles?.filter((item) => {
        //     return item.roleId === "b5f43efb-f59b-4378-bc3a-586ee4ee7346";
        //   });

        // // move to IR from  Logistics
        //   if (IRRole.length !== 0  ) {
        //    navigate(
        //         `/newInvoice?invoiceId=${res.data}&roleId=b5f43efb-f59b-4378-bc3a-586ee4ee7346&roleName=IR&edit=true`
        //       );
        //     }  else {
        //     navigate("/home");
        //   }

        // }, 3000);
      }
    })
    .catch((err) => {
      setAttachInvoiceLoading(false);
      if (err?.response?.data) {
        setErrorMessage(
          err?.response?.data?.title ||
            err?.response?.data?.Message ||
            err?.response?.data
        );
      } else {
        setErrorMessage(err?.message);
      }
    });
};

const updateIPInvoiceByImport = async (
  formState,
  invoiceTaxDetail,
  importPaymentDetail,
  setFormState,
  poBasedState,
  setErrorMessage,
  setSuccessMessage,
  setAttachInvoiceLoading,
  navigate
) => {
  setAttachInvoiceLoading(true);
  const dataStringyfy = JSON.stringify(formState);
  const dataParse = JSON.parse(dataStringyfy);
  dataParse.invoice_Id = parseInt(formState.invoice_Id);
  dataParse.pO_Based = poBasedState === "PO" ? true : false;
  dataParse.salesTaxAmount = formState?.salesTaxAmount?.toString();
  dataParse.invoice_Payment_Details = []; // will use for non po
  dataParse.invoice_Tax_Details = invoiceTaxDetail.invoice_TaxDetails; // tax table  invoice_TaxDetails
  dataParse.invoice_Accounts_Details = formState.invoice_Accounts; // G/L Account
  dataParse.pO_Details = formState.invoicePORef_List; // pO_Details
  dataParse.invoice_Payment_Details =
    importPaymentDetail?.invoice_Payment_Details || []; // payment table
  await axios({
    method: "put", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/IP/PutIPForShippingDemand`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    data: dataParse,
  })
    .then(async (res) => {
      if (res.status === 200) {
        setErrorMessage("");
        // setSuccessMessage(
        //   `Invoice ${formState.invoice_No} Submitted Successfully`
        // );
        // setTimeout(() => {
        setAttachInvoiceLoading(false);
        clearState(setFormState);
        navigate("/home", {
          state: {
            msg: `Invoice ${formState.invoice_No} has been Submitted Successfully`,
          },
        });
        // }, 3000);
      }
    })
    .catch((err) => {
      setAttachInvoiceLoading(false);
      if (err?.response?.data) {
        setErrorMessage(err?.response?.data?.title || err?.response?.data);
      } else {
        setErrorMessage(err?.message);
      }
    });
};

const getCommentsByInvoiceId = async (
  setCommentsList,
  setCommentsLoading,
  invoice_id,
  setcount
) => {
  setCommentsLoading(true);

  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getCommentByInvoiceId/${invoice_id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      setCommentsList(res.data);
      setCommentsLoading(false);
      setcount(res.data.length);
    })
    .catch((err) => {});
};
const getCommentsByERFInvoiceNo = async (
  setCommentsList,
  setCommentsLoading,
  invoice_id,
  setcount
) => {
  setCommentsLoading(true);
  const data = {
    RequestNo: invoice_id,
  };
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetERFCommentsByRequestNo`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
  })
    .then(async (res) => {
      setCommentsList(res.data);
      setCommentsLoading(false);
      setcount(res.data.length);
    })
    .catch((err) => {});
};



const getCommentsByARFInvoiceNo = async (
  setCommentsList,
  setCommentsLoading,
  invoice_id,
  setcount
) => {
  setCommentsLoading(true);
  const data = {
    RequestNo: invoice_id,
  };
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetARFCommentsByRequestNo`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
  })
    .then(async (res) => {
      setCommentsList(res.data);
      setCommentsLoading(false);
      setcount(res.data.length);
    })
    .catch((err) => {});
};


const clearState = (setFormState) => {
  setFormState((formState) => ({
    ...formState,
    // isInitiator: false,
    // isDeptCordinator: false,
    // isHR: false,
    // isPCDV: false, // EFDV initiator
    // isVPPayment: false,
    // isVFPayment: false,
    // isSubmittedByVendor: false,
    // isImport: false,
    // isLogistics: false,
    submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,

    // LogisticInvoices: false,
    // VendorPrePayment: false,
    eInvoice: true,

    invoice_Id: 0,
    grn_No: "",
    pO_No: "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: 0,
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    invoice_Date: new Date(),
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: "", // paths
    comments: "",
    updated_By: "ABC",

    // additionalDocIds_array: [], // additional documents in array
    invoice_Accounts_list: [
      {
        glAccount: "",
        costCenter: "",
        costCenterOwner: "",
        costCenterOwnerName: "",
        horizonId: "",
        vendorCode: "",
        amount: 0,
        profitCenter: "",
        department: "",
      },
    ],

    invoicePORef_List: [
      {
        po_Ref_Id: 0,
        reF_DOC_IT: "",
        val_Loccur: "", // GRN amount
        currency: "", // currency
        quantity: "", // GRN quantity
        delivUnit: "",
        poNumber: "", // poNumber
        poItem: "", //  item #
        poItemText: "",
        refDoc: "", // GRN No
        plant: "",
        uniT_PRICE : "",
        reF_DOC_NO: "",
        reF_DOC_NO_LONG: "",
        assetNumber: "",
        kschl: "",
        vText: "",
        invoice_Id: 0,
        created_by: "",
        created_on: new Date(),
        invoicE_QTY: "", //  consumed quantity
        invoicE_VAL: "", // consumed Amount
        balancE_QTY: "",
        balancE_VAL: "",
        inpuT_QTY: "0", //  invoice QTY
        inpuT_VAL: "0", //  Invoice amount
        conD_ST_NO: "",
        conD_COUNT: "",
        doC_YEAR: "",
        sheeT_ITEM: "",
        dN_NO: "",
        seQ_NO: "",
        disT_IND: "",
        ordeR_UNIT: "",
        ordeR_QTY: "",
        doc_Date: "",
        sO_NO: "",
        sO_ITEM: "",
      },
    ],

    Expense_Accounts_list: [
      // Invoice_Accounts_list for back-end
      {
        expenseDate: "",
        description: "",
        amount: 0,
        glAccount: "",
        costCenter: "",
        fixedAsset: "",
        tType: "",
        profitCenter: "",
        costCenterOwner: "",
        costCenterOwnerName: "",
        horizonId: "",
        vendorCode: "",
        department: "",
      },
    ],
    Invoice_Clearingvendor_list: [
      {
        vendorCode: "",
        VendorName: "",
        amount: "",
      },
    ],
    verified: false,
  }));
};

const getInvoiceByInvoiceIdAndRoleId = async (
  // setIsLoading,
  invoicePayload,
  role,
  setFormState,
  setPoBasedState,
  setNewFormState
) => {
  const data = {
    Id: invoicePayload?.Invoice_id,
    RoleId: role?.roleId,
  };
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/getInvoiceByIdRoleWise_v1`,
    // url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getInvoiceByIdRoleWise`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
  })
    .then(async (res) => {
      const resData = res?.data?.data || res?.data;

      // const multi_attach =
      //   resData?.additionalDocIds != null
      //     ? resData?.additionalDocIds.split(" ")
      //     : "";

      const multi_attach = res?.data?.addtionalAttachments?.map((item) => {
        return {
          ...item,
          path: item?.fPath + item?.fileName || "",
        };
      });
      const invoice_attach = res?.data?.attachments?.map((item) => {
        return {
          ...item,
          path: item?.fPath + item?.fileName || "",
        };
      });
      
      if (role?.roleName === "AP Supervisor") {
        setNewFormState((formState) => ({
          ...formState,
          refrence_DocNo: resData?.invoice_No,
        }));
      }
      const startDate = moment(resData?.invoice_Date);
      const endDate = moment();

      // Calculate the number of days between the two dates
      const daysBetween = endDate.diff(startDate, "days");
      const daysToSalesTax = 180 - daysBetween;
      const uniqueReviewerList = resData?.loamReviewer
      ?.split(" ")
      ?.filter((reviewer) => reviewer);
      if (role?.roleName === "IP") {
        setFormState((formState) => ({
          ...formState,
                    vP_InvoiceId: resData?.vP_InvoiceId,
          isInitiator: resData?.isInitiator || false,
          searchWith: resData?.searchWith,
          isDeptCordinator: resData?.isDeptCordinator
            ? true
            : resData?.isDeptCordinator === null
            ? false
            : false,
          isHR: resData?.isHR || false,
          isPCDV: resData?.isPCDV || false, // EFDV initiator
          isVPPayment: resData?.isVPPayment || false,
          isVFPayment: resData?.isVFPayment || false,
          isSubmittedByVendor: resData?.isSubmittedByVendor || false,
          isImport: resData?.isImport || false,
          isLogistics: resData?.isLogistics || false,
          pO_Based: resData?.pO_Based,
          po_Date : resData?.po_Date,
          due_Date : resData?.due_Date, 
          plant_Code : resData?.plant_Code,
          isPSID: resData?.isPSID || false,
          psid: resData?.psid,
          urgent: resData?.urgent,
          skipTaxStep: resData?.skipTaxStep,
          courier_Tracking_No: resData?.courier_Tracking_No,
          daysto_sale_taxlapse: daysToSalesTax,
          // LogisticInvoices: false,
          // VendorPrePayment: false,
          // VendorFinancingPayment: false,
          invoice_Id: invoicePayload?.Invoice_id,
          pO_No: resData?.pO_No,
          pcdvLocation: resData?.pcdvLocation,
          pcdvSegment: resData?.pcdvSegment,
          grn_No: resData?.grn_No,
          delv_Note_No: resData?.delv_Note_No,
          loamReviewer:
          uniqueReviewerList && uniqueReviewerList[0] == undefined
          ? []
          : uniqueReviewerList,
          loam_approver: resData?.loam_approver,
          barcode_No: resData?.barcode_No,
          demandType: resData?.demandType,
          invoice_Type: resData?.invoice_Type,
          invoice_No: resData?.invoice_No,
          salesTaxCode: resData?.salesTaxCode,
          salesTaxAmount: resData?.salesTaxAmount,
          invoiceCategory: resData?.invoiceCategory,
          invoice_Desc: resData?.invoice_Desc,
          invoice_Amount: resData?.invoice_Amount,
          invoice_Amount_formatted: Number(
            resData?.invoice_Amount
          )?.toLocaleString(),
          final_Invoice_Amount: resData?.final_Invoice_Amount,
          dept_coordinator: resData?.dept_coordinator,
          grn_No: resData?.grn_No,
          irUser: resData?.irUser,
          ipUser: resData?.ipUser,
          taxTeam: resData?.taxTeam,
          calculateTax: resData?.calculateTax,
          // adjustAdvance : resData?.adjustAdvance,
          // rtbId : resData?.rtbId,
          // vendor_Code: resData?.vendor_Code,
           vendor_Code: resData?.pO_Based
            ? resData?.vendor_Code
            : {
                Vendor_Code: resData?.vendor_Code,
                Vendor_Name: res?.data?.vendor_Name?.vendor_Name,
              },
          // invoice_Date: resData?.invoice_Date.slice(0, -9),
          invoice_Date: moment(resData?.invoice_Date).format("YYYY-MM-DD"),
 
          vendor_Name:
            (resData?.vendor_Code || "") +
            "-" +
            (res?.data?.vendor_Name?.vendor_Name || ""),
          // vendor_Name: resData?.vendor_Name,
          lineManager: resData?.lineManager,
          directorHR: resData?.directorHR,
          sharedServices: resData?.sharedServices,
          invoice_attachment: invoice_attach[0],
          additionalDocIds: multi_attach,
          distributor_Code : resData?.distributor_Code
          // paths
          // comments:resData?.comments,

          // invoice_Accounts_list: [
          //   {
          //     glAccount: "",
          //     costCenter: "",
          //     costCenterOwner: "",
          //     costCenterOwnerName: "",
          //     horizonId: "",
          //     vendorCode: "",
          //     amount: 0,
          //     profitCenter: "",
          //     department: "",
          //   },
          // ],
          // Expense_Accounts_list: [
          //   // Invoice_Accounts_list for back-end
          //   {
          //     expenseDate: "",
          //     description: "",
          //     amount: 0,
          //     glAccount: "",
          //     costCenter: "",
          //     fixedAsset: "",
          //     tType: "",
          //     profitCenter: "",
          //     costCenterOwner: "",
          //     costCenterOwnerName: "",
          //     horizonId: "",
          //     vendorCode: "",
          //     department: "",
          //   },
          // ],
          // Invoice_Clearingvendor_list: [
          //   {
          //     vendorCode: "",
          //     VendorName: "",
          //     amount: "",
          //   },
          // ],
          // verified: false,
        }));
      } else if (role.roleName == "Department Coordinator") {
        setFormState((formState) => ({
          ...formState,
                    vP_InvoiceId: resData?.vP_InvoiceId,
          isInitiator: resData?.isInitiator || false,
          searchWith: resData?.searchWith,
          isDeptCordinator: resData?.isDeptCordinator
            ? true
            // : resData?.isSubmittedByVendor == true
            // ? true
            : false,
          isHR: resData?.isHR || false,
          isPCDV: resData?.isPCDV || false, // EFDV initiator
          isVPPayment: resData?.isVPPayment || false,
          isVFPayment: resData?.isVFPayment || false,
          isSubmittedByVendor: resData?.isSubmittedByVendor || false,
          isImport: resData?.isImport || false,
          isLogistics: resData?.isLogistics || false,
          po_Date : resData?.po_Date,
          due_Date : resData?.due_Date, 
          plant_Code : resData?.plant_Code,
          courier_Tracking_No: resData?.courier_Tracking_No,
          pO_Based: resData?.pO_Based,
          isPSID: resData?.isPSID || false,
          pcdvLocation: resData?.pcdvLocation,
          pcdvSegment: resData?.pcdvSegment,
          psid: resData?.psid,
          urgent: resData?.urgent,
          skipTaxStep: resData?.skipTaxStep,
          daysto_sale_taxlapse: daysToSalesTax,
          invoice_Id: invoicePayload?.Invoice_id,
          pO_No: resData?.pO_No,
          grn_No: resData?.grn_No,
          delv_Note_No: resData?.delv_Note_No,
          // adjustAdvance : resData?.adjustAdvance,
          barcode_No: resData?.barcode_No,
          demandType: resData?.demandType,
          invoice_Type: resData?.invoice_Type,
          invoice_No: resData?.invoice_No,
          salesTaxCode: resData?.salesTaxCode,
          salesTaxAmount: resData?.salesTaxAmount,
          loamReviewer:
          uniqueReviewerList && uniqueReviewerList[0] == undefined
          ? []
          : uniqueReviewerList,
          loam_approver: resData?.loam_approver,
          logisticsTeam: resData?.logisticsTeam,
          firstClearText: res?.data?.inv_prc?.firstClearingText,
          secondClearText: res?.data?.inv_prc?.secondClearingText,
          invoiceCategory: resData?.invoiceCategory,
          invoice_Desc: resData?.invoice_Desc,
          invoice_Amount: resData?.invoice_Amount,
          invoice_Amount_formatted: Number(
            resData?.invoice_Amount
          )?.toLocaleString(),
          final_Invoice_Amount: resData?.final_Invoice_Amount,
          dept_coordinator:
            resData?.isSubmittedByVendor && !resData?.pO_Based
              ? resData?.dept_coordinator
                ? resData?.dept_coordinator
                : user?.LoginId
              : resData?.dept_coordinator,
          irUser: resData?.irUser,
          ipUser: role?.roleName === "IR" ? user?.LoginId : resData?.ipUser,
          taxTeam: resData?.taxTeam,

          //RTB work
          // rtbId : resData?.rtbId,

          // vendor_Code: "",
          // vendor_Code: resData?.vendor_Code,
          vendor_Code: resData?.pO_Based
            ? resData?.vendor_Code
            : {
                Vendor_Code: resData?.vendor_Code,
                Vendor_Name: res?.data?.vendor_Name?.vendor_Name,
              },
          vendor_Name:
            (resData?.vendor_Code || "") +
            "-" +
            (res?.data?.vendor_Name?.vendor_Name || ""),
          // invoice_Date: resData?.invoice_Date.slice(0, -9),
          invoice_Date: moment(resData?.invoice_Date).format("YYYY-MM-DD"),
          lineManager: resData?.lineManager,
          directorHR: resData?.directorHR,
          sharedServices: resData?.sharedServices,
          invoice_attachment: invoice_attach[0],
          // invoice_attachment: resData?.invoice_attachment,
          additionalDocIds: multi_attach, // paths
          comments: resData?.isSubmittedByVendor ? resData?.comments : "",
          buyer: resData?.buyer,
          prInitiator: resData?.prInitiator,
          isQuickPay: resData?.isSubmittedByVendor,
          distributor_Code : resData?.distributor_Code
        }));
      } else {
        setFormState((formState) => ({
          ...formState,
                    mpasEFDV:resData?.mpasEFDV,
          vP_InvoiceId:resData?.vP_InvoiceId,
          isInitiator: resData?.isInitiator || false,
          searchWith: resData?.searchWith,
          isDeptCordinator: resData?.isDeptCordinator
            ? true
            // : resData?.isSubmittedByVendor  == true
            // ? true
            : false,
          isHR: resData?.isHR || false,
          isPCDV: resData?.isPCDV || false, // EFDV initiator
          isVPPayment: resData?.isVPPayment || false,
          isVFPayment: resData?.isVFPayment || false,
          isSubmittedByVendor: resData?.isSubmittedByVendor || false,
          isImport: resData?.isImport || false,
          isLogistics: resData?.isLogistics || false,
          courier_Tracking_No: resData?.courier_Tracking_No,
          po_Date : resData?.po_Date,
          due_Date : resData?.due_Date, 
          plant_Code : resData?.plant_Code,
          pO_Based: resData?.pO_Based,
          isPSID: resData?.isPSID || false,
          pcdvLocation: resData?.pcdvLocation,
          pcdvSegment: resData?.pcdvSegment,
          psid: resData?.psid,
          urgent: resData?.urgent,
          skipTaxStep: resData?.skipTaxStep,
          daysto_sale_taxlapse: daysToSalesTax,
          invoice_Id: invoicePayload?.Invoice_id,
          pO_No: resData?.pO_No,
          grn_No: resData?.grn_No,
          delv_Note_No: resData?.delv_Note_No,
          mpasEFDV : resData?.mpasEFDV , 
          barcode_No: resData?.barcode_No,
          demandType: resData?.demandType,
          invoice_Type: resData?.invoice_Type,
          invoice_No: resData?.invoice_No,
          salesTaxCode: resData?.salesTaxCode,
          salesTaxAmount: resData?.salesTaxAmount,
          loam_approver: resData?.loam_approver,
          logisticsTeam: resData?.logisticsTeam,
          firstClearText: res?.data?.inv_prc?.firstClearingText,
          secondClearText: res?.data?.inv_prc?.secondClearingText,
          invoiceCategory: resData?.invoiceCategory,
          invoice_Desc: resData?.invoice_Desc,
          distributor_Code : resData?.distributor_Code,
          invoice_Amount: resData?.invoice_Amount,
          invoice_Amount_formatted: Number(
            resData?.invoice_Amount
          )?.toLocaleString(),
          final_Invoice_Amount: resData?.final_Invoice_Amount,
          dept_coordinator:
            resData?.isSubmittedByVendor && !resData?.pO_Based
              ? resData?.dept_coordinator
                ? resData?.dept_coordinator
                : user?.LoginId
              : resData?.dept_coordinator,
          irUser: resData?.irUser,
          ipUser: role?.roleName === "IR" ? user?.LoginId : resData?.ipUser,
          taxTeam: resData?.taxTeam,

          // vendor_Code: "",
          // vendor_Code: resData?.vendor_Code,
          vendor_Code: resData?.pO_Based
            ? resData?.vendor_Code
            : {
                Vendor_Code: resData?.vendor_Code,
                Vendor_Name: res?.data?.vendor_Name?.vendor_Name,
                designation: res?.data?.vendor_Name?.designation,
                department: res?.data?.vendor_Name?.department
              },
          vendor_Name:
            (resData?.vendor_Code || "") +
            "-" +
            (res?.data?.vendor_Name?.vendor_Name || ""),
          // invoice_Date: resData?.invoice_Date.slice(0, -9),
          invoice_Date: moment(resData?.invoice_Date).format("YYYY-MM-DD"),
          lineManager: resData?.lineManager,
          directorHR: resData?.directorHR,
          sharedServices: resData?.sharedServices,
          invoice_attachment: invoice_attach[0],
          // invoice_attachment: resData?.invoice_attachment,
          additionalDocIds: multi_attach, // paths
          comments: resData?.isSubmittedByVendor ? resData?.comments : "",
          buyer: resData?.buyer,
          prInitiator: resData?.prInitiator,
          isQuickPay: resData?.isSubmittedByVendor,
          comments:"",
          // adjustAdvance : resData?.adjustAdvance,
          //  loamReviewer:
          // uniqueReviewerList && uniqueReviewerList[0] == undefined
          // ? []
          // : uniqueReviewerList,
        //RTB work
        // rtbId : resData?.rtbId
        }));
      }

      if (resData?.pO_Based && !resData?.isLogistics && resData?.pO_No) {
        getVendorByPO(resData?.pO_No, "vendor_Code", setFormState);
      } else if (!resData?.pO_Based && resData?.pO_No) {
        const data = {
          po_no: resData.invoice_Type === "ITN" ? resData?.pO_No : "",
          dn_no: resData.invoice_Type === "DN" ? resData?.pO_No : "",
        };
        const fun = () => {};

        getDN_ITN_Details(
          data,
          fun,
          fun,
          invoicePayload?.Invoice_id,
          fun,
          setFormState
        );
      }

      //
      // if(setIsLoading!==null || setIsLoading!==null ){
      //   setIsLoading(false)
      // }
      setPoBasedState(resData?.pO_Based === true ? "PO" : "Non-PO");
    })
    .catch((err) => {});
};

const getBatchInvoiceDetails = async (
  setTaxFormState,
  setImportPaymentDetail,
  setMultipleData,
  invoicePayload,
  role,
  setFormState,
  setDataLoading,
  setPoBasedState
) => {
  const data = {
    invoice_id: invoicePayload?.Invoice_id,
  };
  setDataLoading(true);
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/VFTreasury/GetBatchInvoiceDetails`,
    // url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getInvoiceByIdRoleWise`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
  })
    .then(async (res) => {
      setDataLoading(false);
      const resData = res?.data?.eeP_I2P_Invoice_Details_List[0];
      const response = res?.data?.eeP_I2P_Invoice_Processing_List[0];
      const vendorRes = res?.data?.eeP_I2P_Vendor_List[0];

      const multi_attach = res?.data?.additional_Attachment?.map((item) => {
        return {
          ...item,
          path: item?.fPath + item?.fileName || "",
        };
      });
      const invoice_attach = res?.data?.attachment?.map((item) => {
        return {
          ...item,
          path: item?.fPath + item?.fileName || "",
        };
      });

      const startDate = moment(resData?.invoice_Date);
      const endDate = moment();

      let invoice_Payment = {};
      if (res?.data?.paymentDetail?.length > 0) {
        invoice_Payment = res?.data?.paymentDetail[0];
        invoice_Payment.dueOn = new Date(invoice_Payment?.dueOn)
          ?.toISOString()
          .split("T")[0];
      }
      const finded = res?.data?.vendorTaxDetail?.vendorTax?.find(
        (x) => x.invoice_Id === invoicePayload?.Invoice_id
      );

      const newData = [];
      for (let i = 0; i < res?.data?.glAccount?.length; i++) {
        let obj = res?.data?.glAccount[i];
        let obj1 = {};

        obj1.rowId = Math.random();
        obj1.accountId = obj?.AccountId || 0;
        obj1.invoice_Id = obj?.Invoice_Id || 0;
        obj1.glAccount = obj?.GLAccount || "";
        obj1.costCenter = obj?.CostCenter;
        // obj1.costCenter = { CostCenterCode: obj?.CostCenter || "" };
        obj1.accountType = obj?.AccountType || "";
        obj1.amount = Number(obj?.Amount) || 0;
        obj1.costCenterOwner = obj?.CostCenterOwner || "";
        obj1.CostCenterOwnerName = obj?.CostCenterOwnerName || "";
        obj1.stCode = obj?.StCode || "";
        obj1.order = obj?.Order || "";
        obj1.profitCenter = Number(obj?.ProfitCenter) || "";
        obj1.wbsElement = obj?.WBSElement || "";
        obj1.created_By = obj?.Created_By || "";
        obj1.created_On = obj?.Created_On || new Date();
        obj1.updated_By = obj?.Updated_By || "";
        obj1.updated_On = obj?.Updated_On || new Date();
        obj1.fixedAsset = obj?.FixedAsset || "";
        obj1.tType = obj?.TType || "";
        obj1.description = obj?.Description || "";
        obj1.expenseDate = obj?.ExpenseDate || new Date();
        obj1.horizonId = obj?.HorizonId || "";
        obj1.department = obj?.Department || "";
        obj1.vendorCode = obj?.VendorCode || "";
        newData.push(obj1);
      }

      const updatedPOData = res?.data?.eeP_I2P_Invoice_PO_Ref_List.map(
        (item) => ({
          ...item,
          inpuT_QTY: Number(item.inpuT_QTY) || Number(item.INPUT_QTY),
          inpuT_VAL: Number(item.inpuT_VAL) || Number(item.INPUT_VAL),
        })
      );
      // Calculate the number of days between the two dates
      const daysBetween = endDate.diff(startDate, "days");
      const daysToSalesTax = 180 - daysBetween;
      const isTaxAmt = isNaN(Number(finded?.salesTaxAmount));
      const clearingvendor = [];
      for (
        let i = 0;
        i < res?.data?.eeP_I2P_Invoice_ClearingVendor_list?.length;
        i++
      ) {
        let object = res?.data?.eeP_I2P_Invoice_ClearingVendor_list[i];

        let vendorObj = {};
        vendorObj.vendor_Code = {
          Vendor_Code: object.vendorCode,
        };
        vendorObj.vendor_Name = object.vendor_Name;
        vendorObj.amount = Number(object.amount);
        clearingvendor.push(vendorObj);
      }

      setMultipleData((setMultipleData) => ({
        ...setMultipleData,
        glAccount: res?.data?.glAccount || [],
        paymentDetail: res?.data?.paymentDetail || [],
        // invoice_Payment: res?.data?.paymentDetail[0] || [],
        invoice_Payment: invoice_Payment || [],
        // invoice_Details: res?.data?.invoice_Details[0] || [],
        efdv_Invoices: res?.data?.efdv_Invoices || [],
        erf_ExpenseInvoice_Detail: res?.data?.pitStop || [],
        fer_Invoice_Detial: res?.data?.fer || [],
        // paymentMethod: res?.data?.paymentMethod || [],
        // paymentMethodSupp: res?.data?.paymentMethodSupp || [],
        // poData: res?.data?.eeP_I2P_Invoice_PO_Ref_List || [],
        poData: updatedPOData || [],
        vendorTaxDetail: res?.data?.vendorTaxDetail || [],
      }));
      if (role?.roleName === "IP") {
        setFormState((formState) => ({
          ...formState,
                    isInitiator: resData?.isInitiator || false,
          searchWith: resData?.searchWith,
          isDeptCordinator: resData?.isDeptCordinator ? true : false,
          isHR: resData?.isHR || false,
          isPCDV: resData?.isPCDV || false, // EFDV initiator
          isVPPayment: resData?.isVPPayment || false,
          isVFPayment: resData?.isVFPayment || false,
          isSubmittedByVendor: resData?.isSubmittedByVendor || false,
          isImport: resData?.isImport || false,
          isLogistics: resData?.isLogistics || false,
          pO_Based: resData?.pO_Based,
          isPSID: resData?.isPSID || false,
          psid: resData?.psid,
          urgent: resData?.urgent,
          skipTaxStep: resData?.skipTaxStep,
          courier_Tracking_No: resData?.courier_Tracking_No,
          daysto_sale_taxlapse: daysToSalesTax,
          // LogisticInvoices: false,
          // VendorPrePayment: false,
          // VendorFinancingPayment: false,
          invoice_Id: invoicePayload?.Invoice_id,
          pO_No: resData?.pO_No,
          pcdvLocation: resData?.pcdvLocation,
          pcdvSegment: resData?.pcdvSegment,
          grn_No: resData?.grn_No,
          delv_Note_No: resData?.delv_Note_No,
          loam_approver: resData?.loam_approver,
          barcode_No: resData?.barcode_No,
          demandType: resData?.demandType,
          invoice_Type: resData?.invoice_Type,
          invoice_No: resData?.invoice_No,
          salesTaxAmount: isTaxAmt ? "" : finded?.salesTaxAmount || "",
          salesTaxCode: finded?.salesTaxCode,
          invoiceCategory: resData?.invoiceCategory,
          invoice_Desc: resData?.invoice_Desc,
          invoice_Amount: resData?.invoice_Amount,
          invoice_Amount_formatted: resData?.invoice_Amount?.toLocaleString(),
          final_Invoice_Amount: resData?.final_Invoice_Amount,
          dept_coordinator: resData?.dept_coordinator,
          grn_No: resData?.grn_No,
          irUser: resData?.irUser,
          ipUser: resData?.ipUser,
          taxTeam: resData?.taxTeam,
          // vendor_Code: resData?.vendor_Code,
          // vendor_Code: resData?.pO_Based
          //   ? resData?.vendor_Code
          //   : {
          //       Vendor_Code: resData?.vendor_Code,
          //       Vendor_Name: res?.data?.vendor_Name?.vendor_Name,
          //     },
          vendor_Code: resData?.pO_Based
            ? resData?.vendor_Code
            : {
                Vendor_Code: vendorRes?.vendor_Code,
                Vendor_Name: vendorRes?.vendor_Name,
              },
          // invoice_Date: resData?.invoice_Date.slice(0, -9),
          invoice_Date: moment(resData?.invoice_Date).format("YYYY-MM-DD"),
          vendor_Name:
            (vendorRes?.vendor_Code || "") +
            "-" +
            (vendorRes.vendor_Name || ""),
          // vendor_Name: resData?.vendor_Name,
          lineManager: resData?.lineManager,
          directorHR: resData?.directorHR,
          sharedServices: resData?.sharedServices,
          invoice_attachment: invoice_attach[0],
          additionalDocIds: multi_attach, // paths
          comments: "",
          invoice_Payment: invoice_Payment,
          invoice_Payment_Details: res?.data?.paymentDetail,
          invoice_Accounts: newData || [],
          invoice_Accounts_list: res?.data?.glAccount || [],
          taxCard_List: res?.data?.vendorTaxDetail?.taxDetail || [],
          taxCard_ListCheck: res?.data?.vendorTaxDetail?.taxDetail || [],
          invoice_TaxDetails: res?.data?.vendorTaxDetail?.taxDetail || [],
          // invoicePORef_List: res?.data?.eeP_I2P_Invoice_PO_Ref_List || [],
          invoicePORef_List: updatedPOData || [],

          // invoiceDebugData_List: res?.data?.debugData || [],
          fsDocumentDate: resData?.FSDocumentDate || "",
          fsDocumentNumber: resData?.FSDocumentNumber || "",
          vendor_Details: clearingvendor,
          firstClearText: res?.data?.inv_prc?.firstClearingText,
          secondClearText: res?.data?.inv_prc?.secondClearingText,

          // invoice_Accounts_list: [
          //   {
          //     glAccount: "",
          //     costCenter: "",
          //     costCenterOwner: "",
          //     costCenterOwnerName: "",
          //     horizonId: "",
          //     vendorCode: "",
          //     amount: 0,
          //     profitCenter: "",
          //     department: "",
          //   },
          // ],
          // Expense_Accounts_list: [
          //   // Invoice_Accounts_list for back-end
          //   {
          //     expenseDate: "",
          //     description: "",
          //     amount: 0,
          //     glAccount: "",
          //     costCenter: "",
          //     fixedAsset: "",
          //     tType: "",
          //     profitCenter: "",
          //     costCenterOwner: "",
          //     costCenterOwnerName: "",
          //     horizonId: "",
          //     vendorCode: "",
          //     department: "",
          //   },
          // ],
          // Invoice_Clearingvendor_list: [
          //   {
          //     vendorCode: "",
          //     VendorName: "",
          //     amount: "",
          //   },
          // ],
          // verified: false,
        }));
      } else {
        setFormState((formState) => ({
          ...formState,
                    isInitiator: resData?.isInitiator,
          searchWith: resData?.searchWith,
          isDeptCordinator: resData?.isDeptCordinator ? true : false,
          isHR: resData?.isHR || false,
          isPCDV: resData?.isPCDV, // EFDV initiator
          isVPPayment: resData?.isVPPayment,
          isVFPayment: resData?.isVFPayment,
          isSubmittedByVendor: resData?.isSubmittedByVendor,
          isImport: resData?.isImport,
          isLogistics: resData?.isLogistics,
          courier_Tracking_No: resData?.courier_Tracking_No,
          pO_Based: resData?.pO_Based,
          isPSID: resData?.isPSID,
          pcdvLocation: resData?.pcdvLocation,
          pcdvSegment: resData?.pcdvSegment,
          psid: resData?.psid,
          urgent: resData?.urgent,
          skipTaxStep: resData?.skipTaxStep,
          daysto_sale_taxlapse: daysToSalesTax,
          invoice_Id: invoicePayload?.Invoice_id,
          pO_No: resData?.pO_No,
          grn_No: resData?.grn_No,
          delv_Note_No: resData?.delv_Note_No,

          barcode_No: resData?.barcode_No,
          demandType: resData?.demandType,
          invoice_Type: resData?.invoice_Type,
          invoice_No: resData?.invoice_No,
          loam_approver: resData?.loam_approver,
          logisticsTeam: resData?.logisticsTeam,

          invoiceCategory: resData?.invoiceCategory,
          invoice_Desc: resData?.invoice_Desc,
          invoice_Amount: resData?.invoice_Amount,
          invoice_Amount_formatted: Number(
            resData?.invoice_Amount
          )?.toLocaleString(),
          final_Invoice_Amount: resData?.final_Invoice_Amount,
          dept_coordinator: resData?.dept_coordinator,
          irUser: resData?.irUser,
          ipUser: resData?.ipUser,
          // resData?.ipUser || role?.roleName === "IR" ? user?.LoginId : "",
          taxTeam: resData?.taxTeam,
          // vendor_Code: "",
          // vendor_Code: resData?.vendor_Code,
          vendor_Code: resData?.pO_Based
            ? resData?.vendor_Code
            : {
                Vendor_Code: vendorRes?.vendor_Code,
                Vendor_Name: vendorRes?.vendor_Name,
              },
          vendor_Name:
            (vendorRes?.vendor_Code || "") +
            "-" +
            (vendorRes?.vendor_Name || ""),
          // invoice_Date: resData?.invoice_Date?.slice(0, -9),
          invoice_Date: moment(resData?.invoice_Date).format("YYYY-MM-DD"),
          lineManager: resData?.lineManager,
          directorHR: resData?.directorHR,
          sharedServices: resData?.sharedServices,
          invoice_attachment: invoice_attach[0],
          additionalDocIds: multi_attach, // paths

          //  invoice_attachment:invoice_attach ,
          currency: response?.currency,
          fiscal_Year: response?.fiscal_Year,
          posting_Date: response?.posting_Date,
          document_No: response?.saP_Posting_Id,
          documents_Reference:
            res?.data?.eeP_I2P_Invoice_ClearingDetail_List[0]?.referenceNo,
          newInvoice_Desc: response?.newInvoice_Desc,
          invoice_Payment: invoice_Payment,
          invoice_Payment_Details:
            role?.roleName === "AP Supervisor" ? res?.data?.paymentDetail : [],

          // invoice_Accounts: newData || [],
          invoice_Accounts_list: res?.data?.glAccount || [],
          taxCard_List: res?.data?.vendorTaxDetail?.taxDetail || [],
          taxCard_ListCheck: res?.data?.vendorTaxDetail?.taxDetail || [],
          invoice_TaxDetails: res?.data?.vendorTaxDetail?.taxDetail || [],
          // invoicePORef_List: res?.data?.eeP_I2P_Invoice_PO_Ref_List || [],
          invoicePORef_List: updatedPOData || [],
          salesTaxAmount: isTaxAmt ? "" : finded?.salesTaxAmount || "",
          salesTaxCode: finded?.salesTaxCode || "",
          // invoiceDebugData_List: res?.data?.debugData || [],
          fsDocumentDate: resData?.FSDocumentDate || "",
          fsDocumentNumber: resData?.FSDocumentNumber || "",
          vendor_Details: clearingvendor,
          firstClearText: res?.data?.inv_prc?.firstClearingText,
          secondClearText: res?.data?.inv_prc?.secondClearingText,
          // comments: resData?.comments,
        }));
      }
      setTaxFormState((taxFormState) => ({
        ...taxFormState,
        salesTaxCode: finded?.salesTaxCode || "",
        salesTaxAmount: finded?.salesTaxAmount || "",
        taxCard_List: res?.data?.vendorTaxDetail?.taxDetail || [],
        // additionalDocIds:res?.data?.additionalDocIds.split(" "),
        // comments:res?.data?.comments
      }));
      setImportPaymentDetail((importPaymentDetail) => ({
        ...importPaymentDetail,
        invoice_Payment_Details: [...res?.data?.paymentDetail],
      }));
      setPoBasedState(resData?.pO_Based === true ? "PO" : "Non-PO");
    })
    .catch((err) => {});
};
const getTaxCode = async (setTaxCodeList, setTaxCodeListLoading) => {
  const taxCode = localStorage.getItem("getTaxCode");
  if (!taxCode) {
    setTaxCodeListLoading(true);
    await axios({
      method: "get", //you can set what request you want to be
      url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getTaxCode`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        const duplicate = res.data?.filter((obj, index, self) => {
          return (
            index ===
            self.findIndex(
              (o) =>
                o.TaxCode === obj.TaxCode &&
                o.Description === obj.Description &&
                o.TaxType === "ST"
            )
          );
        });
        setTaxCodeList(duplicate);
        localStorage.setItem("getTaxCode", JSON.stringify(duplicate));
        // setTaxCodeList(res.data);

        setTaxCodeListLoading(false);
      })
      .catch((err) => {
        setTaxCodeListLoading(false);
      });
  } else {
    const data = JSON.parse(taxCode);
    setTaxCodeList(data);
    setTaxCodeListLoading(false);
  }
};

const getTaxCodeWithBlock = async (setTaxCodeList, setTaxCodeListLoading) => {
  const taxCode = localStorage.getItem("getTaxCodeBlock");
  // if (!taxCode) {
  setTaxCodeListLoading(true);
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getTaxCodeV2`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      const whCodes = [];
      const stCodes = [];
      res.data.forEach((item) => {
        if (item.TaxType == "WHT") whCodes.push(item);
        else if (item.TaxType == "ST")
          stCodes.push(item.S_TAX_CODE + " - " + item.DESCRIPTION);
      });
      setTaxCodeList(res.data);
      localStorage.setItem("getTaxCodeBlock", JSON.stringify(res.data));
      setTaxCodeListLoading(false);
    })
    .catch((err) => {
      setTaxCodeListLoading(false);
    });
};

const getTaxCodeWithDuplicate = async (
  setTaxCodeList,
  setTaxCodeListLoading
) => {
  const taxCode = localStorage.getItem("getTaxCodeDuplicate");

  if (!taxCode) {
    setTaxCodeListLoading(true);
    await axios({
      method: "get", //you can set what request you want to be
      // url: "http://192.168.202.198:9093/api/InvoiceDetails/getTaxCode",
      url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getTaxCode`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        const duplicate = res.data?.filter((obj, index, self) => {
          return (
            index ===
            self.findIndex(
              (o) =>
                o.TaxCode === obj.TaxCode &&
                o.Description === obj.Description &&
                o.TaxType === "ST"
            )
          );
        });
        localStorage.setItem("getTaxCodeDuplicate", JSON.stringify(res.data));
        setTaxCodeList(res.data);
        setTaxCodeListLoading(false);
      })
      .catch((err) => {
        setTaxCodeListLoading(false);
      });
  } else {
    const data = JSON.parse(taxCode);
    setTaxCodeList(data);
    setTaxCodeListLoading(false);
  }
};

// for tax table
const getTaxCard = async (
  setTaxTableDropdownData,
  setTaxCardLoading,
  setTaxCardData
) => {
  const TaxTableDropdownCategory = localStorage.getItem(
    "TaxTableDropdownCategory"
  );
  const TaxTableDropdownPurchaseType = localStorage.getItem(
    "TaxTableDropdownPurchaseType"
  );
  const TaxTableDropdownSupplierJurisdiction = localStorage.getItem(
    "TaxTableDropdownSupplierJurisdiction"
  );
  const TaxTableDropdownSupplierType = localStorage.getItem(
    "TaxTableDropdownSupplierType"
  );
  const TaxTableDropdownStatus = localStorage.getItem("TaxTableDropdownStatus");
  const TaxCardData = localStorage.getItem("TaxCardData");
  if (
    !TaxTableDropdownCategory ||
    !TaxTableDropdownPurchaseType ||
    !TaxTableDropdownSupplierJurisdiction ||
    !TaxTableDropdownSupplierType ||
    !TaxTableDropdownStatus ||
    !TaxCardData
  ) {
    setTaxCardLoading(true);
    await axios({
      method: "get", //you can set what request you want to be
      url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getTaxCard`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        let categories = [
          ...new Map(res.data.map((item) => [item["category"], item])).values(),
        ];
        let purchaseType = [
          ...new Map(
            res.data.map((item) => [item["purchaseType"], item])
          ).values(),
        ];
        let supplierJurisdiction = [
          ...new Map(
            res.data.map((item) => [item["supplierJurisdiction"], item])
          ).values(),
        ];
        let supplierType = [
          ...new Map(
            res.data.map((item) => [item["supplierType"], item])
          ).values(),
        ];
        let status = [
          ...new Map(res.data.map((item) => [item["status"], item])).values(),
        ];
        let fillingStatus = [
          ...new Map(
            res.data.map((item) => [item["fillingStatus"], item])
          ).values(),
        ];
        let goodsNature = [
          ...new Map(
            res.data.map((item) => [item["goodsNature"], item])
          ).values(),
        ];

        setTaxTableDropdownData((taxTableDropdownData) => ({
          ...taxTableDropdownData,
          category: categories,
          purchaseType: purchaseType,
          supplierJurisdiction: supplierJurisdiction,
          supplierType: supplierType,
          status: status,
          // fillingStatus: fillingStatus,
          // goodsNature: goodsNature,
        }));
        setTaxCardData(res.data);
        setTaxCardLoading(false);

        localStorage.setItem(
          "TaxTableDropdownCategory",
          JSON.stringify(categories)
        );
        localStorage.setItem(
          "TaxTableDropdownPurchaseType",
          JSON.stringify(purchaseType)
        );
        localStorage.setItem(
          "TaxTableDropdownSupplierJurisdiction",
          JSON.stringify(supplierJurisdiction)
        );
        localStorage.setItem(
          "TaxTableDropdownSupplierType",
          JSON.stringify(supplierType)
        );
        localStorage.setItem("TaxTableDropdownStatus", JSON.stringify(status));
        localStorage.setItem("TaxCardData", JSON.stringify(res.data));
      })
      .catch((err) => {
        setTaxCardLoading(false);
      });
  } else {
    setTaxTableDropdownData((taxTableDropdownData) => ({
      ...taxTableDropdownData,
      category: JSON.parse(TaxTableDropdownCategory),
      purchaseType: JSON.parse(TaxTableDropdownPurchaseType),
      supplierJurisdiction: JSON.parse(TaxTableDropdownSupplierJurisdiction),
      supplierType: JSON.parse(TaxTableDropdownSupplierType),
      status: JSON.parse(TaxTableDropdownStatus),
      // fillingStatus: fillingStatus,
      // goodsNature: goodsNature,
    }));
    setTaxCardData(JSON.parse(TaxCardData));
    setTaxCardLoading(false);
  }
};
const getTaxCardV2 = async (setTaxCardLoading, setTaxCardData) => {
  const getTaxCard = localStorage.getItem("getTaxCard");

  if (!getTaxCard) {
    setTaxCardLoading(true);
    await axios({
      method: "get", //you can set what request you want to be
      url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getTaxCard`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        setTaxCardData(res.data);
        setTaxCardLoading(false);

        localStorage.setItem("getTaxCard", JSON.stringify(res.data));
      })
      .catch((err) => {
        setTaxCardLoading(false);
      });
  } else {
    // setTaxTableDropdownData((taxTableDropdownData) => ({
    //   ...taxTableDropdownData,
    //   category: JSON.parse(TaxTableDropdownCategory),
    //   purchaseType: JSON.parse(TaxTableDropdownPurchaseType),
    //   supplierJurisdiction: JSON.parse(TaxTableDropdownSupplierJurisdiction),
    //   supplierType: JSON.parse(TaxTableDropdownSupplierType),
    //   status: JSON.parse(TaxTableDropdownStatus),
    //   // fillingStatus: fillingStatus,
    //   // goodsNature: goodsNature,
    // }));
    setTaxCardData(JSON.parse(getTaxCard));
    setTaxCardLoading(false);
  }
};

const getTaxCodeByTaxCardId = async (
  setTaxTableDropdownData,
  setFormState,
  formState,
  tempArray,
  index,
  id,
  Invoice_id,
  invoice_Amount
) => {
  // setTaxCardLoading(true);

  if (id !== undefined) {
    await axios({
      method: "get", //you can set what request you want to be
      url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getTaxCodeByTaxCardId/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        let responseData = [];
        for (let i = 0; i < res.data.length; i++) {
          const element = res.data[i];
          const obj = {
            taxType: element["Tax Type"]?.split("-")[0].replace(/ /g, ""),
            taxType_v1: element["Tax Type"],
            taxId: "",
            taxCode: element["WHT Code"]?.split("-")[0].replace(/ /g, ""),
            taxCode_1: element["WHT Code"],
          };
          responseData.push(obj);
        }

        setTaxTableDropdownData((taxTableDropdownData) => ({
          ...taxTableDropdownData,
          taxType: responseData,
          taxCode: responseData,
        }));
        let transformDataa = [];

        // Deep copy
        const stringified = JSON.stringify(responseData);
        const parsed = JSON.parse(stringified);

        for (let i = 0; i < parsed.length; i++) {
          let item = parsed[i];
          item.invoice_Id = Invoice_id;
          item.amount = invoice_Amount;
          // item.amount = formSt ate?.invoice_Amount || "";
          item.taxCodeDes = item?.taxCode;
          item.taxCode = item?.taxCode_1;
          item.taxTypeDes = item?.taxType;
          item.taxType = item?.taxType_v1;
          transformDataa.push(item);
        }
        tempArray[index] = {
          ...formState.taxCard_List[index],
          // [bindingName.name]: binding[0][bindingName?.name],
          taxType: responseData[0].taxType,
          taxCode: responseData[0].taxCode,
          dropdowns: {
            ...formState.taxCard_List[index].dropdowns,
            taxType: responseData,
            taxCode: responseData,
          },
        };

        setFormState((formState) => ({
          ...formState,
          taxCard_List: tempArray,
        }));
        // setTaxCardLoading(false);
      })
      .catch((err) => {
        // setTaxCardLoading(false);
      });
  }
};

const getTaxCodeByTaxCardIdForIP = async (
  setTaxTableDropdownData,
  setFormState,
  formState,
  tempArray,
  index,
  id,
  Invoice_id,
  invoice_Amount
) => {
   // setTaxCardLoading(true);

  if (id !== undefined) {
    await axios({
      method: "get", //you can set what request you want to be
      url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getTaxCodeByTaxCardId/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        if (formState.taxCard_List.length !== 0) return;
        let responseData = [];
        for (let i = 0; i < res.data.length; i++) {
          const element = res.data[i];
          const obj = {
            taxType: element["Tax Type"]?.split("-")[0].replace(/ /g, ""),
            taxType_v1: element["Tax Type"],
            taxId: "",
            taxCode: element["WHT Code"]?.split("-")[0].replace(/ /g, ""),
            taxCode_1: element["WHT Code"],
          };
          responseData.push(obj);
        }

        setTaxTableDropdownData((taxTableDropdownData) => ({
          ...taxTableDropdownData,
          taxType: responseData,
        }));

        tempArray[index] = {
          ...formState.taxCard_List[index],
          // [bindingName.name]: binding[0][bindingName?.name], 
          taxType: responseData[0].taxType,
          dropdowns: {
            ...formState.taxCard_List[index].dropdowns,
            taxType: responseData,
          },
        };
        const whtCodeRes = await axios({
          method: "get",
          url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getWHTCodeByTaxType/${responseData[0].taxType}`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
            "Content-Type": "application/json",
          },
          // Add any additional parameters or configuration as needed
        });
        if (whtCodeRes) {
          let responseWHTData = [];
          //take  WHT code from taxtype APi and merge it with whtCodeRes response
          responseWHTData = responseData.map((item) => ({
            taxCode: item?.taxCode,
            taxCode_1: item?.taxCode_1,
          }));
          for (let index = 0; index < whtCodeRes.data.length; index++) {
            const element = whtCodeRes.data[index];
            const obj = {
              taxCode: element["WHT Code"]?.split("-")[0].replace(/ /g, ""),
              taxCode_1: element["WHT Code"],
            };

            responseWHTData.push(obj);
          }

          tempArray[index] = {
            ...formState.taxCard_List[index],
            // [bindingName.name]: binding[0][bindingName?.name],
            taxCode: responseWHTData[0]?.taxCode,
            dropdowns: {
              ...formState.taxCard_List[index].dropdowns,
              taxCode: responseWHTData,
            },
          };

          setFormState((formState) => ({
            ...formState,
            taxCard_List: tempArray,
          }));
        }
        //WHT if loop
        setFormState((formState) => ({
          ...formState,
          taxCard_List: tempArray,
        }));
        // setTaxCardLoading(false);
      })
      .catch((err) => {
        // setTaxCardLoading(false);
      });
  }
};
const getTaxCodeByTaxCardIdByDefault = async (
  setTaxTableDropdownData,
  setFormState,
  formState
) => {
  // setTaxCardLoading(true);

  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getTaxCodeByTaxCardId/1`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      let responseData = [];
      for (let i = 0; i < res.data.length; i++) {
        const element = res.data[i];
        const obj = {
          taxType: element["Tax Type"]?.split("-")[0].replace(/ /g, ""),
          taxType_v1: element["Tax Type"],
          taxId: "",
          taxCode: element["WHT Code"]?.split("-")[0].replace(/ /g, ""),
          taxCode_1: element["WHT Code"],
        };
        responseData.push(obj);
      }
      setTaxTableDropdownData((taxTableDropdownData) => ({
        ...taxTableDropdownData,
        taxType: responseData,
        taxCode: responseData,
      }));
      let transformDataa = [];

      // Deep copy

      setFormState((prevFormState) => ({
        ...prevFormState,
        taxCard_List: prevFormState.taxCard_List.map((item, index) => {
          if (index === 0) {
            return {
              ...item,
              dropdowns: {
                ...item.dropdowns,
                taxType: responseData,
                taxCode: responseData,
              },
              taxType: responseData[0].taxType,
              taxCode: responseData[0].taxCode,
            };
          }
          return item;
        }),
      }));

      // setTaxCardLoading(false);
    })
    .catch((err) => {
      // setTaxCardLoading(false);
    });
};
const getWHTCodeByTaxType = async (
  setTaxTableDropdownData,
  setFormState,
  formState,
  tempArray,
  index,
  taxType
) => {
  // setTaxCardLoading(true);
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getWHTCodeByTaxType/${taxType}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      let responseData = [];

      for (let index = 0; index < res.data.length; index++) {
        const element = res.data[index];
        const obj = {
          taxCode: element["WHT Code"]?.split("-")[0].replace(/ /g, ""),
          taxCode_1: element["WHT Code"],
        };
        responseData.push(obj);
      }
      if (formState?.salesTaxCode === "51") {
        tempArray[index] = {
          ...formState.taxCard_List[index],
          // [bindingName.name]: binding[0][bindingName?.name],
          // taxCode: responseData[1].taxCode,
          taxCode: "CG",
        };
      } else if (formState?.salesTaxCode === "31") {
        tempArray[index] = {
          ...formState.taxCard_List[index],
          // [bindingName.name]: binding[0][bindingName?.name],
          // taxCode: responseData[8].taxCode,
          taxCode: "CX",
        };
      }

      tempArray[index] = {
        ...formState.taxCard_List[index],
        // [bindingName.name]: binding[0][bindingName?.name],

        dropdowns: {
          ...formState.taxCard_List[index].dropdowns,
          taxCode: responseData,
        },
      };

      setFormState((formState) => ({
        ...formState,
        taxCard_List: tempArray,
      }));
      // setTaxTableDropdownData((taxTableDropdownData) => ({
      //   ...taxTableDropdownData,
      //   taxCode: responseData,
      // }));
      // setTaxCardLoading(false);
    })
    .catch((err) => {
      // setTaxCardLoading(false);
    });
};

const getWHTCodeByTaxCode = async (setFormState, formState, salesTaxCode) => {
  for (let i = 0; i < formState?.taxCard_List?.length; i++) {
    await axios({
      method: "get", //you can set what request you want to be
      url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getWHTCodeByTaxType/${formState?.taxCard_List[i]?.taxType}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        let responseData = [];

        for (let index = 0; index < res.data.length; index++) {
          const element = res.data[index];
          const obj = {
            taxCode: element["WHT Code"]?.split("-")[0].replace(/ /g, ""),
            taxCode_1: element["WHT Code"],
          };
          responseData.push(obj);
        }

        if (salesTaxCode === "51") {
          formState.taxCard_List[i] = {
            ...formState.taxCard_List[i],
            // [bindingName.name]: binding[0][bindingName?.name],
            // taxCode: responseData[8].taxCode,
            taxCode: "CG",
          };
        } else if (salesTaxCode === "31") {
          formState.taxCard_List[i] = {
            ...formState.taxCard_List[i],
            // [bindingName.name]: binding[0][bindingName?.name],
            // taxCode: responseData[8].taxCode,
            taxCode: "CX",
          };
        }

        setFormState((formState) => ({
          ...formState,
          taxCard_List: formState.taxCard_List,
        }));
      })
      .catch((err) => {
        // setTaxCardLoading(false);
      });
  }
};
// this is used for  table and text field of tax
const vendorTaxDetail = async (
  setTaxTableDropdownData,
  setFormState,
  formState,
  vendor_Code,
  Invoice_id,
  invoice_Amount,
  setTaxCardLoading
) => {
  // setTaxCardLoading(true);
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getVendorTaxDetail/${vendor_Code}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      let responseData = [];
      for (let index = 0; index < res?.data?.taxDetail?.length; index++) {
        const element = res?.data?.taxDetail[index];
        const obj = {
          taxType: element.taxType_v1, // code
          taxType_v1: element.taxType, // des
          taxId: "",
          taxCode: element.taxCode_1,
          taxCode_1: element.taxCode,
        };
        responseData.push(obj);
      }
      setTaxTableDropdownData((taxTableDropdownData) => ({
        ...taxTableDropdownData,
        taxType: responseData,
        taxCode: responseData,
      }));
      const finded = res.data?.vendorTax[0];
      let transformDataa = [];

      // Deep copy
      const stringified = JSON.stringify(res?.data?.taxDetail);
      const parsed = JSON.parse(stringified);

      for (let i = 0; i < parsed.length; i++) {
        let item = parsed[i];
        item.invoice_Id = Invoice_id;
        item.amount = invoice_Amount;
        // item.amount = formState?.invoice_Amount || "";
        item.taxCode = item?.taxCode_1; // code
        item.taxCode_1 = item?.taxCode; // des
        item.taxType = item?.taxType_v1; // code
        item.taxType_v1 = item?.taxType; // des
        transformDataa.push(item);
      }
      const isTaxAmt = isNaN(
        Number(finded?.SalesTaxAmount || finded?.salesTaxAmount)
      );
      setFormState((formState) => ({
        ...formState,
        salesTaxCode: finded?.SalesTaxCode?.split(" ")?.[0] || "",
        salesTaxAmount: isTaxAmt
          ? ""
          : finded?.SalesTaxAmount || finded?.salesTaxAmount || "",
        taxCard_List: transformDataa,
        taxCard_ListCheck: transformDataa, // this is stored to check, Is there data of tax of that vendor.
      }));
      // setTaxCardLoading(false);
    })
    .catch((err) => {
      // setTaxCardLoading(false);
    });
};

const vendorTaxDetailForCnic = async (
  setFormState,
  vendor_Code,
  setCount,
  formState
) => {
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/sap-endpoint/vendor-tax-detail/${vendor_Code}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      const taxTypeList = res?.data?.map((i) => {
        return i.Tax_Type + " - " + i.Description;
      });
      setFormState((formState) => ({
        ...formState,
        taxType_list: res.data.Message ? [] : taxTypeList,
        vendor_tax_detail: res.data.Message ? [] : res.data,
        cnic: res.data?.[0]?.CNIC,
        ntn: res.data?.[0]?.NTN,
      }));
      // setCount(parseInt(res?.data?.vendor_tax_detail[0].TotalNumberOfRecords))
    })
    .catch((err) => {});
};
const normalizeId = (value) =>
  value === 0 || value === "0" || value === "" || value == null ? "null" : value;
// gell All Invoice data at IP
const changeInvoiceStatus = async (
  // rtbId,
  invoice_Id,
  statusForPayload,
  setConfirmationModal,
  setAttachInvoiceLoading,
  setSuccessMessage,
  setErrorMessage,
  navigate,
  comments,
  aditional_Comments,
  setPost
) => {
  const data = {
  // rtbId: normalizeId(rtbId),
    invoice_id: invoice_Id,
    Status: statusForPayload,
    Comments: statusForPayload === "Deleted" ? "Deleted" : comments,
    Additional_Comment: aditional_Comments || "",
  };
  setAttachInvoiceLoading !== "" && setAttachInvoiceLoading(true);

  await axios({
    method: "put", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/ChangeInvoiceStatus`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
  })
    .then(async (res) => {
      // setSuccessMessage("Request submitted Successfully");
      setConfirmationModal(false);
      // setTimeout(() => {
      //   setAttachInvoiceLoading(false);
      //   navigate("/home");
      // }, 3000);
      setAttachInvoiceLoading(false);
      setPost(false);
      if (statusForPayload === "SendToIR") {
        // setSuccessMessage(`Invoice has been Recall Successfully`);
        navigate("/home", {
          state: {
            msg: `Invoice has been Recall Successfully`,
          },
        });
      } else if (statusForPayload === "Reject") {
        setSuccessMessage(`Invoice has been Recall Successfully`);

        // navigate("/home", {
        //   state: {
        //     msg: `Invoice has been recalled Successfully`,
        //   },
        // });
      } else {
        setSuccessMessage(
          statusForPayload != "Deleted"
            ? `Invoice has been Submitted Successfully`
            : `Invoice has been Deleted Successfully`
        );
        navigate("/home", {
          state: {
            msg:
              statusForPayload !== "Deleted"
                ? `Invoice has been Submitted Successfully`
                : `Invoice has been Deleted Successfully`,
          },
        });
      }
    })
    .catch((err) => {
      if (err?.response?.data) {
        setErrorMessage(err?.response?.data?.title || err?.response?.data);
        setAttachInvoiceLoading(false);
      } else {
        setErrorMessage(err?.message);
      }
    });
};
const ChangeInvoiceStatus_V1 = async (
  invoice_Id,
  statusForPayload,
  setConfirmationModal,
  setAttachInvoiceLoading,
  setSuccessMessage,
  setErrorMessage,
  navigate,
  comments,
  setPost
) => {
  const data = {
    invoice_id: invoice_Id,
    Status: statusForPayload,
    Comments: statusForPayload === "Deleted" ? "Deleted" : comments,
  };

  const requestdata = ["string"];

  setAttachInvoiceLoading(true);

  await axios({
    method: "put", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/ChangeInvoiceStatus_V1`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
    data: requestdata,
  })
    .then(async (res) => {
      // setSuccessMessage("Request submitted Successfully");
      setPost(false);
      setConfirmationModal(false);

      // setTimeout(() => {
      //   setAttachInvoiceLoading(false);
      //   navigate("/home");
      // }, 3000);
      setAttachInvoiceLoading(false);

      if (statusForPayload === "SendToIR") {
        setSuccessMessage(`Invoice has been Recall Successfully`);
        // navigate("/home", {
        //   state: {
        //     msg: `Invoice has been Recall Successfully`,
        //   },
        // });
      } else {
        setSuccessMessage(
          statusForPayload != "Deleted"
            ? `Invoice has been Submitted Successfully`
            : `Invoice has been Deleted Successfully`
        );
        // navigate("/home", {
        //   state: {
        //     msg:
        //       statusForPayload != "Deleted"
        //         ? `Invoice has been Submitted Successfully`
        //         : `Invoice has been Deleted Successfully`,
        //   },
        // });
      }
    })
    .catch((err) => {
      if (err?.response?.data) {
        setErrorMessage(err?.response?.data?.title || err?.response?.data);
        setAttachInvoiceLoading(false);
      } else {
        setErrorMessage(err?.message);
        setAttachInvoiceLoading(false);
      }
    });
};
const updateBuyerInvoice = async (
  data,
  formState,
  setFormState,
  poBasedState,
  setErrorMessage,
  setSuccessMessage,
  setAttachInvoiceLoading,
  navigate,
  importPaymentDetail,
  setPost
) => {
  setAttachInvoiceLoading(true);

  await axios({
    method: "put", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/PutBuyerInvoice`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  })
    .then(async (res) => {
      if (res.status === 200) {
        setErrorMessage("");
        setSuccessMessage(
          `Invoice ${formState.invoice_No} has been send to IR Successfully`
        );
        // setTimeout(() => {
        setAttachInvoiceLoading(false);
        clearState(setFormState);
        setPost(false);
        // navigate("/home", {
        //   state: {
        //     msg: `Invoice ${formState.invoice_No} has been send to IR Successfully`,
        //   },
        // });
        // }, 3000);
      }
    })
    .catch((err) => {
      if (err?.response?.data) {
        setErrorMessage(err?.response?.data?.title || err?.response?.data);
        setAttachInvoiceLoading(false);
      } else {
        setErrorMessage(err?.message);
      }
    });
};

const putLM_SSM_DHR = async (
  data,
  formState,
  setFormState,
  setErrorMessage,
  setSuccessMessage,
  setAttachInvoiceLoading,
  navigate,
  setPost
) => {
  setAttachInvoiceLoading(true);

  await axios({
    method: "put", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/PutHrProcess`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  })
    .then(async (res) => {
      if (res.status === 200) {
        setErrorMessage("");
        setPost(false);
        setSuccessMessage(
          `Invoice ${formState.invoice_No} has been submitted Successfully`
        );
        // setTimeout(() => {
        setAttachInvoiceLoading(false);
        clearState(setFormState);
        // navigate("/home", {
        //   state: {
        //     msg: `Invoice ${formState.invoice_No} has been submited Successfully`,
        //   },
        // });
        // }, 3000);
      }
    })
    .catch((err) => {
      if (err?.response?.data) {
        setErrorMessage(err?.response?.data?.title || err?.response?.data);
        setAttachInvoiceLoading(false);
      } else {
        setErrorMessage(err?.message);
      }
    });
};

const getAllInvoiceDetailByInvoiceId = async (
  setFormState,
  setMultipleData,
  Invoice_id,
  setTaxFormState,
  setImportPaymentDetail,
  role,
  setDataLoading
) => {
  const data = {
    InvoiceId: Invoice_id,
  };
  setDataLoading(true);
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/getAllInvoiceDataByInvoiceId`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
  })
    .then(async (res) => {
      setDataLoading(false);
      const invoiceDetail = res.data?.invoice_Details[0];
      // SkipTaxStep
      let invoice_Payment = {};
      if (res?.data?.paymentDetail?.length > 0) {
        invoice_Payment = res?.data?.paymentDetail[0];
        invoice_Payment.dueOn = new Date(invoice_Payment?.dueOn)
          ?.toISOString()
          .split("T")[0];
      }

      const updatedPOData = res?.data?.poData.map((item) => ({
        ...item,
        inpuT_QTY: Number(item.inpuT_QTY) || Number(item.INPUT_QTY),
        inpuT_VAL: Number(item.inpuT_VAL) || Number(item.INPUT_VAL),
        plant_Code : item?.plant
      }));
      setMultipleData((setMultipleData) => ({
        ...setMultipleData,
        glAccount: res?.data?.glAccount || [],
        paymentDetail: res?.data?.paymentDetail || [],
        // invoice_Payment: res?.data?.paymentDetail[0] || [],
        invoice_Payment: invoice_Payment || [],
        invoice_Details: res?.data?.invoice_Details[0] || [],
        efdv_Invoices: res?.data?.efdv_Invoices || [],
        erf_ExpenseInvoice_Detail: res?.data?.pitStop || [],
        fer_Invoice_Detial: res?.data?.fer || [],
        // paymentMethod: res?.data?.paymentMethod || [],
        // paymentMethodSupp: res?.data?.paymentMethodSupp || [],
        // poData: res?.data?.poData || [],
        poData: updatedPOData || [],

        vendorTaxDetail: res?.data?.vendorTaxDetail || [],
      }));
      const finded = res?.data?.vendorTaxDetail?.vendorTax?.find(
        (x) => x.invoice_Id === Invoice_id
      );
      const newData = [];
      for (let i = 0; i < res?.data?.glAccount?.length; i++) {
        let obj = res?.data?.glAccount[i];
        let obj1 = {};

        obj1.rowId = Math.random();
        obj1.accountId = obj?.AccountId || 0;
        obj1.invoice_Id = obj?.Invoice_Id || 0;
        obj1.glAccount = obj?.GLAccount || "";
        obj1.costCenter = obj?.CostCenter;
        // obj1.costCenter = { CostCenterCode: obj?.CostCenter || "" };
        obj1.accountType = obj?.AccountType || "";
        obj1.amount = Number(obj?.Amount) || 0;
        obj1.costCenterOwner = obj?.CostCenterOwner || "";
        obj1.CostCenterOwnerName = obj?.CostCenterOwnerName || "";
        obj1.stCode = obj?.StCode || "";
        obj1.order = obj?.Order || "";
        obj1.profitCenter = Number(obj?.ProfitCenter) || "";
        obj1.wbsElement = obj?.WBSElement || "";
        obj1.created_By = obj?.Created_By || "";
        obj1.created_On = obj?.Created_On || new Date();
        obj1.updated_By = obj?.Updated_By || "";
        obj1.updated_On = obj?.Updated_On || new Date();
        obj1.fixedAsset = obj?.FixedAsset || "";
        obj1.tType = obj?.TType || "";
        obj1.description = obj?.Description || "";
        obj1.expenseDate = obj?.ExpenseDate || new Date();
        obj1.horizonId = obj?.HorizonId || "";
        obj1.department = obj?.Department || "";
        obj1.vendorCode = obj?.VendorCode || "";
        newData.push(obj1);
      }
      const glDefaultRow = {
        rowId: Math.random(),
        accountId: 0,
        invoice_Id: Invoice_id,
        glAccount: "",
        costCenter: "",
        accountType: "",
        amount: 0,
        costCenterOwner: "",
        stCode: "",
        order: "",
        profitCenter: "",
        wbsElement: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        fixedAsset: "",
        tType: "",
        description: "",
        expenseDate: "",
        horizonId: "",
        department: "",
        vendorCode: "",
      };
      if (res?.data?.glAccount.length === 0) {
        newData.push(glDefaultRow);
      }
      const isTaxAmt = isNaN(Number(finded?.salesTaxAmount));
      const clearingvendor = [];
      for (let i = 0; i < res?.data?.clearingVendorDetail?.length; i++) {
        let object = res?.data?.clearingVendorDetail[i];

        let vendorObj = {};
        vendorObj.vendor_Code = {
          Vendor_Code: object.VendorCode,
        };
        vendorObj.vendor_Name = object.vendor_Name;
        vendorObj.amount = Number(object.Amount);
        clearingvendor.push(vendorObj);
      }

      // const poData = res?.data?.poData || [];
      // const newItem = {};
      // for (const item of poData) {
      //    newItem = {
      //     ...item, // Copy all properties from the original item
      //     INPUT_QTY: parseInt(item.INPUT_QTY),
      //     INPUT_VAL: parseInt(item.INPUT_VAL),
      //   };
      // }
      if (role === "APS") {
        setFormState((formState) => ({
          ...formState,
          invoice_TaxDetails: res?.data?.vendorTaxDetail?.taxDetail || [],
          taxCard_List: res?.data?.vendorTaxDetail?.taxDetail || [],
          // invoicePORef_List: res?.data?.poData || [],
          invoicePORef_List: updatedPOData || [],
          invoice_Accounts: newData || [],
          invoice_Accounts_list: res?.data?.glAccount || [], // used at reviewer screen for gl_table.
          salesTaxAmount: isTaxAmt ? "" : finded?.salesTaxAmount || "",
          salesTaxCode: finded?.salesTaxCode || "",
          invoiceDebugData_List: res?.data?.debugData || [],
          invoice_Payment: invoice_Payment,
          invoice_Payment_Details: res?.data?.paymentDetail,
          fsDocumentDate: res.data?.invoice_Details[0]?.FSDocumentDate || "",
          fsDocumentNumber:
            res.data?.invoice_Details[0]?.FSDocumentNumber || "",
          vendor_Details: clearingvendor,
          // invoice_Payment: res?.data?.paymentDetail?.[0],

          // invoice_Accounts: res?.data?.glAccount, //for gl_table
        }));
      } else {
        setFormState((formState) => ({
          ...formState,
          // taxCard_List:  res?.data?.vendorTaxDetail?.taxDetail || [],
          // taxCard_ListCheck: res?.data?.vendorTaxDetail?.taxDetail || [],
          invoice_TaxDetails: res?.data?.vendorTaxDetail?.taxDetail || [],
          // invoicePORef_List: res?.data?.poData || [],
          invoicePORef_List: updatedPOData || [],
          invoice_Accounts: newData || [],
          invoice_Accounts_list:
            res?.data?.glAccount?.length > 0
              ? res?.data?.glAccount
              : [glDefaultRow], // used at reviewer screen for gl_table.
          salesTaxAmount: isTaxAmt ? "" : finded?.salesTaxAmount || "",
          salesTaxCode: finded?.salesTaxCode || "",
          invoiceDebugData_List: res?.data?.debugData || [],
          fsDocumentDate: res.data?.invoice_Details[0]?.FSDocumentDate || "",
          fsDocumentNumber:
            res.data?.invoice_Details[0]?.FSDocumentNumber || "",
          vendor_Details: clearingvendor,
          // invoice_Payment: res?.data?.paymentDetail?.[0],
          // invoice_Accounts: res?.data?.glAccount, //for gl_table
          // invoice_Details: res?.data?.invoice_Details[0] || [],
          // invoice_Payment: invoice_Payment,
        }));
        if (invoiceDetail.SkipTaxStep !== "True") {
          const tempObj = {
            category: "",
            purchaseType: "",
            supplierJurisdiction: "",
            supplierType: "",
            status: "",
            fillingStatus: "",
            goodsNature: "",
            taxType: "",
            taxCode: "",
            amount: invoiceDetail?.invoice_Amount,
          };
          setFormState((formState) => ({
            ...formState,
            taxCard_List: res?.data?.vendorTaxDetail?.taxDetail || [tempObj],
            taxCard_ListCheck: res?.data?.vendorTaxDetail?.taxDetail || [
              tempObj,
            ],
          }));
        }
      }

      setTaxFormState((taxFormState) => ({
        ...taxFormState,
        salesTaxCode: finded?.salesTaxCode || "",
        salesTaxAmount: finded?.salesTaxAmount || "",
        taxCard_List: res?.data?.vendorTaxDetail?.taxDetail || [],
        // additionalDocIds:res?.data?.additionalDocIds.split(" "),
        // comments:res?.data?.comments
      }));
      if (res?.data?.paymentDetail.length > 0) {
        setImportPaymentDetail((importPaymentDetail) => ({
          ...importPaymentDetail,
          invoice_Payment_Details: [...res?.data?.paymentDetail],
        }));
      }
      // setTaxFormState(res.data)
    })
    .catch((err) => {});
};
const getAllInvoiceDetailByInvoiceIdForDCReviewer = async (
  setFormState,
  setMultipleData,
  Invoice_id,
  setTaxFormState,
  setImportPaymentDetail,
  role,
  setDataLoading,
  setSelectedReviewerList , 
  setIsParallel
) => {
  const data = {
    InvoiceId: Invoice_id,
  };
  setDataLoading(true);
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/getAllInvoiceDataByInvoiceIdV2`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
  })
    .then(async (res) => {
      setDataLoading(false);
       // ✅ Map agreement_Detail to match emptyAgreementRow structure
      const mappedAgreementDetails = (res?.data?.agreement_Detail || [])?.map((item) => ({
  agreementStartDate: item.AgreementStartDate || "",
  agreementEndDate: item.AgreementEndDate || "",
  tenure: Number(item.Tenure) || 0,
  rentPerMonth: Number(item.RentPerMonth) || 0,
  totalPayment: Number(item.TotalPayment) || 0,
  annuallyIncrease: Number(item.AnnuallyIncrease) || 0,
  stampDuty: Number(item.StampDuty) || 0,
}));

      let invoice_Payment = {};
      if (res?.data?.paymentDetail?.length > 0) {
        invoice_Payment = res?.data?.paymentDetail[0];
        invoice_Payment.dueOn = new Date(invoice_Payment?.dueOn)
          ?.toISOString()
          .split("T")[0];
      }

      const updatedPOData = res?.data?.poData.map((item) => ({
        ...item,
        inpuT_QTY: Number(item.inpuT_QTY) || Number(item.INPUT_QTY),
        inpuT_VAL: Number(item.inpuT_VAL) || Number(item.INPUT_VAL),
      }));

      const uniqueReviewerList = [...new Set(res?.data?.reviewerList)];
      setSelectedReviewerList(uniqueReviewerList);
      setMultipleData((setMultipleData) => ({
        ...setMultipleData,
        glAccount: res?.data?.glAccount || [],
        paymentDetail: res?.data?.paymentDetail || [],
        // invoice_Payment: res?.data?.paymentDetail[0] || [],
        invoice_Payment: invoice_Payment || [],
        invoice_Details: res?.data?.invoice_Details[0] || [],
        efdv_Invoices: res?.data?.efdv_Invoices || [],
        // paymentMethod: res?.data?.paymentMethod || [],
        // paymentMethodSupp: res?.data?.paymentMethodSupp || [],
        // poData: res?.data?.poData || [],
        poData: updatedPOData || [],

        vendorTaxDetail: res?.data?.vendorTaxDetail || [],
      }));
      const finded = res?.data?.vendorTaxDetail?.vendorTax?.find(
        (x) => x.invoice_Id === Invoice_id
      );
      const newData = [];
      for (let i = 0; i < res?.data?.glAccount?.length; i++) {
        let obj = res?.data?.glAccount[i];
        let obj1 = {};

        obj1.rowId = Math.random();
        obj1.accountId = obj?.AccountId || 0;
        obj1.invoice_Id = obj?.Invoice_Id || 0;
        obj1.glAccount = obj?.GLAccount || "";
        obj1.costCenter = obj?.CostCenter;
        // obj1.costCenter = { CostCenterCode: obj?.CostCenter || "" };
        obj1.accountType = obj?.AccountType || "";
        obj1.amount = Number(obj?.Amount) || 0;
        obj1.costCenterOwner = obj?.CostCenterOwner || "";
        obj1.CostCenterOwnerName = obj?.CostCenterOwnerName || "";
        obj1.stCode = obj?.StCode || "";
        obj1.order = obj?.Order || "";
        obj1.profitCenter = Number(obj?.ProfitCenter) || "";
        obj1.wbsElement = obj?.WBSElement || "";
        obj1.created_By = obj?.Created_By || "";
        obj1.created_On = obj?.Created_On || new Date();
        obj1.updated_By = obj?.Updated_By || "";
        obj1.updated_On = obj?.Updated_On || new Date();
        obj1.fixedAsset = obj?.FixedAsset || "";
        obj1.tType = obj?.TType || "";
        obj1.description = obj?.Description || "";
        obj1.expenseDate = obj?.ExpenseDate || new Date();
        obj1.horizonId = obj?.HorizonId || "";
        obj1.department = obj?.Department || "";
        obj1.vendorCode = obj?.VendorCode || "";
        newData.push(obj1);
      }
      const isTaxAmt = isNaN(Number(finded?.salesTaxAmount));
      const clearingvendor = [];
      for (let i = 0; i < res?.data?.clearingVendorDetail?.length; i++) {
        let object = res?.data?.clearingVendorDetail[i];

        let vendorObj = {};
        vendorObj.vendor_Code = {
          Vendor_Code: object.vendorCode,
          Vendor_Name: "",
        };
        vendorObj.amount = Number(object.amount);
        clearingvendor.push(vendorObj);
      }
      // const poData = res?.data?.poData || [];
      // const newItem = {};
      // for (const item of poData) {
      //    newItem = {
      //     ...item, // Copy all properties from the original item
      //     INPUT_QTY: parseInt(item.INPUT_QTY),
      //     INPUT_VAL: parseInt(item.INPUT_VAL),
      //   };
      // }
      if (role === "APS") {
        setFormState((formState) => ({
          ...formState,
          invoice_TaxDetails: res?.data?.vendorTaxDetail?.taxDetail || [],
          taxCard_List: res?.data?.vendorTaxDetail?.taxDetail || [],
          // invoicePORef_List: res?.data?.poData || [],
          invoicePORef_List: updatedPOData || [],
          invoice_Accounts: newData || [],
          invoice_Accounts_list: res?.data?.glAccount || [], // used at reviewer screen for gl_table.
          Agreement_Details : mappedAgreementDetails || [],
          FCA_Details : res?.data?.fcaDetail || [],
          provinceDuty : res?.data?.provinceDuty || [],
 stamp_Duty_Calculations : res?.data?.stampDuty || [],
          salesTaxAmount: isTaxAmt ? "" : finded?.salesTaxAmount || "",
          salesTaxCode: finded?.salesTaxCode || "",
          invoiceDebugData_List: res?.data?.debugData || [],
          invoice_Payment: invoice_Payment,
          invoice_Payment_Details: res?.data?.paymentDetail,
          fsDocumentDate: res.data?.invoice_Details[0]?.FSDocumentDate || "",
          fsDocumentNumber:
            res.data?.invoice_Details[0]?.FSDocumentNumber || "",
          // invoice_Payment: res?.data?.paymentDetail?.[0],

          // invoice_Accounts: res?.data?.glAccount, //for gl_table
        }));
      } else {
        setFormState((formState) => ({
          ...formState,
          taxCard_List: res?.data?.vendorTaxDetail?.taxDetail || [],
          taxCard_ListCheck: res?.data?.vendorTaxDetail?.taxDetail || [],
          invoice_TaxDetails: res?.data?.vendorTaxDetail?.taxDetail || [],
          // invoicePORef_List: res?.data?.poData || [],
          invoicePORef_List: updatedPOData || [],
          invoice_Accounts: newData || [],
          invoice_Accounts_list: res?.data?.glAccount || [], // used at reviewer screen for gl_table.
            Agreement_Details : mappedAgreementDetails || [],
          FCA_Details : res?.data?.fcaDetail || [],
          provinceDuty : res?.data?.provinceDuty || [],
          stamp_Duty_Calculations : res?.data?.stampDuty || [],
          salesTaxAmount: isTaxAmt ? "" : finded?.salesTaxAmount || "",
          salesTaxCode: finded?.salesTaxCode || "",
          invoiceDebugData_List: res?.data?.debugData || [],
          fsDocumentDate: res.data?.invoice_Details[0]?.FSDocumentDate || "",
          fsDocumentNumber:
            res.data?.invoice_Details[0]?.FSDocumentNumber || "",
          vendor_Details: clearingvendor,

          // invoice_Payment: res?.data?.paymentDetail?.[0],
          // invoice_Accounts: res?.data?.glAccount, //for gl_table
          // invoice_Details: res?.data?.invoice_Details[0] || [],
          // invoice_Payment: invoice_Payment,
        }));
      }
      setIsParallel(res.data?.invoice_Details[0].isParallel === "True" ? "Parallel" : "Sequential") 

      setTaxFormState((taxFormState) => ({
        ...taxFormState,
        salesTaxCode: finded?.salesTaxCode || "",
        salesTaxAmount: finded?.salesTaxAmount || "",
        taxCard_List: res?.data?.vendorTaxDetail?.taxDetail || [],
        // additionalDocIds:res?.data?.additionalDocIds.split(" "),
        // comments:res?.data?.comments
      }));
      setImportPaymentDetail((importPaymentDetail) => ({
        ...importPaymentDetail,
        invoice_Payment_Details: [...res?.data?.paymentDetail],
      }));

      // setTaxFormState(res.data)
    })
    .catch((err) => {});
};
const getAllInvoiceDetailByInvoiceIdForImport = async (
  setFormState,
  setMultipleData,
  Invoice_id,
  setTaxFormState,
  setImportPaymentDetail,
  role
) => {
  const data = {
    InvoiceId: Invoice_id,
  };
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/getAllInvoiceDataByInvoiceIdV2`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
  })
    .then(async (res) => {
      setMultipleData((setMultipleData) => ({
        ...setMultipleData,
        glAccount: res?.data?.glAccount || [],
        paymentDetail: res?.data?.paymentDetail || [],
        invoice_Payment: res?.data?.paymentDetail[0] || [],
        invoice_Details: res?.data?.invoice_Details[0] || [],
        efdv_Invoices: res?.data?.efdv_Invoices || [],
        // paymentMethod: res?.data?.paymentMethod || [],
        // paymentMethodSupp: res?.data?.paymentMethodSupp || [],
        poData: res?.data?.poData || [],
        vendorTaxDetail: res?.data?.vendorTaxDetail || [],
      }));
      const finded = res?.data?.vendorTaxDetail?.vendorTax?.find(
        (x) => x.invoice_Id === Invoice_id
      );
      const newData = [];
      for (let i = 0; i < res?.data?.glAccount?.length; i++) {
        let obj = res?.data?.glAccount[i];
        let obj1 = {};

        obj1.rowId = Math.random();
        obj1.accountId = obj?.AccountId || 0;
        obj1.invoice_Id = obj?.Invoice_Id || 0;
        obj1.glAccount = obj?.GLAccount || "";
        obj1.costCenter = { CostCenterCode: obj?.CostCenter || "" };
        obj1.accountType = obj?.AccountType || "";
        obj1.amount = Number(obj?.Amount) || 0;
        obj1.costCenterOwner = obj?.CostCenterOwner || "";
        obj1.CostCenterOwnerName = obj?.CostCenterOwnerName || "";
        obj1.stCode = obj?.StCode || "";
        obj1.order = obj?.Order || "";
        obj1.profitCenter = Number(obj?.ProfitCenter) || "";
        obj1.wbsElement = obj?.WBSElement || "";
        obj1.created_By = obj?.Created_By || "";
        obj1.created_On = obj?.Created_On || new Date();
        obj1.updated_By = obj?.Updated_By || "";
        obj1.updated_On = obj?.Updated_On || new Date();
        obj1.fixedAsset = obj?.FixedAsset || "";
        obj1.tType = obj?.TType || "";
        obj1.description = obj?.Description || "";
        obj1.expenseDate = obj?.ExpenseDate || new Date();
        obj1.horizonId = obj?.HorizonId || "";
        obj1.department = obj?.Department || "";
        obj1.vendorCode = obj?.VendorCode || "";
        newData.push(obj1);
      }
      const isTaxAmt = isNaN(Number(finded?.salesTaxAmount));
      if (role === "APS") {
        setFormState((formState) => ({
          ...formState,
          invoice_TaxDetails: res?.data?.vendorTaxDetail?.taxDetail || [],
          invoicePORef_List: res?.data?.poData || [],
          invoice_Accounts: newData || [],
          invoice_Accounts_list: res?.data?.glAccount || [], // used at reviewer screen for gl_table.
          salesTaxAmount: isTaxAmt ? "" : finded?.salesTaxAmount || "",
          salesTaxCode: finded?.salesTaxCode || "",
          invoiceDebugData_List: res?.data?.debugData || [],
          invoice_Payment: res?.data?.paymentDetail?.[0],
          mpasEFDV: res.data?.invoice_Details[0]?.MpasEFDV === "True" ? true : false

          // invoice_Accounts: res?.data?.glAccount, //for gl_table
        }));
      } else {
        setFormState((formState) => ({
          ...formState,
          loamReviewer : res?.data?.reviewerList?.filter((item)=>item?.sortOrder == null)?.map((item)=>item?.id),
          taxCard_List: res?.data?.vendorTaxDetail?.taxDetail || [],
          invoice_TaxDetails: res?.data?.vendorTaxDetail?.taxDetail || [],
          // invoicePORef_List: res?.data?.poData || [],
          // invoice_Accounts: newData || [],
          invoice_Accounts_list: res?.data?.glAccount || [], // used at reviewer screen for gl_table.
          salesTaxAmount: isTaxAmt ? "" : finded?.salesTaxAmount || "",
          salesTaxCode: finded?.salesTaxCode || "",
          mpasEFDV: res.data?.invoice_Details[0]?.MpasEFDV === "True" ? true : false
          // invoiceDebugData_List: res?.data?.debugData || [],
          // invoice_Payment: res?.data?.paymentDetail?.[0],
          // invoice_Accounts: res?.data?.glAccount, //for gl_table
        }));
      }

      setTaxFormState((taxFormState) => ({
        ...taxFormState,
        salesTaxCode: finded?.salesTaxCode || "",
        salesTaxAmount: finded?.salesTaxAmount || "",
        taxCard_List: res?.data?.vendorTaxDetail?.taxDetail || [],
        // additionalDocIds:res?.data?.additionalDocIds.split(" "),
        // comments:res?.data?.comments
      }));
      setImportPaymentDetail((importPaymentDetail) => ({
        ...importPaymentDetail,
        invoice_Payment_Details: [...res?.data?.paymentDetail],
      }));

      // setTaxFormState(res.data)
    })
    .catch((err) => {});
};

const calculateTax = async (
  taxCode,
  currency,
  grossAmount,
  setFormState,
  setTaxCalculateLoading
) => {
  const data = {
    taxCode,
    currency,
    grossAmount,
  };
  setTaxCalculateLoading(true);
  await axios({
    method: "post", //you can set what request you want
    url: `${process.env.REACT_APP_API_URL}/sap-endpoint/calculate-tax`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  })
    .then(async (res) => {
      const isTaxAmt = isNaN(Number(res?.data));
      setFormState((formState) => ({
        ...formState,
        salesTaxAmount: isTaxAmt
          ? "0"
          : res?.data === (0.0 || 0)
          ? "0"
          : res?.data,
      }));
      setTaxCalculateLoading(false);
    })
    .catch((err) => {
      setTaxCalculateLoading(false);
    });
};

const getRefrenceDataList = async (
  refKey,
  name,
  setFormState,
  setMultipleData
) => {
  const data = {
    refKey,
  };
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetRefrenceDatList_v1`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
  })
    .then(async (res) => {
      setMultipleData((pre) => ({
        ...pre,
        [name]: res.data,
      }));
      if (
        name !== "paymentMethod" &&
        name !== "paymentMethSupp" &&
        name !== "paymentTerms"
      ) {
        setFormState((formState) => ({
          ...formState,
          invoice_Payment: {
            ...formState.invoice_Payment,
            [name]: res?.data?.[0]?.ReferenceCode,
          },
        }));
      }
    })
    .catch((err) => {});
};
export const getAllRefrenceDataList = async (refrenceList) => {
  const data = {
    refKey:
      "invoiceType,DocumentType,PaymentTerm,postingKey,sglInd,tType,PaymentMethod,PaymentMethodSupp,Currency",
  };
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetRefrenceDatList_v1`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
  })
    .then(async (res) => {
      function categorizeByReferenceKey(data) {
        const categorized = {};

        data.forEach((item) => {
          const referenceKey = item.ReferenceKey;

          if (!categorized[referenceKey]) {
            categorized[referenceKey] = [];
          }

          categorized[referenceKey].push(item);
        });

        return categorized;
      }
      const data = categorizeByReferenceKey(res.data);
      refrenceList.invoice_Type = data.InvoiceType;
      refrenceList.document_Type = data.DocumentType;
      refrenceList.paymentTerms = data.PaymentTerm;
      refrenceList.postingKey = data.PostingKey;
      refrenceList.sglInd = data.SGLInd;
      refrenceList.tType = data.TType;
      refrenceList.paymentMethod = data.PaymentMethod;
      refrenceList.paymentMethSupp = data.PaymentMethodSupp;
      refrenceList.currency = data.Currency;
    })
    .catch((err) => {
      console.log(err);
    });
};

const getImportPoData = async (
  po_value,
  Invoice_id,
  setFormState,
  setPo_Loading
) => {
  const data = {
    po_no: po_value,
  };
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/sap-endpoint/GetImportPOData`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
  })
    .then(async (res) => {
      //
      let newData = [];
      if (res?.data?.Message) {
      } else {
        var result = JSON.parse(res?.data);
        for (let index = 0; index < result.length; index++) {
          const item = result[index];
          const inpuT_QTY_1 = Number(item?.Quantity) - Number(item.INVOICE_QTY);
          const inpuT_VAL_1 =
            Number(item?.Val_Loccur) - Number(item.INVOICE_VAL);
          const obj = {
            po_Ref_Id: 0,
            assetNumber: item.AssetNumber,
            balancE_QTY: item.BALANCE_QTY,
            balancE_VAL: item.BALANCE_VAL,
            conD_COUNT: item.COND_COUNT,
            conD_ST_NO: item.COND_ST_NO,
            currency: item.Currency,
            disT_IND: item.DIST_IND,
            dN_NO: item.DN_NO,
            doc_Date: item.DOC_DATE,
            doC_YEAR: item.DOC_YEAR,
            delivUnit: item.DelivUnit,
            // Dlvqty: item.Dlvqty,
            invoicE_QTY: item.INVOICE_QTY,
            invoicE_VAL: item.INVOICE_VAL,
            kschl: item.KSCHL,
            ordeR_QTY: item.ORDER_QTY,
            ordeR_UNIT: item.ORDER_UNIT,
            poItem: item.POItem,
            poItemText: item.POItemText,
            poNumber: item.PONumber,
            plant: item.Plant,
            uniT_PRICE : item.UNIT_PRICE, 
            Poqty: item.Poqty,
            quantity: item.Quantity,
            refDoc: item.RefDoc,
            reF_DOC_IT: item.RefDocIT,
            reF_DOC_NO: item.RefDocNo,
            reF_DOC_NO_LONG: item.RefDocNoLong,
            seQ_NO: item.SEQ_NO,
            sheeT_ITEM: item.SHEET_ITEM,
            SHEET_NO: item.SHEET_NO,
            sO_ITEM: item.SO_ITEM,
            sO_NO: item.SO_NO,
            vText: item.VText,
            Val_Gr_Loc: item.Val_Gr_Loc,
            Val_Iv_Loc: item.Val_Iv_Loc,
            val_Loccur: item.Val_Loccur,
            Vendor_Code: item.Vendor_Code,
            doc_Date: item.DOC_DATE,
            Vendor_Name: item.Vendor_Name,
            invoice_Id: Invoice_id,
            created_by: "",
            created_on: new Date(),
            // inpuT_QTY: inpuT_QTY_1.toString(),
            // inpuT_VAL: inpuT_VAL_1.toString(),
            available_QTY: inpuT_QTY_1,
            available_VAL: inpuT_VAL_1,
            inpuT_QTY: 0,
            inpuT_VAL: 0,
          };
          newData.push(obj);
        }
        setFormState((formState) => ({
          ...formState,
          invoicePORef_List: newData,
        }));
      }
    })
    .catch((err) => {});
};

const getTaxUserForNonPo = async (invoicetype, setTaxuser, setFormState) => {
  // const data =  {
  //   invoiceType : invoicetype,
  // }

  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/InvoiceTypeWiseUser/GetUsersByInvoiceType/${invoicetype}`,
    // url: `http://i2p-sfg.genial365.com/api/InvoiceTypeWiseUser/GetUsersByInvoiceType/${invoicetype}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    // params: data,
  })
    .then(async (res) => {
      setFormState((formState) => ({
        ...formState,
        taxTeam: res.data[0]?.id,
      }));
      setTaxuser(res.data);
    })
    .catch((err) => {});
};

const deleteAttachment = (
  setFormState,
  setAttachmentURLList,
  setOpenWarningBox,
  formState,
  attachmentURLList,
  attachment,
  setdeleteLoader
) => {
  const data = {
    Id: attachment?.id,
  };
  setdeleteLoader(true);
  var config = {
    method: "delete",
    url: `${process.env.REACT_APP_API_URL}/api/UploadFile/DeleteAttachment`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
    },
    params: data,
  };
  axios(config).then(function (response) {
    setdeleteLoader(false);
    const final = attachmentURLList?.filter(
      (x) => x?.path !== attachment?.path
    );
    setAttachmentURLList(final);
    const files = formState.additionalDocIds.filter(
      (x, i) => x.path !== attachment?.path
    );
    setFormState((formState) => ({
      ...formState,
      additionalDocIds: files,
    }));
    setOpenWarningBox(false);
  });
};
const getg_laccount = async (
  account,
  setLoading,
  setGl_account,
  setGl_accountLoading
) => {
  setLoading(true);
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetChargeAccount_v1/${
      account ? account : -1
    }`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      setLoading(false);
      setGl_account(res.data);
      setGl_accountLoading(res.data);
    })
    .catch((err) => {
      setLoading(false);
    });
};
const getg_laccountForExcel = async (
  account,
  setLoading,
  setGl_account,
  setGlAccountLoading
) => {
  const GLCode = localStorage.getItem("getGLCode");
  setGlAccountLoading(true);
  if (!GLCode) {
    setLoading(true);
    await axios({
      method: "get", //you can set what request you want to be
      url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetChargeAccount_v1/${
        account ? account : -1
      }`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        setLoading(false);
        localStorage.setItem("getGLCode", JSON.stringify(res.data));
        setGl_account(res.data);
        setGlAccountLoading(false);
      })
      .catch((err) => {
        setGlAccountLoading(false);
        setLoading(false);
      });
  } else {
    const data = JSON.parse(GLCode);
    setGl_account(data);
    setGlAccountLoading(false);
    setLoading(false);
  }
};
const getg_laccount_Search = async (account, setLoading, setChoices) => {
  setLoading(true);

  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetChargeAccount_v1/${
      account ? account : "-1"
    }`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      // setGl_account(res.data);
      const updatedChoices = res.data?.map((account) => ({
        data: account,
        value: `${account.GLAccount}`,
        label: `${account.GLAccount} - ${account.ShortText}`,
      }));
      if (typeof setChoices === "function") {
        setChoices(updatedChoices);
      } else {
        const finded = res.data?.find((x) => x.GLAccount === account);
        setChoices.Vendor = finded;
      }
      // setGl_account(updatedChoices)

      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);

      // setErrorMessage("Invalid username or password");
    });
};
const getg_laccountForCopyPast = async (
  formState,
  operation,
  data,
  invoice_Payment_Details,
  importPaymentDetail,
  setImportPaymentDetail,
  setFormState,
  setGlAccountLoading,
  setGlAccount
) => {
  // const fromindex = operation[0]?.fromRowIndex;
  const requestData = data.map((item) => item.glAccount);
  setGlAccountLoading(true);

  await axios({
    method: "post", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetChargeAccountList`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    data: requestData,
  })
    .then(async (res) => {
      setGlAccountLoading(false);
      const PasteData = res.data.map((entry) => JSON.parse(entry.Result));
      const flatPasteData = PasteData?.flat();
      setGlAccount(flatPasteData);

      const tempArray = formState.invoice_Accounts;
      let pasteDataIndex = 0;
      let newpaymentDetails = importPaymentDetail?.invoice_Payment_Details;
      // for update

      const toIndex = operation?.[1]?.toRowIndex
        ? operation?.[1]?.toRowIndex
        : operation?.[0]?.toRowIndex;
      if (operation[0]?.type) {
        for (
          let index = operation?.[0].fromRowIndex;
          index < toIndex;
          index++
        ) {
          const randomNum = Math.random();
          const findedPayDetail = newpaymentDetails.find(
            (x) =>
              x?.rowId === (formState.invoice_Accounts?.[index]?.rowId || "")
          );

          //  add payment detail for update.
          if (findedPayDetail) {
            const findedPayDetailIndex = newpaymentDetails.findIndex(
              (x) => x?.rowId === formState.invoice_Accounts?.[index]?.rowId
            );
            newpaymentDetails[findedPayDetailIndex].account =
              flatPasteData[pasteDataIndex]?.GLAccount;
            newpaymentDetails[findedPayDetailIndex].accountName =
              flatPasteData[pasteDataIndex]?.ShortText;
          } else {
            // new payment detail for create.
            if (
              (formState?.isImport && !formState?.pO_Based) ||
              (formState?.isVPPayment && !formState?.pO_Based) ||
              !formState?.pO_Based
            ) {
              const stringify = JSON.stringify(invoice_Payment_Details);
              const parseinvoice_Payment_Details = JSON.parse(stringify);
              parseinvoice_Payment_Details.rowId = randomNum;
              parseinvoice_Payment_Details.account =
                flatPasteData[pasteDataIndex]?.GLAccount;
              parseinvoice_Payment_Details.accountName =
                flatPasteData[pasteDataIndex]?.ShortText;
              parseinvoice_Payment_Details.amount = 0;
              newpaymentDetails.push(parseinvoice_Payment_Details);
            }
          }

          tempArray[index] = {
            ...formState.invoice_Accounts[index],
            glAccount: flatPasteData[pasteDataIndex].GLAccount,
            amount: formState.invoice_Accounts?.[index]?.amount || 0,
            rowId: formState.invoice_Accounts?.[index]?.rowId || randomNum,
          };
          pasteDataIndex++;
        }
      }

      setImportPaymentDetail((importPaymentDetail) => ({
        ...importPaymentDetail,
        invoice_Payment_Details: newpaymentDetails,
      }));

      setFormState((formState) => ({
        ...formState,
        invoice_Accounts: tempArray,
      }));
    })
    .catch((err) => {
      setGlAccountLoading(false);
      console.log(err);
    });
};
const getCostCenterForCopyPast = async (
  formState,
  operation,
  data,
  invoice_Payment_Details,
  importPaymentDetail,
  setImportPaymentDetail,
  setFormState,
  setCostCenterLoading,
  setCostCenterList
) => {
  const requestData = data.map((item) => item.costCenter);
  setCostCenterLoading(true);

  await axios({
    method: "post", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetCostCentersList`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    data: requestData,
  })
    .then(async (res) => {
      setCostCenterLoading(false);
      const PasteData = res.data.map((entry) => JSON.parse(entry.Result));
      const flatPasteData = PasteData?.flat();
      setCostCenterList(flatPasteData);

      const tempArray = formState.invoice_Accounts;
      let pasteDataIndex = 0;
      let newpaymentDetails = importPaymentDetail?.invoice_Payment_Details;
      // for update

      const toIndex = operation?.[1]?.toRowIndex
        ? operation?.[1]?.toRowIndex
        : operation?.[0]?.toRowIndex;
      if (operation[0]?.type) {
        for (
          let index = operation?.[0].fromRowIndex;
          index < toIndex;
          index++
        ) {
          const randomNum = Math.random();
          const findedPayDetail = newpaymentDetails.find(
            (x) =>
              x?.rowId === (formState.invoice_Accounts?.[index]?.rowId || "")
          );

          //  add payment detail for update.
          if (findedPayDetail) {
            const findedPayDetailIndex = newpaymentDetails.findIndex(
              (x) => x?.rowId === formState.invoice_Accounts?.[index]?.rowId
            );
            newpaymentDetails[findedPayDetailIndex].costCenter =
              flatPasteData[pasteDataIndex]?.CostCenterCode;
            newpaymentDetails[findedPayDetailIndex].costCenterOwner =
              flatPasteData[pasteDataIndex]?.Owner;
            newpaymentDetails[findedPayDetailIndex].CostCenterOwnerName =
              flatPasteData[pasteDataIndex]?.CC_OwnerName;
          } else {
            // new payment detail for create.
            if (
              (formState?.isImport && !formState?.pO_Based) ||
              (formState?.isVPPayment && !formState?.pO_Based) ||
              !formState?.pO_Based
            ) {
              const stringify = JSON.stringify(invoice_Payment_Details);
              const parseinvoice_Payment_Details = JSON.parse(stringify);
              parseinvoice_Payment_Details.rowId = randomNum;
              parseinvoice_Payment_Details.costCenter =
                flatPasteData[pasteDataIndex]?.CostCenterCode;
              parseinvoice_Payment_Details.costCenterOwner =
                flatPasteData[pasteDataIndex]?.Owner;
              parseinvoice_Payment_Details.amount = 0;

              newpaymentDetails.push(parseinvoice_Payment_Details);
            }
          }

          tempArray[index] = {
            ...formState.invoice_Accounts[index],
            costCenter: flatPasteData[pasteDataIndex].CostCenterCode,
            costCenterOwner: flatPasteData[pasteDataIndex].Owner,
            CostCenterOwnerName: flatPasteData[pasteDataIndex].CC_OwnerName,
            amount: formState.invoice_Accounts?.[index]?.amount || 0,
            rowId: formState.invoice_Accounts?.[index]?.rowId || randomNum,
          };
          data[index].costCenterOwner = flatPasteData[pasteDataIndex].Owner;
          data[index].CostCenterOwnerName =
            flatPasteData[pasteDataIndex].CC_OwnerName;
          pasteDataIndex++;
        }
      }

      setImportPaymentDetail((importPaymentDetail) => ({
        ...importPaymentDetail,
        invoice_Payment_Details: newpaymentDetails,
      }));

      setFormState((formState) => ({
        ...formState,
        invoice_Accounts: tempArray,
      }));
    })
    .catch((err) => {
      setCostCenterLoading(false);
    });
};
const getLoamApprover = async (
  invoice_Type,
  invoice_Amount,
  setLoamUser,
  setLoamLoading,
  additionalUsers
) => {
  // setLoamLoading(true);
  if (invoice_Type) {
    let payload = [
      {
        invoice_type: invoice_Type || "",
        invoice_amount: invoice_Amount ? invoice_Amount?.toString() : "0",
      },
    ];

    await axios({
      method: "post", //you can set what request you want to be
      url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetApprovers`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
      // data: formState,
      data: payload,
    })
      .then(async (res) => {
        if (res?.data[0]?.Error) {
          // Handle the case when the API response contains an error message
          console.error(res.data[0].Error);

          // setLoamUser(additionalUsers);
          setLoamUser([]);
        }
        // Combine the API response data with the additional list of users
        // const combinedUsers = [...res.data, ...additionalUsers];
        const combinedUsers = res?.data;

        // const uniqueUsersMap = {};

        //  filter out duplicates
        // combinedUsers.forEach((user) => {
        //   const key = `${user?.CareerLadder}-${user?.Name}`;
        //   uniqueUsersMap[key] = user;
        // });

        // // Extract unique users from the map and convert them back to an array
        // const uniqueUsers = Object.values(uniqueUsersMap);

        setLoamUser(combinedUsers);

        setLoamLoading(false);
      })
      .catch((err) => {
        setLoamLoading(false);
      });
  }
};
const getMethodForPageRefresh = (
  invoiceId,
  status,
  setAllowToProceed,
  setPageLoader
) => {
  var axios = require("axios");
  setPageLoader(true);
  var config = {
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetInvoiceStatus/${invoiceId}/${status}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
    },
  };
  axios(config)
    .then(function (response) {
      setAllowToProceed(response.data);
      setPageLoader(false);
    })

    .catch(function (error) {
      setPageLoader(false);
    });
};

const getVendorAdvance = (vendorCode, setVendorAdvance , setPageLoader , advanceDocNo , SPGL) =>{
   var axios = require("axios");
   const vendorAdvance =[]
 setPageLoader(true);
  var config = {
    method: "post",
    url: `${process.env.REACT_APP_API_URL}/sap-endpoint/GetVendorAdvances`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
    },
    params:{
      vendorCode:vendorCode?.Vendor_Code||vendorCode,
      SPGL: "A"
    }
  };
  axios(config)
    .then(function (response) {

      const data = response.data?.vendorAdvanceLineItems || [];
    if (advanceDocNo === undefined) {
  // Case: undefined → set all data
  setVendorAdvance(data);
} else if (advanceDocNo === "") {
  // Case: empty string → set empty array
  setVendorAdvance(data);
} else {
  // Case: has value → filter
  const filtered = data.filter((item) => item.doC_NO === advanceDocNo);
  setVendorAdvance(filtered.length > 0 ? filtered : []);
}
      
        // setVendorAdvance(response.data?.vendorAdvanceLineItems || []);
        setPageLoader(false);
      
    })

    

    .catch(function (error) {

setPageLoader(false);

    });
}

const getCustomerCode = async (user, setUserData, setLoading) => {
  setLoading(true);
  //
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getDistributor${user ? `/${user}` : ""}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  
  })
    .then(async (res) => {
      setUserData(res.data);
      setLoading(false);
    })
    .catch((err) => {
    //   const data =


    //   [
    //     {
    //         Bank_Key: "1APR-HBL001",
    //         Vendor_Code: "0001005482",
    //         Vendor_Name: "Ecolean Pakistan (Pvt) Ltd",
    //         CO_POST_BLOCK: "",
    //         ALL_COMPANY_CODE: "",
    //         Payment_Terms: "V004"
    //     }
    // ]

    // setUserData(data);
      setLoading(false);

      // setErrorMessage("Invalid username or password");
    });
};



const getDistributorData= (setFormState , formState) =>{
  
  const dummyDistributorData = [
  {
    cusT_NO: "0070002179",
    cusT_NAME1: "Khan Brothers - DD",
    cusT_NAME2: "",
    doC_NO: "1200036699",
    fiS_YEAR: "2025",
    doC_TYPE: "AB",
    posT_DATE: "2025-08-05T00:00:00",
    doC_DATE: "2025-08-05T00:00:00",
    sP_GL: "",
    amT_LC: 75000.0,
    currency: "PKR",
    paY_TERM: "",
    amT_DC: 75000.0,
    excH_RATE: 0.0,
    basE_DATE: "2025-08-05T00:00:00",
    reF_NO: "CUSTOMER PAYMENT",
    itM_TEXT: "CUSTOMER PAYMENT",
    hdR_TEXT: "CUSTOME PAYMENT",
    usR_NAME: "ABAPDEV",
  },
  {
    cusT_NO: "0070002179",
    cusT_NAME1: "Khan Brothers - DD",
    cusT_NAME2: "",
    doC_NO: "1200036701",
    fiS_YEAR: "2025",
    doC_TYPE: "AB",
    posT_DATE: "2025-08-05T00:00:00",
    doC_DATE: "2025-08-05T00:00:00",
    sP_GL: "",
    amT_LC: 75000.0,
    currency: "PKR",
    paY_TERM: "",
    amT_DC: 75000.0,
    excH_RATE: 0.0,
    basE_DATE: "2025-08-05T00:00:00",
    reF_NO: "CUSTOMER PAYMENT",
    itM_TEXT: "CUSTOMER PAYMENT",
    hdR_TEXT: "CUSTOME PAYMENT",
    usR_NAME: "ABAPDEV",
  },
  {
    cusT_NO: "0070002179",
    cusT_NAME1: "Khan Brothers - DD",
    cusT_NAME2: "",
    doC_NO: "5700001061",
    fiS_YEAR: "2025",
    doC_TYPE: "DG",
    posT_DATE: "2025-08-05T00:00:00",
    doC_DATE: "2025-08-05T00:00:00",
    sP_GL: "",
    amT_LC: 75000.0,
    currency: "PKR",
    paY_TERM: "",
    amT_DC: 75000.0,
    excH_RATE: 0.0,
    basE_DATE: "2025-08-05T00:00:00",
    reF_NO: "",
    itM_TEXT: "",
    hdR_TEXT: "dummy23",
    usR_NAME: "SN_FICO2",
  },
];

const newInvoiceAccounts = dummyDistributorData.map((item) => ({
    rowId: Math.random(),
    accountId: 0,
    invoice_Id: 0,
    glAccount: undefined,
    accountType: "Debit",
    costCenter: "",
    costCenterOwner: "",
    costCenterOwnerName: "",
    wbsElement: "",
    horizonId: "",
    vendor_Code: formState?.vendor_Code?.Vendor_Code ? formState.vendor_Code?.Vendor_Code + " - "  + formState?.vendor_Code?.Vendor_Name  : "", 
    profitCenter: "",
    department: "",
    description: "",
    customerAccountNo: item?.cusT_NO || "",
    fsDocNo: item?.doC_NO || "",
    fsDocDate: item?.doC_DATE ? item.doC_DATE.split("T")[0] : "",
    amount : item?.amT_LC || 0,
  }));

const updatedData = dummyDistributorData?.map((item)=>{
  return {
    selected: true,
    distributorNumbers : item?.cusT_NO || "",
    distributorName : item?.cusT_NAME1 || "",
    amount : item?.amT_DC || 0,
    years : item?.fiS_YEAR || "",
  }
})
  
  var config = {
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/sap-endpoint/GetCustomerOpenItem`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
    },
      params: {
    customerNo: formState?.distributor_Code, // query parameter
  },
  };
  axios(config)
    .then(function (response) {
const distributorData= response?.data?.items?.map((item) => ({
    rowId: Math?.random(),
    accountId: 0,
    invoice_Id: 0,
    glAccount: undefined,
    accountType: "Debit",
    costCenter: "",
    costCenterOwner: "",
    costCenterOwnerName: "",
    wbsElement: "",
    horizonId: "",
    vendor_Code: formState?.vendor_Code?.Vendor_Code ? formState?.vendor_Code?.Vendor_Code + " - "  + formState?.vendor_Code?.Vendor_Name  : "", 
    profitCenter: "",
    department: "",
    description: "",
    customerAccountNo: item?.cusT_NO || "",
    fsDocNo: item?.doC_NO || "",
    fsDocDate: item?.doC_DATE ? item?.doC_DATE?.split("T")[0] : "",
    amount : item?.amT_LC || 0,
  }));

   setFormState({
  ...formState,
  invoice_Accounts_list: distributorData, // replace instead of append
});
    })

    .catch(function (error) {
  //  setFormState(prev => ({
  //   ...prev,
  //   invoice_Accounts_list: newInvoiceAccounts, // replace instead of append
  // }));
      // setPageLoader(false);
    });
}




const getRTBLineItemsData= (setFormState , formState) =>{
  // const rtbId = formState?.rtbId || null;
  const rtbId = formState?.rtbId
  const VendorCode = formState?.vendor_Code?.Vendor_Code || "";
  
 
  var config = {
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetRTBLineItems?RTBId=${rtbId}&VendorCode=${VendorCode}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
    },
     
  };
  axios(config)
    .then(function (response) {   
setFormState((prev)=>({
  ...prev,
  rtbLineItems_List : response?.data,
}))
    })

    .catch(function (error) {

    });
}
const getDuplicateInvoiceCheck  = async(
  vendorCode ,
  invoiceNumber,
  setIsDuplicateInvoice,
  setOpenDuplicateCheckWarning,
  setLoading
) =>{

  await axios({
    method: "Post", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/sap-endpoint/check-duplicate-invoice?Vendor_Code=${vendorCode}&Invoice_No=${invoiceNumber}&Currency=""`,

})
    .then(async (res) => {
         if(res.data === "No Duplicate Found"){     
        setLoading(false)
      }
      else {
        setIsDuplicateInvoice(res.data );
        setOpenDuplicateCheckWarning(true)
        setLoading(false)
      }
      return
    })
    .catch((err) => {    
      setLoading(false)
          return false;
    });
  }



export {
  getAllUsers,
  getUsersByRole,
  getUsersByIRIPRole , 
  getAllUsersByRole,
  getVendorDetail,
  getHorizonID_Data,
  getCostCenterData,
  getCostCenterData_v2,
  getCostCenterDataForExcel,
  getEmployeeByCostCenter,
  getEmployeeByCostCenter_IP,
  uploadFile,
  uploadFile_v1,
  uploadAdditioalDocumentFile,
  getVendorByPO,
  getPODetails,
  getPODetailsForBuyer,
  getDNDetails,
  getDN_ITN_Details,
  createNewInvoice,
  submit_APSInvoice,
  putDeptCoordinatorAndReviewerInvoice,
  LoamPutInvoice,
  updateInvoiceByTaxTeam,
  updateIR,
  createInvoiceByIR,
  updateIPInvoice,
  updateLogisticsInvoice,
  updateIPInvoiceByImport,
  getCommentsByInvoiceId,
  getCommentsByERFInvoiceNo,
  getCommentsByARFInvoiceNo,
  clearState,
  getInvoiceByInvoiceIdAndRoleId,
  getTaxCode,
  getTaxCodeWithBlock,
  getTaxCodeWithDuplicate,
  getTaxCard,
  getTaxCardV2,
  vendorTaxDetail,
  vendorTaxDetailForCnic,
  getAllInvoiceDetailByInvoiceId,
  getAllInvoiceDetailByInvoiceIdForDCReviewer,
  getAllInvoiceDetailByInvoiceIdForImport,
  changeInvoiceStatus,
  ChangeInvoiceStatus_V1,
  calculateTax,
  getRefrenceDataList,
  getImportPoData,
  createNewInvoiceByEFDV,
  updateBuyerInvoice,
  getAllNotifications,
  getTaxCodeByTaxCardId,
  getTaxCodeByTaxCardIdForIP,
  getTaxCodeByTaxCardIdByDefault,
  getWHTCodeByTaxType,
  getTaxUserForNonPo,
  deleteAttachment,
  getVendorDetailForVendorBlock,
  getVendorDetailForTable,
  getVendorByPOForBlock,
  putLM_SSM_DHR,
  getWHTCodeByTaxCode,
  getBatchInvoiceDetails,
  getg_laccount,
  getg_laccount_Search,
  getg_laccountForExcel,
  getg_laccountForCopyPast,
  getCostCenterForCopyPast,
  getLoamApprover,
  getVendorForPaymentMethod,
  getMethodForPageRefresh,
  updateLoamReviewer,
  getVendorAdvance,
  getCustomerCode ,
  getDistributorData,
  // getRTBLineItemsData,
  getDuplicateInvoiceCheck

};
